(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["dasa-icons"] = {}, global.React));
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function SvgAdd$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17 13h-4v4a1 1 0 11-2 0v-4H7a1 1 0 110-2h4V7a1 1 0 112 0v4h4a1 1 0 110 2z"
    }));
  }

  var ForwardRef$3M = /*#__PURE__*/React__namespace.forwardRef(SvgAdd$2);

  function SvgAgConsulta$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M9 3.692a.692.692 0 00-1.385 0v1.154H5.203C4 4.846 3 5.804 3 7.016V18.83C3 20.042 4 21 5.203 21h3.89a.692.692 0 100-1.385h-3.89a.803.803 0 01-.818-.786v-7.983h15.23V13.1a.692.692 0 101.385 0V7.017c0-1.213-1-2.17-2.203-2.17h-2.412V3.691a.692.692 0 10-1.385 0v1.154H9V3.692zM5.203 6.231h2.412v.23a.692.692 0 001.385 0v-.23h6v.23a.692.692 0 001.385 0v-.23h2.412c.466 0 .818.366.818.786v2.445H4.385V7.017c0-.42.352-.786.818-.786zM12.063 21C11.2 21 11 20.817 11 19.94v-4.243c0-.877.2-1.06 1.063-1.06h4.25c1.361 0 1.562.183 1.562 1.59v3.712c0 .878-.2 1.061-1.063 1.061h-4.75zm8.033-.9a.606.606 0 00.477.034.624.624 0 00.362-.32.65.65 0 00.065-.283v-3.425c0-.17-.065-.33-.183-.45a.614.614 0 00-.722-.119l-1.422.724a.317.317 0 00-.168.23l-.005.001V19.144l.005.002a.317.317 0 00.168.23l1.423.724z"
    }));
  }

  var ForwardRef$3L = /*#__PURE__*/React__namespace.forwardRef(SvgAgConsulta$1);

  function SvgAgExams$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M9 3.692a.692.692 0 00-1.385 0v1.154H5.203C4 4.846 3 5.804 3 7.016V18.83C3 20.042 4 21 5.203 21h5.55a.692.692 0 100-1.385h-5.55a.803.803 0 01-.818-.786v-7.983h15.23v3.914a.692.692 0 101.385 0V7.017c0-1.213-1-2.17-2.203-2.17h-2.412V3.691a.692.692 0 10-1.385 0v1.154H9V3.692zM5.203 6.231h2.412v.23a.692.692 0 001.385 0v-.23h6v.23a.692.692 0 001.385 0v-.23h2.412c.466 0 .818.366.818.786v2.445H4.385V7.017c0-.42.352-.786.818-.786zM17.38 16.486l1.454 2.768a1.241 1.241 0 01.047 1.152 1.08 1.08 0 01-.366.433.918.918 0 01-.512.161h-4.005a.919.919 0 01-.518-.164 1.084 1.084 0 01-.367-.442 1.245 1.245 0 01.067-1.164l1.441-2.744a.413.413 0 00.047-.19v-3.358a.2.2 0 00-.05-.133.158.158 0 00-.117-.055h-.5a.316.316 0 01-.236-.11.4.4 0 01-.097-.265.4.4 0 01.097-.265.316.316 0 01.236-.11h4c.088 0 .173.04.235.11a.4.4 0 01.098.265.4.4 0 01-.098.265.316.316 0 01-.235.11h-.5a.158.158 0 00-.118.055.2.2 0 00-.049.133v3.357a.41.41 0 00.046.19zm-2.572 1.489a.152.152 0 00.084.025h2.218c.03 0 .058-.009.083-.025a.18.18 0 00.061-.07.207.207 0 000-.188l-.54-1.026a.411.411 0 01-.046-.191v-.281a.2.2 0 00-.05-.133.158.158 0 00-.117-.055h-.44a.237.237 0 01-.177-.082.3.3 0 01-.073-.199.3.3 0 01.073-.199.237.237 0 01.177-.082h.44c.044 0 .086-.02.118-.055a.2.2 0 00.049-.133v-.375a.2.2 0 00-.05-.132.158.158 0 00-.117-.055h-.44a.237.237 0 01-.177-.083.3.3 0 01-.073-.198.3.3 0 01.073-.2.237.237 0 01.177-.082h.44c.044 0 .086-.02.118-.055a.2.2 0 00.049-.132v-1.031a.2.2 0 00-.05-.133.158.158 0 00-.117-.055h-1a.158.158 0 00-.118.055.2.2 0 00-.049.133V16.5a.417.417 0 01-.046.19l-.54 1.027a.206.206 0 000 .188.18.18 0 00.06.07zm.077 2.113a.462.462 0 00.278.095c.133 0 .26-.059.354-.165a.614.614 0 00.062-.71.517.517 0 00-.225-.207.449.449 0 00-.289-.032.486.486 0 00-.256.154.588.588 0 00-.136.288c-.02.11-.01.222.028.325.038.103.102.19.184.253zm1.499-1.1a.301.301 0 00.313.035.332.332 0 00.108-.081.38.38 0 00.072-.122.417.417 0 00-.03-.352.346.346 0 00-.15-.138.299.299 0 00-.193-.02.323.323 0 00-.17.102.392.392 0 00-.092.192.419.419 0 00.02.216.369.369 0 00.122.169zm.833 1.156c.055.042.12.064.186.064H17.4a.3.3 0 00.128-.028.333.333 0 00.109-.081.383.383 0 00.072-.122.418.418 0 00-.03-.353.345.345 0 00-.15-.138.3.3 0 00-.193-.021.324.324 0 00-.17.102.417.417 0 00-.072.409.368.368 0 00.122.168z"
    }));
  }

  var ForwardRef$3K = /*#__PURE__*/React__namespace.forwardRef(SvgAgExams$2);

  function SvgApp$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5 3.25A1.75 1.75 0 003.25 5v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0010.75 9V5A1.75 1.75 0 009 3.25H5zM4.75 5A.25.25 0 015 4.75h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25H5A.25.25 0 014.75 9V5zM15 3.25A1.75 1.75 0 0013.25 5v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0020.75 9V5A1.75 1.75 0 0019 3.25h-4zM14.75 5a.25.25 0 01.25-.25h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25h-4a.25.25 0 01-.25-.25V5zM3.25 15c0-.966.784-1.75 1.75-1.75h4c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 019 20.75H5A1.75 1.75 0 013.25 19v-4zM5 14.75a.25.25 0 00-.25.25v4c0 .138.112.25.25.25h4a.25.25 0 00.25-.25v-4a.25.25 0 00-.25-.25H5zM15 13.25A1.75 1.75 0 0013.25 15v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0020.75 19v-4A1.75 1.75 0 0019 13.25h-4zM14.75 15a.25.25 0 01.25-.25h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25h-4a.25.25 0 01-.25-.25v-4z"
    }));
  }

  var ForwardRef$3J = /*#__PURE__*/React__namespace.forwardRef(SvgApp$1);

  function SvgArrowCornerRight$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-corner-right_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.145 18.382l9.1-9.1a.189.189 0 01.32.146l-.55 8.637a1.084 1.084 0 002.162.14l.71-11.181a1.806 1.806 0 00-1.915-1.916L5.793 5.82a1.082 1.082 0 00.14 2.16l8.636-.549a.189.189 0 01.146.32l-9.1 9.101a1.083 1.083 0 001.531 1.532v-.001z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-corner-right_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3I = /*#__PURE__*/React__namespace.forwardRef(SvgArrowCornerRight$1);

  function SvgArrowDown$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-down_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.92 4.054v12.869a.189.189 0 01-.33.124L4.873 10.55a1.084 1.084 0 00-1.627 1.43l7.404 8.408a1.806 1.806 0 002.708 0l7.402-8.407a1.083 1.083 0 00-1.626-1.43l-5.718 6.496a.189.189 0 01-.33-.124V4.054a1.083 1.083 0 00-2.166 0h.001z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-down_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3H = /*#__PURE__*/React__namespace.forwardRef(SvgArrowDown$1);

  function SvgArrowLeft$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.946 10.92H7.077a.188.188 0 01-.124-.33l6.496-5.718a1.084 1.084 0 00-1.43-1.627L3.612 10.65a1.805 1.805 0 000 2.708l8.407 7.402a1.083 1.083 0 001.43-1.626l-6.496-5.718a.189.189 0 01.124-.33h12.87a1.082 1.082 0 000-2.166v.001z"
    }));
  }

  var ForwardRef$3G = /*#__PURE__*/React__namespace.forwardRef(SvgArrowLeft$2);

  function SvgArrowRight$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.054 10.92h12.869a.189.189 0 00.124-.33L10.55 4.873a1.084 1.084 0 011.43-1.627l8.408 7.404a1.806 1.806 0 010 2.708l-8.407 7.402a1.083 1.083 0 01-1.43-1.626l6.496-5.718a.189.189 0 00-.124-.33H4.054a1.083 1.083 0 010-2.166v.001z"
    }));
  }

  var ForwardRef$3F = /*#__PURE__*/React__namespace.forwardRef(SvgArrowRight$1);

  function SvgArrowUp$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-up_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.08 19.946V7.077a.188.188 0 01.33-.124l5.718 6.496a1.084 1.084 0 001.627-1.43L13.35 3.612a1.805 1.805 0 00-2.708 0L3.24 12.018a1.083 1.083 0 001.626 1.43l5.718-6.496a.189.189 0 01.33.124v12.87a1.082 1.082 0 002.166 0h-.001z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-up_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3E = /*#__PURE__*/React__namespace.forwardRef(SvgArrowUp$1);

  function SvgAvatar$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-5.284c1.72 0 3.486.693 5.297 2.158-1.8 1.205-3.565 1.808-5.297 1.808-1.732 0-3.505-.603-5.322-1.889 1.828-1.384 3.602-2.077 5.322-2.077zM12 5.4a4.725 4.725 0 110 9.45 4.725 4.725 0 010-9.45z"
    }));
  }

  var ForwardRef$3D = /*#__PURE__*/React__namespace.forwardRef(SvgAvatar$1);

  function SvgBrowser$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5.239 16.883h3.37a.744.744 0 01.748.748.753.753 0 01-.744.753H5.24a2.233 2.233 0 01-1.583-.66A2.258 2.258 0 013 16.134V5.25c0-.597.236-1.17.656-1.592.42-.422.99-.659 1.583-.659h13.434c.594 0 1.163.237 1.583.66.42.422.656.994.656 1.591v4.153a.752.752 0 01-.753.744.744.744 0 01-.74-.757V6.94a.188.188 0 00-.186-.188H4.679a.186.186 0 00-.186.189v9.192a.752.752 0 00.746.75zm5.228-12.66a.724.724 0 00-.265.278.736.736 0 00-.114.375.738.738 0 00.114.375.724.724 0 00.634.38.718.718 0 00.635-.38.732.732 0 00.115-.375.73.73 0 00-.115-.375.724.724 0 00-.635-.38.719.719 0 00-.369.102zm-2.612 0a.724.724 0 00-.265.278.736.736 0 00-.114.375.738.738 0 00.114.375.724.724 0 00.634.38.719.719 0 00.635-.38.732.732 0 00.115-.375.73.73 0 00-.115-.375.724.724 0 00-.635-.38.719.719 0 00-.369.102zm-2.648.024a.75.75 0 00-.275.322h.002a.744.744 0 00-.07.307.738.738 0 00.114.375.724.724 0 00.634.38.719.719 0 00.635-.38.732.732 0 00.114-.375.73.73 0 00-.114-.375.736.736 0 00-.635-.375.743.743 0 00-.405.12zm10.016 8.481l.887-.894a2.856 2.856 0 012.024-.854 2.842 2.842 0 012.029.84A2.874 2.874 0 0121 13.862a2.887 2.887 0 01-.85 2.035l-.887.893a.745.745 0 01-1.283-.528.755.755 0 01.228-.533l.887-.893a1.376 1.376 0 000-1.94 1.361 1.361 0 00-1.929 0l-.886.893a.747.747 0 01-.82.174.745.745 0 01-.464-.7.755.755 0 01.227-.534zm-.378 6.382l.938-.943a.744.744 0 011.265.534.753.753 0 01-.21.527l-.938.944a2.849 2.849 0 01-4.027-.014 2.88 2.88 0 01-.013-4.05l.938-.943a.744.744 0 011.264.534.753.753 0 01-.209.528l-.937.943a1.376 1.376 0 000 1.94 1.361 1.361 0 001.929 0zm2.926-4.883a.744.744 0 00-1.055 0l-2.638 2.656a.752.752 0 00.525 1.29.74.74 0 00.53-.229l2.638-2.652a.751.751 0 000-1.065z"
    }));
  }

  var ForwardRef$3C = /*#__PURE__*/React__namespace.forwardRef(SvgBrowser$1);

  function SvgCake$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M7.273 7.125c.434-.001.85-.18 1.158-.498a1.72 1.72 0 00.478-1.196 4.666 4.666 0 00-.925-2.093.912.912 0 00-1.423 0 4.66 4.66 0 00-.925 2.093c0 .448.172.878.479 1.196.307.317.723.497 1.158.498zm9.454 0c.435-.001.851-.18 1.158-.498a1.72 1.72 0 00.479-1.196 4.665 4.665 0 00-.925-2.093.912.912 0 00-1.423 0 4.659 4.659 0 00-.925 2.093c0 .448.172.878.478 1.196.307.317.723.497 1.158.498zm-3.57-.498A1.617 1.617 0 0112 7.125a1.617 1.617 0 01-1.158-.498 1.72 1.72 0 01-.478-1.196 4.66 4.66 0 01.925-2.093.912.912 0 011.423 0c.475.606.793 1.326.924 2.093 0 .448-.171.878-.478 1.196zm5.025 4.623a.358.358 0 01-.257-.11.38.38 0 01-.107-.265v-2.25a.762.762 0 00-.213-.53.716.716 0 00-.514-.22h-.727a.716.716 0 00-.515.22.762.762 0 00-.213.53v2.25a.38.38 0 01-.106.265.358.358 0 01-.257.11h-1.819a.358.358 0 01-.257-.11.38.38 0 01-.106-.265v-2.25a.762.762 0 00-.213-.53.716.716 0 00-.514-.22h-.728a.716.716 0 00-.514.22.762.762 0 00-.213.53v2.25a.38.38 0 01-.106.265.358.358 0 01-.258.11H8.728a.358.358 0 01-.257-.11.38.38 0 01-.106-.265v-2.25a.762.762 0 00-.213-.53.716.716 0 00-.515-.22H6.91a.716.716 0 00-.514.22.762.762 0 00-.213.53v2.25a.38.38 0 01-.107.265.358.358 0 01-.257.11 1.79 1.79 0 00-1.285.55A1.905 1.905 0 004 13.124v.27c0 .362.13.712.367.981.236.27.56.438.91.474.298.032.598-.02.868-.15s.502-.333.67-.588a.971.971 0 01.345-.325.993.993 0 01.94.002c.15.081.278.2.372.344.15.224.352.407.586.533a1.598 1.598 0 001.519 0c.234-.126.435-.309.586-.533.097-.134.223-.243.369-.317a1.019 1.019 0 01.935 0c.145.074.271.183.369.317.15.224.352.407.586.533a1.598 1.598 0 001.518 0c.235-.126.436-.309.587-.533.093-.145.22-.264.37-.345a.983.983 0 01.487-.12c.159 0 .314.041.454.119.14.077.258.189.346.325.167.255.399.458.67.588.27.13.57.182.867.15.35-.036.675-.204.912-.473a1.49 1.49 0 00.367-.983v-.269c0-.497-.192-.974-.532-1.326a1.79 1.79 0 00-1.286-.549zm.65 4.72c.23-.024.456-.08.671-.168a.353.353 0 01.338.039.372.372 0 01.159.31v2.974c0 .246-.047.49-.138.718a1.88 1.88 0 01-.394.608c-.17.174-.37.312-.59.406a1.77 1.77 0 01-.696.143H5.818a1.77 1.77 0 01-.696-.143 1.815 1.815 0 01-.59-.406 1.88 1.88 0 01-.394-.608A1.926 1.926 0 014 19.125v-2.974a.384.384 0 01.161-.31.357.357 0 01.339-.035c.215.087.44.144.67.168.404.041.812-.01 1.194-.149.383-.139.73-.364 1.02-.658a.358.358 0 01.508 0c.512.526 1.204.821 1.926.821s1.414-.295 1.925-.82a.358.358 0 01.514 0c.51.524 1.2.818 1.92.819.357.002.71-.07 1.04-.212.329-.142.627-.35.877-.613a.365.365 0 01.258-.115.353.353 0 01.261.11c.288.296.637.523 1.02.664.385.14.794.191 1.199.149z"
    }));
  }

  var ForwardRef$3B = /*#__PURE__*/React__namespace.forwardRef(SvgCake$2);

  function SvgCalendar$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M19.515 4.375h-2.177a.198.198 0 01-.198-.198V2.792a.792.792 0 00-1.584 0v3.76a.594.594 0 11-1.187 0V4.771a.396.396 0 00-.396-.396H9.025a.198.198 0 01-.198-.197V2.792a.792.792 0 10-1.583 0v3.76a.594.594 0 11-1.187 0V4.771a.396.396 0 00-.396-.396H4.473c-.874 0-1.583.709-1.583 1.583v13.459c0 .874.709 1.583 1.583 1.583h15.042c.874 0 1.583-.709 1.583-1.583V5.958c0-.874-.709-1.583-1.583-1.583zm0 14.646a.396.396 0 01-.396.396H4.869a.396.396 0 01-.396-.396v-9.5c0-.219.177-.396.396-.396h14.25c.219 0 .396.177.396.396v9.5z"
    }));
  }

  var ForwardRef$3A = /*#__PURE__*/React__namespace.forwardRef(SvgCalendar$2);

  function SvgCall$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.35 15.926l-1.919-1.923a2.2 2.2 0 00-3.114 0l-.391.392a42.59 42.59 0 01-5.324-5.339l.392-.392a2.21 2.21 0 000-3.118L8.07 3.626a2.255 2.255 0 00-3.118 0L3.905 4.68a3.123 3.123 0 00-.392 3.915A42.433 42.433 0 0015.388 20.49a3.14 3.14 0 003.914-.392l1.052-1.055a2.202 2.202 0 000-3.117h-.004z"
    }));
  }

  var ForwardRef$3z = /*#__PURE__*/React__namespace.forwardRef(SvgCall$2);

  function SvgCamera$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M4.25 4.95a1.1 1.1 0 112.2 0v1.3h1.3a1.1 1.1 0 110 2.2h-1.3v1.3a1.1 1.1 0 01-2.2 0v-1.3h-1.3a1.1 1.1 0 110-2.2h1.3v-1.3zM2.95 9.3c-.343 0-.665-.089-.945-.244v8.156a1.878 1.878 0 002.129 1.99h15.732a1.876 1.876 0 002.13-1.99V8.559c0-.845-.37-1.852-2.13-1.852H18.77a.445.445 0 01-.4-.288l-.001-.002c-.515-1.086-1.047-2.209-2.204-2.209H12c-.892 0-1.363.648-2.215 1.825-.056.078-.106.148-.15.213-.057.08-.106.15-.152.21A1.95 1.95 0 017.75 9.3H7.3v.45a1.95 1.95 0 11-3.9 0V9.3h-.45zm16.13 3.238a4.79 4.79 0 11-9.58 0 4.79 4.79 0 019.58 0zm-4.79 3.123a3.124 3.124 0 100-6.247 3.124 3.124 0 000 6.247z"
    }));
  }

  var ForwardRef$3y = /*#__PURE__*/React__namespace.forwardRef(SvgCamera$2);

  function SvgCameraOff$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M16.182 14.982c.01.025.026.048.046.067l5.528 5.529a.833.833 0 01-1.178 1.178L2.244 3.423a.833.833 0 011.179-1.179l4.903 4.904a.207.207 0 00.147.06h6.444a1.25 1.25 0 011.25 1.25v6.444c0 .027.005.054.015.08zM4.638 7.36a.21.21 0 00-.233-.043 1.25 1.25 0 00-.738 1.141v7.5a1.25 1.25 0 001.25 1.25h9.066a.208.208 0 00.147-.355L4.638 7.36zm15.476.85l-2.5 1.425A1.205 1.205 0 0017 10.677v3.063a1.208 1.208 0 00.614 1.042l2.5 1.425A1.25 1.25 0 0022 15.168V9.25a1.25 1.25 0 00-1.886-1.04z"
    }));
  }

  var ForwardRef$3x = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOff$1);

  function SvgCameraOn$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M4.87 7.3a1.2 1.2 0 00-1.2 1.2v7.51a1.2 1.2 0 001.2 1.2h10.08a1.2 1.2 0 001.2-1.2V8.5a1.2 1.2 0 00-1.2-1.2H4.87zm12.744 2.335l2.5-1.426A1.25 1.25 0 0122 9.25v5.917a1.25 1.25 0 01-1.886 1.04l-2.5-1.425A1.208 1.208 0 0117 13.74v-3.063a1.205 1.205 0 01.614-1.042z"
    }));
  }

  var ForwardRef$3w = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOn$2);

  function SvgCameraSwitch$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#camera-switch_svg__clip0)",
      clipRule: "evenodd"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15.081 1.95a.5.5 0 01.64-.301A11 11 0 0111.999 23a.5.5 0 010-1 10 10 0 003.383-19.41.5.5 0 01-.301-.64z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.014 1.334a.5.5 0 01-.405.58l-3.261.573 1.612 2.747a.5.5 0 11-.862.506L15.12 2.372a.5.5 0 01.344-.745l3.97-.698a.5.5 0 01.58.405zM12 2a10 10 0 00-3.383 19.41.5.5 0 01-.338.942A11 11 0 0112 1a.5.5 0 110 1z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.218 18.082a.5.5 0 01.684.178l1.977 3.368a.5.5 0 01-.345.745l-3.97.698a.5.5 0 11-.173-.985l3.261-.573-1.613-2.747a.5.5 0 01.179-.684zM14.67 7.224A1.5 1.5 0 0013.88 7h-2.764a1.5 1.5 0 00-1.341.83L9.69 8H7.5A1.5 1.5 0 006 9.5v6A1.5 1.5 0 007.5 17h10a1.5 1.5 0 001.5-1.5v-6A1.5 1.5 0 0017.5 8h-2.192l-.086-.171a1.5 1.5 0 00-.552-.605zM12.5 10a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm-1.06 1.44a1.5 1.5 0 112.12 2.12 1.5 1.5 0 01-2.12-2.12z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "camera-switch_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3v = /*#__PURE__*/React__namespace.forwardRef(SvgCameraSwitch$1);

  function SvgCar$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M2.833 14.498a.208.208 0 00.209-.209v-1.875a1.667 1.667 0 011.666-1.666h.398a.209.209 0 00.187-.115l1.354-2.716A1.66 1.66 0 018.142 7h6.675a1.661 1.661 0 011.495.917l1.355 2.716a.21.21 0 00.186.115h2.48A1.666 1.666 0 0122 12.414v2.084a1.25 1.25 0 01-1.037 1.23.208.208 0 01-.242-.179 2.49 2.49 0 00-4.944.015.208.208 0 01-.207.184H9.472a.206.206 0 01-.207-.184 2.496 2.496 0 00-4.973.376.208.208 0 01-.209.224h-1.25a.833.833 0 110-1.667zm9.375-4.375a.208.208 0 00.209.208h2.896a.21.21 0 00.187-.302l-.626-1.25a.208.208 0 00-.186-.115h-2.271a.208.208 0 00-.209.209v1.25zm-4.743.11a.208.208 0 00.177.098h2.691a.208.208 0 00.209-.208v-1.25a.208.208 0 00-.209-.209H8.267a.208.208 0 00-.187.115l-.625 1.25a.21.21 0 00.01.204zM18.25 17.53a1.667 1.667 0 110-3.333 1.667 1.667 0 010 3.333zM5.125 15.864a1.667 1.667 0 103.333 0 1.667 1.667 0 00-3.333 0z"
    }));
  }

  var ForwardRef$3u = /*#__PURE__*/React__namespace.forwardRef(SvgCar$2);

  function SvgCheck$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M18.774 7.726l-6.964 9.847a1 1 0 01-1.455.2L5.382 13.63a1.09 1.09 0 01-.159-1.49.99.99 0 011.43-.166l4.147 3.457 6.336-8.959c.208-.325.57-.504.943-.467.373.037.696.284.841.644.146.36.09.774-.146 1.077z"
    }));
  }

  var ForwardRef$3t = /*#__PURE__*/React__namespace.forwardRef(SvgCheck$1);

  function SvgCheckRound$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentcolor",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "non-zero",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm4.323-14.671L11 14.859l-3.448-2.876a.83.83 0 00-1.202.13c-.334.426-.17 1.004.123 1.236l4.098 3.413a.837.837 0 001.245-.086l5.9-8.34c.337-.637-.125-1.085-.23-1.164-.104-.079-.673-.421-1.163.157z"
    }));
  }

  var ForwardRef$3s = /*#__PURE__*/React__namespace.forwardRef(SvgCheckRound$2);

  function SvgCheckboxEmpty$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M18 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2zM6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6z"
    }));
  }

  var ForwardRef$3r = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxEmpty$1);

  function SvgCheckboxIndeterminate$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2zM2 6a4 4 0 014-4h12a4 4 0 014 4v12a4 4 0 01-4 4H6a4 4 0 01-4-4V6zm5 5a1 1 0 100 2h10a1 1 0 000-2H7z"
    }));
  }

  var ForwardRef$3q = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxIndeterminate$1);

  function SvgCheckboxSelected$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6zm5.81 15.573l6.964-9.847c.235-.303.292-.717.146-1.077a1.022 1.022 0 00-.841-.644 1.003 1.003 0 00-.943.467l-6.335 8.959-4.147-3.457a.99.99 0 00-1.43.165 1.09 1.09 0 00.158 1.49l4.973 4.144a1 1 0 001.455-.2z"
    }));
  }

  var ForwardRef$3p = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxSelected$1);

  function SvgChevronDown$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-down_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.979 17.636a1.724 1.724 0 01-1.297-.585L3.324 8.688a1.385 1.385 0 012.08-1.83l6.434 7.314a.188.188 0 00.282 0l6.434-7.314a1.385 1.385 0 112.08 1.83l-7.356 8.36a1.731 1.731 0 01-1.3.588z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-down_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3o = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDown$2);

  function SvgChevronDownSm$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-down-sm_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.986 15.76a1.151 1.151 0 01-.865-.39L6.216 9.794a.923.923 0 011.386-1.22l4.29 4.877a.125.125 0 00.188 0l4.29-4.876a.923.923 0 111.386 1.22l-4.904 5.573a1.155 1.155 0 01-.866.392z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-down-sm_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3n = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDownSm$1);

  function SvgChevronLeft$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5 11.979a1.725 1.725 0 01.585-1.297l8.364-7.358a1.385 1.385 0 011.829 2.08l-7.314 6.434a.188.188 0 000 .282l7.314 6.434a1.386 1.386 0 11-1.83 2.08l-8.36-7.356a1.733 1.733 0 01-.588-1.3z"
    }));
  }

  var ForwardRef$3m = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeft$2);

  function SvgChevronLeftSm$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.24 11.986a1.15 1.15 0 01.39-.865l5.576-4.905a.924.924 0 011.22 1.386l-4.877 4.29a.125.125 0 000 .188l4.876 4.29a.923.923 0 11-1.22 1.386l-5.573-4.904a1.155 1.155 0 01-.392-.866z"
    }));
  }

  var ForwardRef$3l = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeftSm$1);

  function SvgChevronRight$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.273 11.979a1.724 1.724 0 00-.585-1.297L9.324 3.324a1.385 1.385 0 00-1.83 2.08l7.315 6.434a.188.188 0 010 .282l-7.314 6.434a1.385 1.385 0 101.829 2.08l8.36-7.356a1.733 1.733 0 00.589-1.3z"
    }));
  }

  var ForwardRef$3k = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRight$2);

  function SvgChevronRightSm$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15.76 11.986a1.148 1.148 0 00-.39-.865L9.794 6.216a.923.923 0 00-1.22 1.386l4.877 4.29a.124.124 0 01.031.145.124.124 0 01-.031.043l-4.876 4.29a.924.924 0 101.22 1.386l5.573-4.904a1.156 1.156 0 00.392-.866z"
    }));
  }

  var ForwardRef$3j = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRightSm$1);

  function SvgChevronUp$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-up_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.021 6.364a1.725 1.725 0 011.297.585l7.358 8.363a1.385 1.385 0 01-2.08 1.83l-6.434-7.314a.188.188 0 00-.282 0l-6.434 7.314a1.386 1.386 0 11-2.08-1.83l7.356-8.36a1.733 1.733 0 011.3-.588z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-up_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3i = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUp$2);

  function SvgChevronUpSm$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-up-sm_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.014 8.24a1.15 1.15 0 01.865.39l4.905 5.576a.924.924 0 01-1.386 1.22l-4.29-4.877a.125.125 0 00-.188 0l-4.29 4.876a.923.923 0 11-1.386-1.22l4.904-5.573a1.156 1.156 0 01.866-.392z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-up-sm_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3h = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUpSm$1);

  function SvgClock$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm4.333 14.35a.847.847 0 01-1.177.052l-4.133-3.788A.835.835 0 0110.75 12V7.417a.833.833 0 111.667 0v4.216l3.861 3.54a.833.833 0 01.055 1.179v-.001z"
    }));
  }

  var ForwardRef$3g = /*#__PURE__*/React__namespace.forwardRef(SvgClock$2);

  function SvgClose$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M7.05 8.11a.75.75 0 111.06-1.06L12 10.939l3.889-3.89a.75.75 0 011.06 1.061L13.06 12l3.89 3.889a.75.75 0 01-1.061 1.06l-3.89-3.889-3.889 3.89a.75.75 0 01-1.06-1.061l3.889-3.89-3.89-3.889z"
    }));
  }

  var ForwardRef$3f = /*#__PURE__*/React__namespace.forwardRef(SvgClose$2);

  function SvgCloseRound$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM7.05 8.11a.75.75 0 011.06-1.06L12 10.939l3.889-3.89a.75.75 0 111.06 1.061L13.06 12l3.89 3.889a.75.75 0 01-1.061 1.06l-3.89-3.889-3.889 3.89a.75.75 0 11-1.06-1.061l3.889-3.89-3.89-3.889z"
    }));
  }

  var ForwardRef$3e = /*#__PURE__*/React__namespace.forwardRef(SvgCloseRound$1);

  function SvgDash$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7 11a1 1 0 100 2h10a1 1 0 100-2H7z"
    }));
  }

  var ForwardRef$3d = /*#__PURE__*/React__namespace.forwardRef(SvgDash$1);

  function SvgDoctor$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#doctor_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M10.425 10.991a4.216 4.216 0 10-3.779-.016.188.188 0 01.104.168v2.111a.189.189 0 00.107.17 1.125 1.125 0 11-.964 0 .188.188 0 00.107-.17v-1.593a.187.187 0 00-.285-.16A5.624 5.624 0 003 16.31a.375.375 0 00.375.375h6.938a.188.188 0 00.187-.188v-5.398a.11.11 0 00-.075-.107zM8.55 9.936a2.72 2.72 0 01-2.714-2.715c.001-.352.074-.7.212-1.024a.189.189 0 01.284-.075 5.717 5.717 0 003.375 1.103 5.68 5.68 0 001.35-.166.167.167 0 01.145.032.169.169 0 01.065.133A2.718 2.718 0 018.55 9.936zm2.796 1.563a.187.187 0 00-.096.163v.811a.187.187 0 00.252.176c.16-.058.328-.089.498-.089h.354a.187.187 0 00.13-.322 5.606 5.606 0 00-.948-.736.188.188 0 00-.19-.003zm7.216 2.004h1.313A1.125 1.125 0 0121 14.627v5.248A1.124 1.124 0 0119.875 21h-7.5a1.125 1.125 0 01-1.125-1.125v-5.248a1.124 1.124 0 011.125-1.124h1.313a.375.375 0 00.374-.375v-.375a1.313 1.313 0 011.313-1.312h1.5a1.314 1.314 0 011.313 1.312v.375a.375.375 0 00.375.375zm-3.32-.883a.188.188 0 00-.055.133v.375a.375.375 0 00.376.375h1.124a.375.375 0 00.375-.375v-.375a.188.188 0 00-.187-.188h-1.5c-.05 0-.097.02-.133.055zm2.703 5.326a.188.188 0 00.055-.132v-1.125a.188.188 0 00-.188-.187h-.562a.375.375 0 01-.375-.375v-.562a.188.188 0 00-.188-.188h-1.125a.188.188 0 00-.187.188v.562a.375.375 0 01-.375.375h-.563a.188.188 0 00-.187.187v1.125a.188.188 0 00.188.187H15a.375.375 0 01.375.375v.562a.188.188 0 00.188.188h1.124a.188.188 0 00.188-.188v-.562A.375.375 0 0117.25 18h.563c.05 0 .097-.02.132-.055z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "doctor_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$3c = /*#__PURE__*/React__namespace.forwardRef(SvgDoctor$2);

  function SvgEdit$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M20.334 2.01c.439 0 .86.17 1.178.472a1.666 1.666 0 010 2.357l-.884.884a.417.417 0 01-.59 0l-1.767-1.768a.417.417 0 010-.589l.884-.884c.318-.303.74-.472 1.179-.472zm-2.257 9.807a.833.833 0 011.423.59v7.082a2.5 2.5 0 01-2.5 2.5H4.5a2.5 2.5 0 01-2.5-2.5V5.325a2.5 2.5 0 012.5-2.5h8.333a.833.833 0 010 1.666H4.5a.833.833 0 00-.833.834v14.165a.833.833 0 00.833.834H17a.833.833 0 00.833-.834v-7.083c0-.22.088-.432.244-.589zm-6.611-1.055l1.767 1.767a.417.417 0 00.59 0l5.302-5.303a.416.416 0 000-.59l-1.768-1.768a.43.43 0 00-.589 0l-5.302 5.304a.417.417 0 000 .59zm-1.024.688a.417.417 0 01.558.027l1.517 1.514a.418.418 0 01-.14.682l-2.524 1.01a.44.44 0 01-.45-.092.417.417 0 01-.092-.45l1.01-2.529a.422.422 0 01.12-.162z"
    }));
  }

  var ForwardRef$3b = /*#__PURE__*/React__namespace.forwardRef(SvgEdit$2);

  function SvgEvolution$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M19.376 2.5a1.624 1.624 0 00-1.589 1.964L15.51 6.245a1.625 1.625 0 00-2.2.533l-2.872-.768a1.624 1.624 0 10-3.203.237l-2.75 2.747a1.624 1.624 0 10.815.461l2.397-2.394a1.624 1.624 0 002.422-.202l2.941.786a1.624 1.624 0 103.07-.74l2.094-1.636.004.005A1.624 1.624 0 1019.376 2.5zM10.38 9.54a.842.842 0 00-.842.841v9.716H7.51V17.42a.842.842 0 00-.841-.842H4.516a.842.842 0 00-.842.842v2.677h-.722a.451.451 0 000 .902H19.962a.451.451 0 100-.902h-.722V13.9a.842.842 0 00-.842-.843h-2.993v7.039h-2.03V10.38a.842.842 0 00-.842-.842h-2.151z"
    }));
  }

  var ForwardRef$3a = /*#__PURE__*/React__namespace.forwardRef(SvgEvolution$1);

  function SvgExams$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.737 2.36a.897.897 0 00-.323-.265.942.942 0 00-.828 0 .897.897 0 00-.323.266C11.2 2.453 5 11.779 5 15.325c0 1.77.737 3.468 2.05 4.72C8.363 21.297 10.143 22 12 22c1.857 0 3.637-.703 4.95-1.955 1.313-1.252 2.05-2.95 2.05-4.72 0-3.545-6.2-12.872-6.263-12.964zM12 19.707a4.715 4.715 0 01-3.247-1.285 4.285 4.285 0 01-1.347-3.096c0-.166.07-.325.192-.442a.673.673 0 01.465-.183c.174 0 .34.066.464.183a.611.611 0 01.192.442c0 .83.347 1.625.962 2.212a3.369 3.369 0 002.319.917c.174 0 .341.066.464.183a.611.611 0 01.192.443c0 .166-.069.325-.192.442a.672.672 0 01-.464.184z"
    }));
  }

  var ForwardRef$39 = /*#__PURE__*/React__namespace.forwardRef(SvgExams$2);

  function SvgExit$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M15.604 17.095a.75.75 0 011.28.53v1.5a.75.75 0 01-.75.75h-5.629v.75a.374.374 0 01-.456.367l-6.755-1.5A.375.375 0 013 19.125V4.875a.375.375 0 01.294-.366l6.755-1.5a.376.376 0 01.456.366v.75h5.63a.751.751 0 01.75.75V6.75a.75.75 0 01-1.501 0V6a.375.375 0 00-.376-.375h-4.127a.375.375 0 00-.376.375v12a.375.375 0 00.375.375h4.128a.375.375 0 00.376-.375v-.375a.75.75 0 01.22-.53zM8.439 13a1.124 1.124 0 00-1.561-1.56A1.125 1.125 0 108.439 13zm8.829-3.687l3.659 2.438a.75.75 0 010 1.248l-3.659 2.437a.75.75 0 01-1.166-.624V13.5h-3.096a1.126 1.126 0 01-.796-1.92c.21-.212.497-.33.796-.33h3.096V9.937a.75.75 0 011.166-.624z"
    }));
  }

  var ForwardRef$38 = /*#__PURE__*/React__namespace.forwardRef(SvgExit$2);

  function SvgFamily$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M6.465 8.253a2.028 2.028 0 01-3.013-.92 2.06 2.06 0 01.188-1.922 2.025 2.025 0 013.134-.31 2.053 2.053 0 01.44 2.233 2.047 2.047 0 01-.75.92zM2.976 10a3.323 3.323 0 014.714 0c.625.63.977 1.482.977 2.372v1.818a.42.42 0 01-.417.419h-.7a.415.415 0 00-.416.377l-.412 4.137a.42.42 0 01-.416.377h-1.94a.415.415 0 01-.417-.377l-.411-4.137a.42.42 0 00-.417-.377h-.704a.415.415 0 01-.417-.42v-1.817c0-.89.351-1.743.976-2.372zM18.666 8.6c.403 0 .797-.12 1.132-.346a2.061 2.061 0 00.309-3.153 2.033 2.033 0 00-2.22-.444 2.04 2.04 0 00-.914.755 2.058 2.058 0 00.253 2.587c.382.385.9.6 1.44.6zM16.31 10a3.323 3.323 0 014.714 0c.625.63.976 1.482.976 2.372v1.818a.42.42 0 01-.417.419h-.694a.414.414 0 00-.417.377l-.411 4.137a.42.42 0 01-.417.377H17.7a.414.414 0 01-.417-.377l-.411-4.137a.42.42 0 00-.417-.377h-.704a.415.415 0 01-.417-.42v-1.817c0-.89.351-1.743.977-2.372zm-6.067-1.005a1.707 1.707 0 001.043 1.57 1.68 1.68 0 001.841-.368 1.703 1.703 0 00.366-1.852 1.698 1.698 0 00-.622-.763 1.682 1.682 0 00-2.133.212c-.316.318-.494.75-.495 1.201zm-.02 2.831a2.41 2.41 0 011.71-.712 2.405 2.405 0 011.719.707 2.434 2.434 0 01.713 1.725v1.475a.42.42 0 01-.417.419h-.416a.415.415 0 00-.417.377l-.328 3.302a.42.42 0 01-.417.378h-.86a.415.415 0 01-.416-.378l-.328-3.302a.42.42 0 00-.417-.377h-.416a.415.415 0 01-.417-.42v-1.474c0-.645.254-1.264.708-1.72z"
    }));
  }

  var ForwardRef$37 = /*#__PURE__*/React__namespace.forwardRef(SvgFamily$1);

  function SvgFold$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.81 2H5.578c-.31.052-.59.213-.789.455-.198.24-.3.545-.288.855v14.565c0 .291.087.576.253.818.166.241.402.428.677.536l6.76 2.667a1.499 1.499 0 001.378-.147c.2-.133.364-.313.477-.524.114-.21.173-.445.173-.684V6.374c0-.292-.088-.577-.253-.819a1.47 1.47 0 00-.677-.536l-2.417-.952a.21.21 0 01-.124-.231.208.208 0 01.07-.12.213.213 0 01.132-.05H17.6c.056 0 .11.023.15.062.039.039.061.092.061.147v13.73a.207.207 0 01-.062.148.213.213 0 01-.15.06H16.12a.851.851 0 00-.598.245.828.828 0 000 1.178.851.851 0 00.598.244h1.69c.448 0 .878-.175 1.195-.488.317-.312.495-.736.495-1.178V3.667c0-.442-.178-.866-.495-1.179A1.702 1.702 0 0017.81 2z"
    }));
  }

  var ForwardRef$36 = /*#__PURE__*/React__namespace.forwardRef(SvgFold$2);

  function SvgGenderFemale$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19 9.012a7 7 0 10-8.31 6.864.225.225 0 01.181.222v1.398a.226.226 0 01-.226.226H9.29a1.13 1.13 0 100 2.258h1.355a.226.226 0 01.226.225v1.355a1.129 1.129 0 102.258 0v-1.355a.225.225 0 01.226-.225h1.355a1.129 1.129 0 100-2.258h-1.355a.225.225 0 01-.226-.226v-1.394a.225.225 0 01.18-.221A7.006 7.006 0 0019 9.01zm-11.742 0a4.742 4.742 0 119.484 0 4.742 4.742 0 01-9.484 0z"
    }));
  }

  var ForwardRef$35 = /*#__PURE__*/React__namespace.forwardRef(SvgGenderFemale$2);

  function SvgGenderMale$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21 3.374A.374.374 0 0020.626 3H15.39a.374.374 0 00-.265.639l1.825 1.824a.188.188 0 01.041.204.189.189 0 01-.04.061l-3.332 3.33a.187.187 0 01-.241.02 6.569 6.569 0 101.543 1.543.187.187 0 01.02-.24l3.332-3.332a.187.187 0 01.264 0l1.824 1.825A.374.374 0 0021 8.61V3.374zM9.593 19.082a4.675 4.675 0 110-9.35 4.675 4.675 0 010 9.35z"
    }));
  }

  var ForwardRef$34 = /*#__PURE__*/React__namespace.forwardRef(SvgGenderMale$2);

  function SvgGlasses$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.457 4a.75.75 0 000 1.5A1.045 1.045 0 0119.5 6.543v5.574a.188.188 0 01-.294.155 4.153 4.153 0 00-5.827 1.12.375.375 0 01-.468.133 2.175 2.175 0 00-1.822 0 .375.375 0 01-.468-.133 4.152 4.152 0 00-5.827-1.12.187.187 0 01-.294-.155V6.543A1.045 1.045 0 015.543 5.5a.75.75 0 000-1.5A2.55 2.55 0 003 6.543v9.15a4.158 4.158 0 008.315 0v-.18a.685.685 0 111.37 0v.18a4.158 4.158 0 008.315 0v-9.15A2.55 2.55 0 0018.457 4zm-11.3 14.348a2.658 2.658 0 110-5.316 2.658 2.658 0 010 5.316zm9.686 0a2.658 2.658 0 11-.002-5.317 2.658 2.658 0 01.002 5.316z"
    }));
  }

  var ForwardRef$33 = /*#__PURE__*/React__namespace.forwardRef(SvgGlasses$2);

  function SvgHandshake$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21.362 7.379h-1.755a1.77 1.77 0 00-.766.18.213.213 0 01-.17.006l-3.66-1.4a2.83 2.83 0 00-2.19.121l-1.807.877a.214.214 0 01-.205-.008 2.534 2.534 0 00-2.248-.17L6.014 8.07a.212.212 0 01-.245-.057 1.807 1.807 0 00-1.376-.635H2.638A.638.638 0 002 8.017v8.085a.638.638 0 00.638.639h1.755a1.806 1.806 0 001.473-.762.215.215 0 01.17-.09h.792c.048 0 .094.017.132.046l2.378 1.872.019.016a1.648 1.648 0 002.212.105l2.602-2.135a.216.216 0 01.094-.044l3.315-.663a.215.215 0 01.161.033c.047.033.08.083.09.14a1.8 1.8 0 001.774 1.482h1.757a.639.639 0 00.638-.638V8.018a.639.639 0 00-.638-.639zm-6.993 6.054l-.964.806-.02.014a.807.807 0 00-.104.085l-.008.007-2.585 2.162a.187.187 0 01-.235 0l-2.724-2.145a.851.851 0 00-.526-.181h-.788a.211.211 0 01-.212-.213V9.98a.211.211 0 01.129-.195L9.207 8.56h.005a.191.191 0 01.255.227 2.266 2.266 0 001.29 2.643c.282.122.585.184.892.184.29 0 .576-.055.846-.161l.134-.055a.212.212 0 01.238.054l1.522 1.678a.212.212 0 01-.02.306v-.004zm3.428-.3a.212.212 0 01-.17.208l-1.116.223a.209.209 0 01-.18-.046.213.213 0 01-.075-.17 1.728 1.728 0 00-.375-1.112l-.011-.014-2.244-2.468a.912.912 0 00-.953-.216l-.815.335a.553.553 0 01-.463-1.003l2.175-1.06c.264-.126.566-.145.843-.053l3.268 1.25a.17.17 0 01.11.163l.006 3.962z"
    }));
  }

  var ForwardRef$32 = /*#__PURE__*/React__namespace.forwardRef(SvgHandshake$2);

  function SvgHealthInsurance$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M21.512 4.493c.312.316.488.745.488 1.191v12.632c0 .447-.176.875-.488 1.19a1.657 1.657 0 01-1.179.494H3.667c-.442 0-.866-.177-1.179-.493A1.693 1.693 0 012 18.316V5.684c0-.446.176-.875.488-1.19A1.658 1.658 0 013.667 4h16.666c.442 0 .866.177 1.179.493zm-17.723 13.7a.415.415 0 00.294.123h15.834c.11 0 .216-.045.294-.123a.424.424 0 00.122-.298V9.053a.423.423 0 00-.122-.298.414.414 0 00-.294-.123H4.083a.414.414 0 00-.294.123.423.423 0 00-.122.298v8.842c0 .111.044.218.122.297zM9.292 12h.833c.166 0 .325.067.442.185a.636.636 0 01.183.447v1.263a.636.636 0 01-.183.446.622.622 0 01-.442.185h-.833a.207.207 0 00-.148.062.212.212 0 00-.06.149v.842a.636.636 0 01-.184.446.622.622 0 01-.442.186h-1.25a.622.622 0 01-.441-.186.636.636 0 01-.184-.446v-.842a.212.212 0 00-.06-.149.207.207 0 00-.148-.062h-.833a.622.622 0 01-.442-.185.636.636 0 01-.183-.446v-1.263c0-.168.066-.328.183-.447A.622.622 0 015.542 12h.833a.207.207 0 00.147-.062.211.211 0 00.061-.149v-.842c0-.167.066-.328.184-.446a.622.622 0 01.441-.185h1.25c.166 0 .325.067.442.185a.636.636 0 01.183.446v.843c0 .055.022.109.061.148.04.04.092.062.148.062zm8.75-.21h-3.959a.621.621 0 00-.442.184.635.635 0 000 .894.622.622 0 00.442.184h3.959a.622.622 0 00.442-.184.635.635 0 000-.894.622.622 0 00-.442-.185zm-3.959 2.526H17c.166 0 .325.066.442.185a.635.635 0 010 .893.622.622 0 01-.442.185h-2.917a.622.622 0 01-.442-.185.635.635 0 010-.893.621.621 0 01.442-.185z"
    }));
  }

  var ForwardRef$31 = /*#__PURE__*/React__namespace.forwardRef(SvgHealthInsurance$1);

  function SvgHeartbeat$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.977 11.732l1.073 3.693.048.128c.165.37.506.614.896.637h.129c.382-.027.725-.267.887-.635l.984-2.376.477.739.064.086a.73.73 0 00.552.255l3.648-.001-2.058 2.322-3.697 3.987c-.256.277-.61.433-.98.433-.324 0-.636-.12-.88-.335l-.1-.097-3.71-4.001-2.043-2.304h2.838l.13-.008c.345-.045.65-.264.808-.59l.934-1.933zm7.48-8.66c1.716.288 3.194 1.411 3.973 3.02a5.769 5.769 0 01.01 4.98l-.124.244-.101.145-1.123 1.266h-4.61l-.697-1.083-.078-.105a1.034 1.034 0 00-.892-.373l-.126.02a1.06 1.06 0 00-.741.63l-.823 1.984-1.04-3.581-.042-.124a1.053 1.053 0 00-.875-.65l-.13-.003-.126.013a1.055 1.055 0 00-.78.6L7.837 12.73H3.91l-1.122-1.265-.101-.145a5.762 5.762 0 01-.116-5.225c.778-1.608 2.256-2.732 3.972-3.02a5.292 5.292 0 014.504 1.38l.188.185.765.788.766-.791a5.3 5.3 0 014.692-1.566z"
    }));
  }

  var ForwardRef$30 = /*#__PURE__*/React__namespace.forwardRef(SvgHeartbeat$2);

  function SvgHome$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 3c.488.002.957.174 1.324.482l.133.122 8.33 8.273a.715.715 0 01-.006 1.023.748.748 0 01-.96.065l-.083-.07-1.385-1.376v8.757c0 .367-.277.67-.637.717l-.1.007H5.384a.733.733 0 01-.73-.626l-.008-.098v-8.76l-1.384 1.378a.747.747 0 01-1.043.007.714.714 0 01-.077-.942l.07-.082 2.643-2.629a.692.692 0 01.014-.014l5.668-5.638A2.072 2.072 0 0112 3zm0 10.942a2.396 2.396 0 00-2.396 2.232l-.005.157v3.22H14.4v-3.22a2.395 2.395 0 00-2.4-2.39z"
    }));
  }

  var ForwardRef$2$ = /*#__PURE__*/React__namespace.forwardRef(SvgHome$2);

  function SvgHospital$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12.5 5.563a3.563 3.563 0 11-7.125 0 3.563 3.563 0 017.125 0zm-4.552-.594h-.594a.594.594 0 100 1.187h.594c.219 0 .396.177.396.396v.594a.594.594 0 101.187 0v-.594c0-.219.177-.396.396-.396h.594a.594.594 0 100-1.187h-.594a.396.396 0 01-.396-.396v-.594a.594.594 0 10-1.187 0v.594a.396.396 0 01-.396.396z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M14.48 12.292h-2.376a2.375 2.375 0 00-2.375 2.375v5.541c0 .11.01.22.028.329a.396.396 0 01-.39.463H3.792A.792.792 0 013 20.208V7.542a1.16 1.16 0 01.83-1.126.396.396 0 01.5.284 4.744 4.744 0 009.214 0 .396.396 0 01.501-.284c.497.148.836.607.83 1.126v4.354a.396.396 0 01-.396.396zm-9.105 6.135H7.75a.594.594 0 100-1.187H5.375a.594.594 0 100 1.187zm2.375-2.77H5.375a.594.594 0 110-1.188H7.75a.594.594 0 110 1.187zm-2.375-2.772h2.77a.594.594 0 100-1.187h-2.77a.594.594 0 100 1.187z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M20.813 13.48h-8.709c-.656 0-1.187.53-1.187 1.187v5.541c0 .438.354.792.791.792h2.771a.396.396 0 00.396-.396v-.791a1.583 1.583 0 113.167 0v.791c0 .219.177.396.395.396h2.771a.792.792 0 00.792-.792v-5.541c0-.656-.532-1.188-1.188-1.188zm-5.542 2.968h-1.98a.594.594 0 010-1.188h1.98a.594.594 0 110 1.188zm2.375 0h1.979a.594.594 0 100-1.188h-1.98a.594.594 0 100 1.188z"
    }));
  }

  var ForwardRef$2_ = /*#__PURE__*/React__namespace.forwardRef(SvgHospital$1);

  function SvgId$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M21.512 4.488c.312.313.488.737.488 1.179v12.5a1.667 1.667 0 01-1.667 1.666h-2.5A.834.834 0 0117 19v-.625a.634.634 0 00-.625-.625.624.624 0 00-.625.625V19a.833.833 0 01-.833.833H9.083A.834.834 0 018.25 19v-.625a.634.634 0 00-.625-.625.625.625 0 00-.625.625V19a.833.833 0 01-.833.833h-2.5A1.667 1.667 0 012 18.167v-12.5A1.667 1.667 0 013.667 4h16.666c.442 0 .866.176 1.179.488zm-1.3 13.557a.417.417 0 00.121-.295V6.083a.417.417 0 00-.416-.416H4.083a.417.417 0 00-.416.416V17.75a.417.417 0 00.416.417h.907a.417.417 0 00.405-.321 2.292 2.292 0 014.46 0 .416.416 0 00.405.32h3.48a.417.417 0 00.405-.32 2.292 2.292 0 014.46 0 .417.417 0 00.405.32h.907c.11 0 .216-.043.294-.121zm-6.154-6.103a.624.624 0 01.442-1.067h3.986a.625.625 0 110 1.25H14.5a.624.624 0 01-.442-.183zM13.875 14a.624.624 0 00.625.625h2.174a.625.625 0 100-1.25H14.5a.624.624 0 00-.625.625zm4.792-4.375H14.5a.625.625 0 110-1.25h4.167a.625.625 0 010 1.25zM8.525 11.083a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333zm2.353 3.334H6.172a.418.418 0 01-.392-.57 3 3 0 012.745-1.93 3 3 0 012.746 1.93.417.417 0 01-.393.57z"
    }));
  }

  var ForwardRef$2Z = /*#__PURE__*/React__namespace.forwardRef(SvgId$2);

  function SvgInfoRound$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2 12.176a10.04 10.04 0 002.965 7.012 9.709 9.709 0 007.05 2.814 10.173 10.173 0 007.092-3.044 9.836 9.836 0 002.892-7.13A9.817 9.817 0 0012.164 2h-.18A10.092 10.092 0 002 12.176zm11.21 4.672a1.211 1.211 0 11-2.421 0v-5.45a1.211 1.211 0 112.421 0v5.45zM11.973 5.921h.026a1.514 1.514 0 11.026 3.028h-.026a1.514 1.514 0 11-.024-3.028h-.002z"
    }));
  }

  var ForwardRef$2Y = /*#__PURE__*/React__namespace.forwardRef(SvgInfoRound$1);

  function SvgLab$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.558 18.12l-3.878-6.152a.794.794 0 01-.122-.424v-7.46c0-.111.047-.217.13-.295a.46.46 0 01.314-.122h1.333a.92.92 0 00.629-.244.808.808 0 00.26-.59.808.808 0 00-.26-.589.92.92 0 00-.629-.244H6.67a.92.92 0 00-.628.244.808.808 0 00-.26.59c0 .22.093.432.26.589a.92.92 0 00.628.244h1.334a.46.46 0 01.314.122c.083.078.13.184.13.294v7.462a.794.794 0 01-.123.423l-3.843 6.1a2.37 2.37 0 00-.18 2.585c.224.405.563.745.979.982A2.8 2.8 0 006.66 22h10.68a2.801 2.801 0 001.366-.357c.413-.232.75-.565.978-.962a2.372 2.372 0 00-.127-2.56zM9.045 15.334a.467.467 0 01-.223-.056.43.43 0 01-.162-.154.397.397 0 01.003-.418l1.437-2.28a.805.805 0 00.125-.425V4.083c0-.11.047-.216.13-.294a.46.46 0 01.314-.122h2.667a.46.46 0 01.314.122c.083.078.13.184.13.294v2.292c0 .11-.047.216-.13.295a.46.46 0 01-.314.122h-1.174a.69.69 0 00-.47.183.606.606 0 00-.196.442c0 .165.07.324.195.442a.69.69 0 00.471.183h1.174a.46.46 0 01.314.122c.083.078.13.184.13.294v.834c0 .11-.047.216-.13.294a.46.46 0 01-.314.122h-1.174a.69.69 0 00-.47.183.606.606 0 00-.196.442c0 .166.07.325.195.442a.69.69 0 00.471.183h1.174a.46.46 0 01.314.122c.083.079.13.184.13.295V12c0 .15.043.296.124.424l1.438 2.281a.397.397 0 01.003.418.43.43 0 01-.163.154.468.468 0 01-.222.056H9.045zm.723 4.852c-.264 0-.522-.073-.74-.21a1.27 1.27 0 01-.492-.562c-.1-.228-.127-.48-.076-.722.052-.242.179-.465.365-.64.187-.175.424-.294.683-.342.258-.048.527-.023.77.071.244.095.452.255.598.46.147.206.225.448.225.695 0 .332-.14.65-.39.884a1.38 1.38 0 01-.943.366zm3.75-2.514a.931.931 0 01-.494-.14.848.848 0 01-.327-.375.786.786 0 01-.05-.481.82.82 0 01.242-.427.908.908 0 01.456-.228.944.944 0 01.513.048.88.88 0 01.399.306.797.797 0 01.082.782.833.833 0 01-.193.27.896.896 0 01-.288.181.94.94 0 01-.34.064zm2.222 2.568a.931.931 0 01-.494-.14.847.847 0 01-.327-.374.785.785 0 01-.05-.482.818.818 0 01.242-.426.909.909 0 01.456-.229.945.945 0 01.513.048c.163.063.301.17.399.307a.796.796 0 01-.112 1.054.895.895 0 01-.29.18.94.94 0 01-.341.062h.004z"
    }));
  }

  var ForwardRef$2X = /*#__PURE__*/React__namespace.forwardRef(SvgLab$2);

  function SvgLink$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M19.272 4.054l.673.673h-.004a3.612 3.612 0 010 5.11l-4.377 4.377a3.585 3.585 0 01-2.555 1.057 3.587 3.587 0 01-2.554-1.057.756.756 0 111.068-1.066 2.085 2.085 0 001.486.616 2.088 2.088 0 001.488-.616l4.377-4.378a2.102 2.102 0 000-2.975l-.674-.674a2.106 2.106 0 00-2.974 0L13.037 7.31a.755.755 0 01-1.067-1.067l2.192-2.189a3.623 3.623 0 015.11 0zm-10.5 14.822l2.065-2.065.002-.002a.755.755 0 111.067 1.068L9.842 19.94a3.612 3.612 0 01-5.11 0l-.674-.673a3.613 3.613 0 010-5.109l4.378-4.377a3.616 3.616 0 015.11 0l.674.673a.756.756 0 11-1.07 1.07l-.675-.673a2.105 2.105 0 00-2.975 0l-4.377 4.377a2.103 2.103 0 000 2.974l.673.673a2.153 2.153 0 002.975 0z"
    }));
  }

  var ForwardRef$2W = /*#__PURE__*/React__namespace.forwardRef(SvgLink$2);

  function SvgLoading$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M8.91 2.49A10 10 0 0122 12a1 1 0 11-2 0 8 8 0 10-5.528 7.608 1 1 0 11.618 1.903A10.001 10.001 0 018.91 2.489z"
    }));
  }

  var ForwardRef$2V = /*#__PURE__*/React__namespace.forwardRef(SvgLoading$2);

  function SvgLock$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.526 9.197h-.552V7.114a5.187 5.187 0 00-1.457-3.616A4.906 4.906 0 0012 2c-1.32 0-2.584.539-3.517 1.498a5.188 5.188 0 00-1.457 3.616v2.083h-.552c-.391 0-.766.16-1.042.444-.277.284-.432.67-.432 1.071v9.773c0 .402.155.787.432 1.071.276.284.65.444 1.042.444h11.052c.391 0 .766-.16 1.042-.444.277-.284.432-.67.432-1.071v-9.773c0-.402-.155-.787-.432-1.071a1.454 1.454 0 00-1.042-.444zm-7 5.455a1.548 1.548 0 01.195-.76c.128-.23.314-.423.538-.557a1.444 1.444 0 011.475-.004c.225.132.411.324.541.554a1.548 1.548 0 01.002 1.517c-.13.23-.316.422-.54.555v1.725c0 .2-.078.393-.216.536a.727.727 0 01-.521.221.727.727 0 01-.521-.221.769.769 0 01-.216-.536v-1.725a1.49 1.49 0 01-.538-.551c-.13-.23-.198-.49-.199-.755zM8.868 7.114c0-.854.33-1.673.918-2.277A3.089 3.089 0 0112 3.894c.83 0 1.627.34 2.214.943.588.604.918 1.423.918 2.277v1.704c0 .1-.04.197-.108.268a.363.363 0 01-.26.111H9.236a.363.363 0 01-.26-.111.384.384 0 01-.109-.268V7.114z"
    }));
  }

  var ForwardRef$2U = /*#__PURE__*/React__namespace.forwardRef(SvgLock$2);

  function SvgMail$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12 14.556c-.277 0-.542-.115-.738-.32l-8.07-8.475a.459.459 0 01-.1-.447C3.18 5.026 3.437 5 3.666 5h16.666c.229 0 .484.026.575.314a.458.458 0 01-.1.447l-8.072 8.476c-.196.204-.46.32-.737.32zm9.818-7.963a.145.145 0 01.089.01.153.153 0 01.068.058.164.164 0 01.025.089v10.5c0 .464-.176.91-.488 1.237a1.627 1.627 0 01-1.179.513H3.667c-.442 0-.866-.184-1.179-.513A1.795 1.795 0 012 17.25V6.75c0-.031.008-.062.025-.088a.154.154 0 01.067-.06.143.143 0 01.166.035l8.12 8.527c.43.45 1.012.704 1.62.704.607 0 1.19-.253 1.62-.704l8.122-8.527a.15.15 0 01.078-.044z"
    }));
  }

  var ForwardRef$2T = /*#__PURE__*/React__namespace.forwardRef(SvgMail$2);

  function SvgMenu$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 7a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 21a2 2 0 100-4 2 2 0 000 4z"
    }));
  }

  var ForwardRef$2S = /*#__PURE__*/React__namespace.forwardRef(SvgMenu$2);

  function SvgMessage$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M19.5 4h-15A1.5 1.5 0 003 5.5v10.164a1.465 1.465 0 001.5 1.461h1.875v2.625a.75.75 0 001.177.617l4.682-3.242H19.5a1.5 1.5 0 001.5-1.5V5.5A1.5 1.5 0 0019.5 4zm0 11.438a.188.188 0 01-.188.187H12a.75.75 0 00-.427.133l-3.698 2.56v-1.943a.75.75 0 00-.75-.75H4.687a.188.188 0 01-.187-.188v-9.75a.187.187 0 01.188-.187h14.625a.188.188 0 01.187.188v9.75zm-12-5.813h9a.75.75 0 100-1.5h-9a.75.75 0 000 1.5zm9 3.375h-9a.75.75 0 110-1.5h9a.75.75 0 110 1.5z"
    }));
  }

  var ForwardRef$2R = /*#__PURE__*/React__namespace.forwardRef(SvgMessage$2);

  function SvgMicOff$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M18.481 17.306l3.303 3.302-.006-.003a.835.835 0 01-1.17 1.191l-.006-.006L2.216 3.404a.836.836 0 010-1.182.847.847 0 011.182 0l3.443 3.44a.21.21 0 00.349-.09 5.014 5.014 0 019.825 1.414v5.432a4.983 4.983 0 01-.676 2.52.21.21 0 00.033.252l.608.607a.205.205 0 00.255.03.208.208 0 00.066-.066c.633-1 .969-2.16.967-3.343V10.33a.835.835 0 111.672 0v2.09a7.9 7.9 0 01-1.48 4.617.207.207 0 00.021.27zM12 18.686a6.275 6.275 0 01-6.268-6.268v-2.09a.836.836 0 00-1.671 0v2.09a7.951 7.951 0 006.921 7.874.208.208 0 01.182.207v.694a.836.836 0 001.672 0v-.694a.208.208 0 01.182-.207 7.884 7.884 0 003.225-1.17.208.208 0 00.036-.324l-.912-.912a.21.21 0 00-.25-.033 6.225 6.225 0 01-3.117.833zm-4.657-8.82a.209.209 0 00-.357.148v2.404a5.014 5.014 0 007.08 4.569.209.209 0 00.061-.334L7.343 9.866z"
    }));
  }

  var ForwardRef$2Q = /*#__PURE__*/React__namespace.forwardRef(SvgMicOff$2);

  function SvgMicOn$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M15.357 15.763c-.89.79-2.098 1.236-3.357 1.237-1.26-.001-2.467-.446-3.357-1.237-.89-.79-1.392-2.145-1.393-3.263v-6c0-1.119.5-2.473 1.391-3.264C9.532 2.444 10.741 2 12 2c1.26 0 2.468.444 3.359 1.236.89.79 1.391 2.145 1.391 3.264v6c-.001 1.118-.502 2.472-1.393 3.263zm2.936-6.47A1 1 0 0120 10v2.5a8.013 8.013 0 01-6.788 7.908.25.25 0 00-.212.247v.845a1 1 0 01-2 0v-.845a.25.25 0 00-.212-.247A8.013 8.013 0 014 12.5V10a1 1 0 012 0v2.5a6 6 0 1012 0V10a1 1 0 01.293-.707z"
    }));
  }

  var ForwardRef$2P = /*#__PURE__*/React__namespace.forwardRef(SvgMicOn$2);

  function SvgNotification$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.055 19.874l.042-.112c.12-.388.55-.61.96-.496.41.114.645.52.525.908-.336 1.083-1.387 1.826-2.58 1.826s-2.243-.743-2.58-1.826c-.12-.387.115-.794.525-.908a.789.789 0 01.925.403l.036.093c.142.46.588.774 1.094.774.464 0 .877-.265 1.053-.662zM12 2c.392 0 .716.275.767.632l.007.1v1.263c3.396.383 6.02 3.257 6.02 6.728 0 2.416.217 4.125.57 5.24.155.489.284.736.339.817l.023.03c.548.44.218 1.288-.502 1.288H4.775c-.635 0-1-.683-.622-1.166l.027-.039c.1-.15.269-.51.452-1.132.356-1.212.573-2.87.573-5.038 0-3.471 2.625-6.345 6.02-6.728V2.732c0-.404.347-.732.775-.732z"
    }));
  }

  var ForwardRef$2O = /*#__PURE__*/React__namespace.forwardRef(SvgNotification$2);

  function SvgPhone$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5.175 3.69a34.063 34.063 0 0113.65 0A2.775 2.775 0 0121 6.31v1.5a1.875 1.875 0 01-1.875 1.875h-2.25A1.875 1.875 0 0115 7.809V7.2a.19.19 0 00-.174-.19 34.025 34.025 0 00-5.652 0A.19.19 0 009 7.2v.608a1.875 1.875 0 01-1.875 1.875h-2.25A1.875 1.875 0 013 7.808v-1.5a2.775 2.775 0 012.175-2.617zm4.013 8.498a1.312 1.312 0 11-2.625 0 1.312 1.312 0 012.625 0zm-1.313 5.063a1.312 1.312 0 100-2.625 1.312 1.312 0 000 2.625zm1.313 2.436a1.312 1.312 0 11-2.625 0 1.312 1.312 0 012.625 0zM12 13.502a1.312 1.312 0 100-2.625 1.312 1.312 0 000 2.625zm1.313 2.437a1.312 1.312 0 11-2.625 0 1.312 1.312 0 012.624 0zM12 21a1.312 1.312 0 100-2.625A1.312 1.312 0 0012 21zm5.438-8.812a1.312 1.312 0 11-2.625 0 1.312 1.312 0 012.624 0zm-1.313 5.063a1.312 1.312 0 100-2.625 1.312 1.312 0 000 2.625zm1.313 2.436a1.312 1.312 0 11-2.625 0 1.312 1.312 0 012.624 0z"
    }));
  }

  var ForwardRef$2N = /*#__PURE__*/React__namespace.forwardRef(SvgPhone$1);

  function SvgPin$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a7.03 7.03 0 00-4.947 2.04A6.943 6.943 0 005 8.957c0 3.052 4.375 9.587 6.255 12.63A.873.873 0 0012 22a.871.871 0 00.745-.415C14.625 18.545 19 12.012 19 8.957a6.942 6.942 0 00-2.053-4.917A7.03 7.03 0 0012 2zm0 10a3.076 3.076 0 01-1.701-.513 3.048 3.048 0 01-1.128-1.366 3.026 3.026 0 01.663-3.317 3.08 3.08 0 013.338-.66c.56.231 1.038.621 1.374 1.122a3.03 3.03 0 01-.38 3.843A3.072 3.072 0 0112 12z"
    }));
  }

  var ForwardRef$2M = /*#__PURE__*/React__namespace.forwardRef(SvgPin$2);

  function SvgPortraitFrame$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M4.28 9.305A.75.75 0 013 8.775V4.468A1.47 1.47 0 014.468 3h4.307a.75.75 0 010 1.5h-3.93a.375.375 0 00-.375.375l.03 3.9a.75.75 0 01-.22.53zm.595 10.224l3.9-.029a.75.75 0 110 1.5H4.468A1.47 1.47 0 013 19.532V15.23a.75.75 0 111.5 0v3.925a.375.375 0 00.375.375zm15.375-5.05a.75.75 0 00-.75.75l.03 3.893a.375.375 0 01-.375.375h-3.93a.75.75 0 100 1.5h4.304A1.47 1.47 0 0021 19.532V15.23a.75.75 0 00-.75-.75zM15.225 3h4.307A1.469 1.469 0 0121 4.468v4.307a.75.75 0 01-1.5 0v-3.93a.375.375 0 00-.375-.374l-3.9.029a.75.75 0 010-1.5zm-7.72 13.374a.79.79 0 00.783.876h7.575a.635.635 0 00.462-.2.627.627 0 00.175-.475 4.517 4.517 0 00-8.993-.202l-.002.001zM14.618 9a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
    }));
  }

  var ForwardRef$2L = /*#__PURE__*/React__namespace.forwardRef(SvgPortraitFrame$2);

  function SvgQuestion$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm0 15.833a1.25 1.25 0 110-2.501 1.25 1.25 0 010 2.501zm1.333-5.066a.834.834 0 00-.5.764.834.834 0 01-1.666 0 2.5 2.5 0 011.5-2.292 1.667 1.667 0 10-2.334-1.527.834.834 0 01-1.666 0 3.333 3.333 0 114.666 3.056v-.001z"
    }));
  }

  var ForwardRef$2K = /*#__PURE__*/React__namespace.forwardRef(SvgQuestion$2);

  function SvgRadioOff$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
    }));
  }

  var ForwardRef$2J = /*#__PURE__*/React__namespace.forwardRef(SvgRadioOff$1);

  function SvgRadioOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM12 6a6 6 0 106 6 6.007 6.007 0 00-6-6z"
    }));
  }

  var ForwardRef$2I = /*#__PURE__*/React__namespace.forwardRef(SvgRadioOn$1);

  function SvgRefresh$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M10.376 5.293c-1.238.3-2.37.938-3.27 1.84a6.95 6.95 0 00-1.698 7.008.21.21 0 00.316.111l1.126-.74a.84.84 0 011.285.871l-.768 3.703a.84.84 0 01-.991.655l-3.704-.763a.84.84 0 01-.292-1.526l1.176-.775a.208.208 0 00.08-.252A9.035 9.035 0 0114.763 3.43a1.05 1.05 0 11-.639 2 6.92 6.92 0 00-3.749-.137zm11.393 1.123a.84.84 0 01.218.436.84.84 0 01-.38.859l-1.131.71a.208.208 0 00-.084.253A9.034 9.034 0 019.337 20.667a1.051 1.051 0 11.62-2.007A6.932 6.932 0 0018.6 9.9a.211.211 0 00-.128-.134.208.208 0 00-.184.023l-1.212.761a.84.84 0 01-1.267-.898l.84-3.687a.841.841 0 011.01-.632l3.687.84a.84.84 0 01.423.243z"
    }));
  }

  var ForwardRef$2H = /*#__PURE__*/React__namespace.forwardRef(SvgRefresh$1);

  function SvgRemove$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7 11a1 1 0 100 2h10a1 1 0 100-2H7z"
    }));
  }

  var ForwardRef$2G = /*#__PURE__*/React__namespace.forwardRef(SvgRemove$1);

  function SvgRemoveRound$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM6 12a1 1 0 011-1h10a1 1 0 110 2H7a1 1 0 01-1-1z"
    }));
  }

  var ForwardRef$2F = /*#__PURE__*/React__namespace.forwardRef(SvgRemoveRound$1);

  function SvgSearch$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.725 19.375l-4.988-4.988a7.093 7.093 0 10-1.35 1.35l4.988 4.988a.967.967 0 001.35 0 .956.956 0 000-1.35zM4.962 10.116a5.157 5.157 0 115.156 5.157 5.163 5.163 0 01-5.156-5.157z"
    }));
  }

  var ForwardRef$2E = /*#__PURE__*/React__namespace.forwardRef(SvgSearch$2);

  function SvgShare$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M14.95 15.553l-5.242-2.621.068-.37c.033-.185.053-.373.057-.562a3.612 3.612 0 00-.057-.563l-.068-.369 5.24-2.62.255.262a3.659 3.659 0 10-1.036-2.55c.004.192.023.382.057.57l.068.37L9.05 9.719l-.255-.264a3.667 3.667 0 100 5.09l.255-.265 5.242 2.62-.068.37a3.617 3.617 0 00-.057.568 3.667 3.667 0 103.667-3.671 3.647 3.647 0 00-2.628 1.12l-.255.266z"
    }));
  }

  var ForwardRef$2D = /*#__PURE__*/React__namespace.forwardRef(SvgShare$2);

  function SvgSun$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M7.8 11.976a4.2 4.2 0 118.4 0 4.2 4.2 0 01-8.4 0zM12 2.976a.6.6 0 01.6.6v2.4a.6.6 0 11-1.2 0v-2.4a.6.6 0 01.6-.6zM12 17.376a.6.6 0 01.6.6v2.4a.6.6 0 01-1.2 0v-2.4a.6.6 0 01.6-.6zM17.4 11.976a.6.6 0 01.6-.6h2.4a.6.6 0 110 1.2H18a.6.6 0 01-.6-.6zM3 11.976a.6.6 0 01.6-.6H6a.6.6 0 110 1.2H3.6a.6.6 0 01-.6-.6zM18.363 5.612a.6.6 0 010 .849l-1.696 1.697a.6.6 0 11-.849-.849l1.697-1.697a.6.6 0 01.848 0zM8.181 15.795a.6.6 0 010 .848L6.484 18.34a.6.6 0 01-.848-.848l1.696-1.697a.6.6 0 01.849 0zM15.818 15.795a.6.6 0 01.849 0l1.696 1.697a.6.6 0 01-.848.848l-1.697-1.697a.6.6 0 010-.848zM5.636 5.612a.6.6 0 01.848 0L8.181 7.31a.6.6 0 01-.848.849L5.635 6.46a.6.6 0 010-.849z"
    }));
  }

  var ForwardRef$2C = /*#__PURE__*/React__namespace.forwardRef(SvgSun$2);

  function SvgTelemedicine$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#telemedicine_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M7.815 18.209a2.796 2.796 0 01-.276-.397.376.376 0 00-.325-.188H4.875a.375.375 0 01-.375-.374V5.625a.375.375 0 01.375-.375h8.25a.375.375 0 01.375.375v1.32a.375.375 0 00.375.374c.224 0 .447.025.665.075a.375.375 0 00.46-.367V5.25A2.257 2.257 0 0012.75 3h-7.5A2.257 2.257 0 003 5.25v13.5A2.257 2.257 0 005.25 21h4.084a.374.374 0 00.288-.615l-1.807-2.176zm.247-5.834h1.125a.566.566 0 00.563-.563v-.75a.187.187 0 01.187-.187h.75a.187.187 0 00.188-.188v-.367c0-.396.08-.788.236-1.151a.375.375 0 00-.172-.48.54.54 0 00-.252-.064h-.75a.188.188 0 01-.187-.188v-.75a.566.566 0 00-.563-.563H8.062a.566.566 0 00-.562.563v.75a.188.188 0 01-.188.187h-.75A.566.566 0 006 9.187v1.125a.566.566 0 00.562.562h.75a.188.188 0 01.188.188v.75a.566.566 0 00.562.563zm7.688 1.875h1.5A3.754 3.754 0 0121 18v2.25a.75.75 0 01-1.5 0V18a2.25 2.25 0 00-2.25-2.25H15a.75.75 0 01-.75-.75v-4.875a.375.375 0 10-.75 0v7.369a.75.75 0 01-1.327.48l-1.76-2.117a.375.375 0 00-.577.479l2.854 3.434a.748.748 0 01-.097 1.056.753.753 0 01-1.057-.096l-2.854-3.434a1.876 1.876 0 012.884-2.4l.434.524v-5.295a1.875 1.875 0 013.75 0v4.125z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "telemedicine_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2B = /*#__PURE__*/React__namespace.forwardRef(SvgTelemedicine$1);

  function SvgTerms$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.125 3H4.875A1.875 1.875 0 003 4.875v14.25A1.875 1.875 0 004.875 21h14.25A1.875 1.875 0 0021 19.125V4.875A1.875 1.875 0 0019.125 3zm-2.25 7.125H13.5a.75.75 0 110-1.5h3.375a.75.75 0 110 1.5zm.75 6a.75.75 0 01-.75.75H13.5a.75.75 0 110-1.5h3.375a.75.75 0 01.75.75zM11.475 7.2l-2.25 3a.75.75 0 01-.547.3h-.053a.75.75 0 01-.53-.22L6.97 9.155a.75.75 0 011.06-1.061l.514.514L10.275 6.3a.75.75 0 111.2.9zm0 7.5l-2.25 3a.763.763 0 01-1.13.08L6.97 16.655a.75.75 0 011.06-1.06l.514.513 1.731-2.308a.75.75 0 011.2.9z"
    }));
  }

  var ForwardRef$2A = /*#__PURE__*/React__namespace.forwardRef(SvgTerms$2);

  function SvgTrashBin$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M16.542 5.333H20.5A.833.833 0 0120.5 7H3.833a.833.833 0 010-1.667h3.959A.208.208 0 008 5.125V4.083A2.083 2.083 0 0110.083 2h4.167a2.083 2.083 0 012.083 2.083v1.042a.208.208 0 00.209.208zm-6.875-1.25v1.042a.208.208 0 00.208.208h4.583a.208.208 0 00.209-.208V4.083a.417.417 0 00-.417-.416h-4.167a.417.417 0 00-.416.416zM5.956 8.25h12.42a.416.416 0 01.416.454l-1.071 11.78A1.667 1.667 0 0116.06 22H8.27a1.667 1.667 0 01-1.66-1.516L5.54 8.704a.417.417 0 01.417-.454zm4.571 11.275a.625.625 0 00.183-.442v-7.5a.625.625 0 10-1.25 0v7.5a.625.625 0 001.067.442zm4.167 0a.625.625 0 00.183-.442v-7.5a.625.625 0 00-1.25 0v7.5a.625.625 0 001.067.442z"
    }));
  }

  var ForwardRef$2z = /*#__PURE__*/React__namespace.forwardRef(SvgTrashBin$2);

  function SvgTweezer$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#tweezer_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21 4.015a1.015 1.015 0 00-1.65-.79L8.209 12.253a.189.189 0 01-.294-.08 2.538 2.538 0 00-4.466-.54 2.537 2.537 0 002.096 3.978 2.68 2.68 0 001.602-.568l3.845-3.116a.376.376 0 01.5.024l.553.542a.375.375 0 01.028.504L8.95 16.846a2.686 2.686 0 00-.568 1.6 2.54 2.54 0 002.693 2.55 2.545 2.545 0 002.377-2.847 2.542 2.542 0 00-1.63-2.07.188.188 0 01-.08-.294l9.035-11.132c.146-.18.226-.406.225-.638zM4.5 13.07a1.043 1.043 0 112.087-.002 1.043 1.043 0 01-2.086.002zm7.469 5.376a1.043 1.043 0 11-2.086.003 1.043 1.043 0 012.086-.003zm1.527-7.202a.374.374 0 01-.554.032l-.217-.214a.375.375 0 01.026-.56l2.536-2.055a.187.187 0 01.264.263l-2.055 2.534z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "tweezer_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2y = /*#__PURE__*/React__namespace.forwardRef(SvgTweezer$1);

  function SvgUser$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M16.342 7.4c0 2.43-1.944 4.4-4.342 4.4-2.398 0-4.342-1.97-4.342-4.4C7.658 4.97 9.602 3 12 3c2.398 0 4.342 1.97 4.342 4.4zM6.7 15.229A7.459 7.459 0 0112 13a7.46 7.46 0 015.3 2.229 7.66 7.66 0 012.2 5.371.403.403 0 01-.116.283.392.392 0 01-.279.117H4.895a.392.392 0 01-.28-.117.403.403 0 01-.115-.283 7.66 7.66 0 012.2-5.371z"
    }));
  }

  var ForwardRef$2x = /*#__PURE__*/React__namespace.forwardRef(SvgUser$2);

  function SvgVaccines$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M15.938 4.562l-.676-.675a.955.955 0 011.35-1.35l4.726 4.725a.955.955 0 01-1.35 1.35l-.675-.675a.477.477 0 00-.675 0l-.338.338a.477.477 0 01-.675 0L15.6 6.25a.477.477 0 010-.675l.338-.338a.477.477 0 000-.675zm-4.726-.675l8.776 8.775a.955.955 0 11-1.35 1.35l-1.52-1.518a.24.24 0 00-.337 0l-5.568 5.569A4.296 4.296 0 016.63 19.14a.239.239 0 00-.258.051l-1.91 1.91a1.193 1.193 0 11-1.687-1.688l1.91-1.91a.238.238 0 00.052-.257 4.296 4.296 0 011.075-4.585l.506-.506a.477.477 0 01.675 0l2.025 2.025a.716.716 0 101.012-1.012l-2.025-2.025a.477.477 0 010-.675L9.02 9.456a.477.477 0 01.675 0l2.025 2.025a.716.716 0 101.012-1.012l-2.025-2.025a.477.477 0 010-.675l.675-.675a.239.239 0 00.001-.337l-1.52-1.52a.955.955 0 011.35-1.35z"
    }));
  }

  var ForwardRef$2w = /*#__PURE__*/React__namespace.forwardRef(SvgVaccines$2);

  function SvgViewOff$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M17.868 7.762a17.744 17.744 0 013.658 3c.304.331.473.76.474 1.206.001.446-.166.876-.469 1.209-2.179 2.347-5.78 4.833-9.4 4.833h-.255a9.745 9.745 0 01-3.667-.782l-3.527 3.455a.864.864 0 01-1.073.103.835.835 0 01-.34-.45.817.817 0 01.026-.56.046.046 0 01.012-.008.05.05 0 00.01-.006l16.588-16.25a.612.612 0 00.147-.243l.015-.015A.852.852 0 0120.672 3a.866.866 0 01.609.244.83.83 0 01.249.597.817.817 0 01-.26.592l-3.402 3.329zm-3.16 6.838c.445-.44.774-.979.959-1.57a3.516 3.516 0 00-.171-2.551.21.21 0 00-.158-.116.22.22 0 00-.188.06l-4.73 4.632a.21.21 0 00-.06.184.207.207 0 00.118.155c.828.373 1.768.43 2.637.159a3.912 3.912 0 001.594-.953zm-6.386-1.556a.202.202 0 01-.054.093l-2.59 2.542a.22.22 0 01-.278.024 17.93 17.93 0 01-2.924-2.525A1.771 1.771 0 012 11.968c.001-.446.173-.877.482-1.206 2.2-2.375 5.858-4.881 9.516-4.833a9.028 9.028 0 012.757.415.216.216 0 01.143.152.209.209 0 01-.058.199L13.19 8.313a.209.209 0 01-.204.052 3.707 3.707 0 00-.987-.144 3.869 3.869 0 00-2.707 1.098 3.712 3.712 0 00-1.121 2.652c.005.327.055.652.15.966a.2.2 0 01.002.107z"
    }));
  }

  var ForwardRef$2v = /*#__PURE__*/React__namespace.forwardRef(SvgViewOff$2);

  function SvgViewOn$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12 6c3.667-.05 7.325 2.513 9.53 4.94a1.843 1.843 0 01.002 2.456c-2.182 2.4-5.786 4.942-9.41 4.942h-.257c-3.611 0-7.217-2.541-9.396-4.941a1.843 1.843 0 010-2.458C4.674 8.514 8.331 5.95 12 6.001zM8.81 10.04a3.835 3.835 0 106.377 4.26 3.835 3.835 0 00-6.377-4.26zm2.01 3.309a1.667 1.667 0 112.357-2.358 1.667 1.667 0 01-2.358 2.357z"
    }));
  }

  var ForwardRef$2u = /*#__PURE__*/React__namespace.forwardRef(SvgViewOn$2);

  function SvgWarning$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M22 11.828a10.04 10.04 0 00-2.965-7.011 9.707 9.707 0 00-7.05-2.815 10.172 10.172 0 00-7.092 3.045 9.837 9.837 0 00-2.892 7.13 9.817 9.817 0 009.835 9.827h.18A10.093 10.093 0 0022 11.828zM10.79 7.156a1.211 1.211 0 012.421 0v5.45a1.211 1.211 0 01-2.421 0v-5.45zm1.237 10.927h-.026a1.514 1.514 0 01-.026-3.027h.026a1.514 1.514 0 11.024 3.027h.002z"
    }));
  }

  var ForwardRef$2t = /*#__PURE__*/React__namespace.forwardRef(SvgWarning$2);

  function SvgWhatsapp$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2a9.963 9.963 0 00-7.045 2.923A10.11 10.11 0 002 11.997a9.904 9.904 0 001.783 5.683l-1.125 3.357a.423.423 0 00.525.538l3.5-1.117a9.941 9.941 0 0010.125.3 10.032 10.032 0 003.78-3.669c.912-1.54 1.4-3.298 1.412-5.092a10.11 10.11 0 00-2.955-7.074A9.963 9.963 0 0012 2zm6 14.035c-.279.534-.699.98-1.213 1.29a3.24 3.24 0 01-1.704.464 8.878 8.878 0 01-2.875-.84 11.692 11.692 0 01-4.958-4.33c-1.592-2.124-1.667-4.114-.133-5.759a1.805 1.805 0 011.55-.47 1.278 1.278 0 011.008.73l.317.773.525 1.267a.93.93 0 010 .84 4.315 4.315 0 01-.834 1.15c.428.656.929 1.261 1.492 1.804a7.538 7.538 0 002.275 1.368c.233-.302.692-.84.833-1.066a.834.834 0 011.117-.302c.317.118 2.092.99 2.092.99.225.078.422.22.566.412A1.687 1.687 0 0118 16.035z"
    }));
  }

  var ForwardRef$2s = /*#__PURE__*/React__namespace.forwardRef(SvgWhatsapp$2);

  function SvgWifi$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 21.482a3.129 3.129 0 01-3.125-3.125A3.129 3.129 0 0112 15.232a3.129 3.129 0 013.125 3.125A3.129 3.129 0 0112 21.482z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.058 8.829h0a.776.776 0 01.038-1.096h0a14.477 14.477 0 019.905-3.883c3.7 0 7.217 1.38 9.904 3.883h0c.312.292.33.782.039 1.095h0a.778.778 0 01-1.095.04h0A12.924 12.924 0 0012 5.399a12.927 12.927 0 00-8.848 3.468l-1.095-.038zm0 0a.778.778 0 00.567.246m-.567-.246l.567.246m0 0a.772.772 0 00.528-.208l-.528.208zm13.792 5.638a.769.769 0 01-.548-.228 5.439 5.439 0 00-3.872-1.6 5.44 5.44 0 00-3.871 1.6l8.29.228zm0 0a.773.773 0 00.548-1.323 6.98 6.98 0 00-4.968-2.054A6.977 6.977 0 007.03 13.39a.77.77 0 000 1.096.77.77 0 001.096 0l8.29.227zm2.106-2.88a.769.769 0 00.548.228.77.77 0 00.548-.228.769.769 0 00.227-.547.769.769 0 00-.227-.548A10.704 10.704 0 0012 7.588a10.7 10.7 0 00-7.619 3.15.77.77 0 000 1.095.77.77 0 001.096 0A9.164 9.164 0 0112 9.138c2.467 0 4.783.958 6.523 2.696z",
      stroke: "currentcolor",
      strokeWidth: 0.3
    }));
  }

  var ForwardRef$2r = /*#__PURE__*/React__namespace.forwardRef(SvgWifi$1);

  function SvgXRay$2(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.875 3H4.125A1.125 1.125 0 003 4.125v15.75A1.125 1.125 0 004.125 21h15.75A1.125 1.125 0 0021 19.875V4.125A1.125 1.125 0 0019.875 3zm-1.668 7.275a.75.75 0 01-1.055.11 7.842 7.842 0 00-3.984-1.504.375.375 0 00-.418.375v1.111a.376.376 0 00.341.375c.704.061 1.4.189 2.079.382.522.15 1.03.344 1.519.581a.75.75 0 11-.659 1.35 7.94 7.94 0 00-1.275-.487 9.449 9.449 0 00-1.586-.31.375.375 0 00-.416.376v.928a.375.375 0 00.341.375c.704.06 1.4.188 2.079.381a.75.75 0 01-.209 1.471.773.773 0 01-.212-.039 9.534 9.534 0 00-1.586-.31.376.376 0 00-.416.375v1.998a.75.75 0 11-1.5 0v-1.998a.376.376 0 00-.416-.375 9.534 9.534 0 00-1.586.31.75.75 0 01-.417-1.441 11.072 11.072 0 012.078-.382.376.376 0 00.341-.375v-.925a.376.376 0 00-.417-.375 9.462 9.462 0 00-1.585.309 7.939 7.939 0 00-1.275.488.75.75 0 11-.659-1.35 9.412 9.412 0 011.52-.582 11.066 11.066 0 012.078-.382.375.375 0 00.341-.374V9.25a.377.377 0 00-.418-.375 7.843 7.843 0 00-3.988 1.507.75.75 0 01-.945-1.165 9.34 9.34 0 015.007-1.852.375.375 0 00.341-.375V5.813a.75.75 0 111.5 0v1.18a.375.375 0 00.341.375 9.34 9.34 0 015.007 1.852.75.75 0 01.109 1.055z"
    }));
  }

  var ForwardRef$2q = /*#__PURE__*/React__namespace.forwardRef(SvgXRay$2);

  function SvgAdd$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#add_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 13h8v-2h-8V3h-2v8H3v2h8v8h2v-8z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "add_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2p = /*#__PURE__*/React__namespace.forwardRef(SvgAdd$1);

  function SvgAgExams$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#ag-exams_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10h5V6h-2v1a1 1 0 11-2 0V6H9v1a1 1 0 01-2 0V6H5v11h8v-5h-1v-2zm1.126 9H5a2 2 0 01-2-2V4h4V2h2v2h4V2h2v2h4v6h3v2h-1v6a4 4 0 01-7.874 1zM19 12h-4v3h4v-3z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "ag-exams_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2o = /*#__PURE__*/React__namespace.forwardRef(SvgAgExams$1);

  function SvgArrowLeft$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-left_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.293 4.293l-7 7a1 1 0 000 1.414l7 7 1.414-1.414L6.414 13H21v-2H6.414l5.293-5.293-1.414-1.414z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-left_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2n = /*#__PURE__*/React__namespace.forwardRef(SvgArrowLeft$1);

  function SvgCake$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#cake_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 12.001V9a2 2 0 00-2-2H5a2 2 0 00-2 2v12h18v-8.999zm-2 2.855A3.363 3.363 0 0118 15c-1.319 0-2.29-.645-2.903-1.24C14.476 14.42 13.482 15 12 15c-1.487 0-2.482-.583-3.104-1.246C8.286 14.346 7.312 15 6 15c-.364 0-.697-.051-1-.147V19h14v-4.144zM5 11.98a1.516 1.516 0 00.02.155c.022.124.064.274.134.413a.794.794 0 00.261.31c.1.067.272.143.585.143.621 0 1.133-.313 1.533-.71a3.72 3.72 0 00.579-.75l.002-.005v.002l-.001.001v.002l1.855.217h.002v-.004l-.002-.003-.001-.005v-.003l.006.023c.01.026.026.072.053.13.055.12.147.284.29.447.26.298.742.658 1.684.658s1.424-.36 1.685-.659a1.864 1.864 0 00.342-.576l.007-.023v.003l-.002.005-.001.003v.003l.001.001 1.86-.204h.002v-.001l.021.038a3.562 3.562 0 00.542.703c.391.39.902.707 1.543.707.325 0 .502-.078.602-.145a.758.758 0 00.254-.302 1.464 1.464 0 00.143-.538L19 11.99V9H5v2.98zm10.894-.427l-.002-.004.001.002v.002h.001zM17 5c-.068 0-.15-.007-.241-.02-1.369-.195-1.35-1.594-.583-2.743l.408-.613a.5.5 0 01.832 0l.408.613c.767 1.15.785 2.548-.583 2.743-.09.013-.173.02-.241.02zm-5.242-.02c.092.013.174.02.242.02s.15-.007.242-.02c1.367-.195 1.349-1.594.582-2.743l-.408-.613a.5.5 0 00-.832 0l-.408.613c-.767 1.15-.786 2.548.582 2.743zM7 5c-.068 0-.15-.007-.241-.02-1.369-.195-1.35-1.594-.583-2.743l.408-.613a.5.5 0 01.832 0l.408.613c.767 1.15.786 2.548-.583 2.743-.09.013-.173.02-.241.02z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "cake_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2m = /*#__PURE__*/React__namespace.forwardRef(SvgCake$1);

  function SvgCalendar$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#calendar_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 6h2v1a1 1 0 102 0V6h6v1a1 1 0 102 0V6h2v13H5V6zm12-2h4v15a2 2 0 01-2 2H5a2 2 0 01-2-2V4h4V2h2v2h6V2h2v2zm-8 8v-2H7v2h2zm0 2v2H7v-2h2zm4 2v-2h-2v2h2zm4-2v2h-2v-2h2zm0-2v-2h-2v2h2zm-4-2v2h-2v-2h2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "calendar_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2l = /*#__PURE__*/React__namespace.forwardRef(SvgCalendar$1);

  function SvgCall$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#call_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.199 5.68c-.398.484-.654.926-.752 1.217-.237.706-.662 4.317 3.353 8.062 2.035 1.898 3.948 2.8 5.417 3.198 1.516.411 2.496.274 2.68.209.234-.083.64-.306 1.134-.673.454-.338.933-.76 1.354-1.22a902.175 902.175 0 00-2.698-2.591l-1.511 1.511-.416.419-.568-.162c-.29-.083-2.328-.68-4.175-2.527-.927-.926-1.412-1.761-1.659-2.448a3.995 3.995 0 01-.21-.873c-.027-.213-.028-.433-.027-.411l-.023-.455.328-.315c.116-.112.89-.887 1.496-1.494l-2.528-2.6c-.418.31-.84.72-1.195 1.153zM4.653 4.41a8.8 8.8 0 011.713-1.607c.826-.575 1.83-.32 2.406.272.682.7 1.846 1.899 2.585 2.66a1.998 1.998 0 01-.018 2.804l-1.18 1.18c.017.081.043.173.081.28.135.376.446.965 1.19 1.71a8.387 8.387 0 002.771 1.83l1.072-1.072a1.997 1.997 0 012.795-.032c.759.727 1.965 1.882 2.753 2.645.7.676.85 1.84.124 2.65a11.842 11.842 0 01-1.72 1.568c-.564.419-1.156.775-1.663.954-.702.248-2.127.308-3.869-.165-1.788-.485-3.988-1.55-6.257-3.666C2.842 12.137 3.066 7.703 3.55 6.26c.206-.612.627-1.27 1.102-1.848z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "call_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2k = /*#__PURE__*/React__namespace.forwardRef(SvgCall$1);

  function SvgCamera$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#camera_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.908 8H4v10h16V8h-4.658l-.597-.683L13.593 6h-2.935L9.505 7.317 8.908 8zm7.342-2l-1.451-1.659A1 1 0 0014.046 4h-3.842a1 1 0 00-.753.341L8 6H3a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V7a1 1 0 00-1-1h-4.75zM12 15a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zm6-8a1 1 0 100 2 1 1 0 000-2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "camera_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2j = /*#__PURE__*/React__namespace.forwardRef(SvgCamera$1);

  function SvgCameraOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#camera-on_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.44 11.761L20 10.505v4.216l-2.689-.88-.622 1.9 4 1.31 1.31-.95V8.9l-1.44-.899-4 1.964.882 1.795zM3 7a1 1 0 00-1 1v9a1 1 0 001 1h13V7H3zm1 9V9h10v7H4z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "camera-on_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2i = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOn$1);

  function SvgCar$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#car_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.78 12H8c-1.328 0-2.168.33-2.713.738-.548.411-.886.97-1.088 1.578A5.58 5.58 0 003.938 16H5.17a3.001 3.001 0 015.658 0h2.342a3.001 3.001 0 015.658 0H20v-1c0-1.127-.13-2.125-.36-3H8.78zm.764-2h9.293C17.657 7.94 15.762 7 14 7c-1.378 0-2.55.72-3.46 1.686-.41.436-.743.896-.996 1.314zM3 18h2.17a3.001 3.001 0 005.66 0h2.34a3.001 3.001 0 005.66 0H21a1 1 0 001-1v-2c0-6.423-3.826-10-8-10-2.122 0-3.784 1.113-4.915 2.314-.84.891-1.456 1.902-1.802 2.713-1.328.104-2.381.5-3.196 1.11-.95.714-1.488 1.655-1.786 2.547-.295.885-.364 1.75-.364 2.379a8.236 8.236 0 00.071 1.069l.004.02v.008l.001.002v.001L3 17l-.986.164A1 1 0 003 18zm13 0a1 1 0 100-2 1 1 0 000 2zm-7-1a1 1 0 10-2 0 1 1 0 002 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "car_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2h = /*#__PURE__*/React__namespace.forwardRef(SvgCar$1);

  function SvgCheckRound$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#check-round_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-5.3-1.287l.714-.7-1.401-1.427-.714.7-4.39 4.312-2.208-2.169-.714-.7-1.401 1.427.713.7 2.91 2.857.7.689.701-.689 5.09-5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "check-round_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2g = /*#__PURE__*/React__namespace.forwardRef(SvgCheckRound$1);

  function SvgChevronDown$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-down_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.293 16.707l-8-8 1.414-1.414L12 14.586l7.293-7.293 1.414 1.414-8 8a1 1 0 01-1.414 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-down_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2f = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDown$1);

  function SvgChevronLeft$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-left_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.293 11.293l8-8 1.414 1.414L9.414 12l7.293 7.293-1.414 1.414-8-8a1 1 0 010-1.414z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-left_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2e = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeft$1);

  function SvgChevronRight$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-right_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.707 12.707l-8 8-1.414-1.414L14.586 12 7.293 4.707l1.414-1.414 8 8a1 1 0 010 1.414z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-right_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2d = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRight$1);

  function SvgChevronUp$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-up_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.707 7.293l8 8-1.414 1.414L12 9.414l-7.293 7.293-1.414-1.414 8-8a1 1 0 011.414 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-up_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2c = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUp$1);

  function SvgClinic(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#clinic_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.707 1.293a1 1 0 00-1.414 0l-10 10 1.414 1.414L4 11.414V20a2 2 0 002 2h12a2 2 0 002-2v-8.586l1.293 1.293 1.414-1.414-10-10zM18 9.414l-6-6-6 6V20h12V9.414zM11 10v3H8v2h3v3h2v-3h3v-2h-3v-3h-2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "clinic_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2b = /*#__PURE__*/React__namespace.forwardRef(SvgClinic);

  function SvgClock$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#clock_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM11 7v6h6v-2h-4V7h-2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "clock_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$2a = /*#__PURE__*/React__namespace.forwardRef(SvgClock$1);

  function SvgClose$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#close_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10.586L5.636 4.222 4.222 5.636 10.586 12l-6.364 6.364 1.414 1.414L12 13.414l6.364 6.364 1.414-1.414L13.414 12l6.364-6.364-1.414-1.414L12 10.586z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "close_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$29 = /*#__PURE__*/React__namespace.forwardRef(SvgClose$1);

  function SvgCompanion(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#companion_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.445 17.914C13.017 16.374 14.1 15 16 15c1.523 0 2.49.856 3.128 1.99.659 1.17.872 2.5.872 3.01h2c0-.823-.287-2.494-1.128-3.99C20.009 14.477 18.477 13 16 13c-2.559 0-4.08 1.547-4.937 3.134A4.65 4.65 0 008 15c-1.705 0-2.971.863-3.78 1.875C3.434 17.855 3 19.07 3 20h2c0-.404.232-1.189.78-1.875C6.306 17.47 7.039 17 8 17c.962 0 1.695.47 2.22 1.125.548.686.78 1.471.78 1.875h2c0-.62-.193-1.367-.555-2.086zM8 12a1 1 0 100-2 1 1 0 000 2zm0 2a3 3 0 100-6 3 3 0 000 6zm10-6a2 2 0 11-4 0 2 2 0 014 0zm2 0a4 4 0 11-8 0 4 4 0 018 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "companion_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$28 = /*#__PURE__*/React__namespace.forwardRef(SvgCompanion);

  function SvgCross(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#cross_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 21a2 2 0 01-2-2v-4H5a2 2 0 01-2-2v-2a2 2 0 012-2h4V5a2 2 0 012-2h2a2 2 0 012 2v4h4a2 2 0 012 2v2a2 2 0 01-2 2h-4v4a2 2 0 01-2 2h-2zm0-8H5v-2h6V5h2v6h6v2h-6v6h-2v-6z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "cross_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$27 = /*#__PURE__*/React__namespace.forwardRef(SvgCross);

  function SvgDoctor$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#doctor_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 13.005v6h8v-6h-8zm-2 7V13h-.21A3.79 3.79 0 005 16.79H3A5.79 5.79 0 018.79 11h1.594v.005H20a1 1 0 011 1v8a1 1 0 01-1 1H10a1 1 0 01-1-1zM10 6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm2 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm1 10.255h1.25v1.25h1.5v-1.25H17v-1.5h-1.25v-1.25h-1.5v1.25H13v1.5zm1-5.75c0-.66.09-.907.13-.98a.98.98 0 01.154-.02c.124-.008.236-.006.385-.003a17.884 17.884 0 00.661 0c.15-.003.262-.005.386.003a.98.98 0 01.155.02c.039.073.129.32.129.98h2c0-1.146-.214-2.155-1.06-2.679-.386-.238-.793-.298-1.1-.317-.201-.013-.446-.009-.643-.006a13.924 13.924 0 01-.394 0c-.197-.003-.442-.007-.644.006-.306.02-.714.079-1.1.317C12.215 8.85 12 9.86 12 11.006h2zm.147-1.007l-.006.007.006-.007zm1.706 0l.006.007-.006-.007z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "doctor_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$26 = /*#__PURE__*/React__namespace.forwardRef(SvgDoctor$1);

  function SvgDownload(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#download_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 19a2 2 0 002 2h14a2 2 0 002-2v-3h-2v3H5v-3H3v3zm8.293-2.293l-5-5 1.414-1.414L11 13.586V3h2v10.586l3.293-3.293 1.414 1.414-5 5a1 1 0 01-1.414 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "download_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$25 = /*#__PURE__*/React__namespace.forwardRef(SvgDownload);

  function SvgEdit$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#edit_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 13v-1.172l6-6L18.172 7l-6 6H11zm-2-2l6.586-6.586L17 3l1.414 1.414 1.172 1.172L21 7l-1.414 1.414L13 15H9v-4zM5 5a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-2v6H5V7h6V5H5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "edit_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$24 = /*#__PURE__*/React__namespace.forwardRef(SvgEdit$1);

  function SvgExams$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#exams_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.252 20.194C15.672 21.467 13.69 22 12 22s-3.672-.533-5.252-1.806C5.134 18.894 4 16.867 4 14.046c0-1.482.51-2.966 1.205-4.313.7-1.356 1.62-2.639 2.522-3.737a34.049 34.049 0 013.533-3.678l.087-.075.001-.001h1.305l.087.076c.055.049.134.119.233.21a34.06 34.06 0 013.3 3.468c.902 1.098 1.823 2.381 2.522 3.737C19.49 11.08 20 12.563 20 14.046c0 2.82-1.134 4.847-2.748 6.148zm-4.6-17.953a1 1 0 00-1.303 0h1.302zM12 4.352a32.066 32.066 0 00-2.727 2.913c-.848 1.033-1.677 2.196-2.29 3.385C6.364 11.846 6 13.005 6 14.046c0 2.224.866 3.675 2.003 4.59C9.172 19.578 10.69 20 12 20s2.828-.422 3.998-1.364C17.134 17.721 18 16.27 18 14.046c0-1.041-.365-2.2-.982-3.396-.614-1.189-1.443-2.352-2.29-3.385A32.034 32.034 0 0012 4.352z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "exams_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$23 = /*#__PURE__*/React__namespace.forwardRef(SvgExams$1);

  function SvgExit$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#exit_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.586 13l-1.293 1.293 1.415 1.414 3-3 .707-.707-.707-.707-3-3-1.415 1.414L18.586 11H10v2h8.586zM3 5a2 2 0 012-2h10a2 2 0 012 2v3h-2V5H5v14h10v-3h2v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "exit_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$22 = /*#__PURE__*/React__namespace.forwardRef(SvgExit$1);

  function SvgFilter(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#filter_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 7.25H3v-2.5h18v2.5zm-2 6H5v-2.5h14v2.5zm-11 6h8v-2.5H8v2.5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "filter_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$21 = /*#__PURE__*/React__namespace.forwardRef(SvgFilter);

  function SvgFold$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#fold_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.706 3.291A1 1 0 0119 4v13a1 1 0 01-1 1h-3v3a1 1 0 01-1.351.936L5 18.693V3.059L17.995 3a1 1 0 01.71.291zM15 16h2V5.005l-5.55.025 2.901 1.088a1 1 0 01.649.936V16zM7 5.497v11.81l6 2.25V7.747l-6-2.25z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "fold_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$20 = /*#__PURE__*/React__namespace.forwardRef(SvgFold$1);

  function SvgGenderFemale$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#gender-female_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 9A5 5 0 117 9a5 5 0 0110 0zm-4 6.93A7.002 7.002 0 0012 2a7 7 0 00-1 13.93v1.514H8v2h3V22h2v-2.556h3v-2h-3V15.93z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "gender-female_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1$ = /*#__PURE__*/React__namespace.forwardRef(SvgGenderFemale$1);

  function SvgGenderMale$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#gender-male_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.071 7.343v1.829h2V3.929h-5.243v2h1.829l-4.009 4.008a6.002 6.002 0 00-7.72 9.134 6 6 0 009.135-7.72l4.008-4.008zM12 12a4 4 0 10-5.657 5.657A4 4 0 0012 12z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "gender-male_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1_ = /*#__PURE__*/React__namespace.forwardRef(SvgGenderMale$1);

  function SvgGlasses$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#glasses_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 13h-1.126a4.002 4.002 0 01-7.845-.518 3.663 3.663 0 00-.209-.15C12.495 12.115 12.2 12 12 12c-.2 0-.495.115-.82.332-.077.05-.147.102-.209.15A4 4 0 013.126 13H2v-2h1.126a4.002 4.002 0 017.514-.66c.384-.185.853-.34 1.36-.34.508 0 .976.155 1.36.34a4 4 0 017.514.66H22v2zm-5 1a2 2 0 100-4 2 2 0 000 4zM7 14a2 2 0 100-4 2 2 0 000 4z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "glasses_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1Z = /*#__PURE__*/React__namespace.forwardRef(SvgGlasses$1);

  function SvgHamburguer(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#hamburguer_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 7.25H3v-2.5h18v2.5zm0 6H3v-2.5h18v2.5zm-18 6h18v-2.5H3v2.5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "hamburguer_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1Y = /*#__PURE__*/React__namespace.forwardRef(SvgHamburguer);

  function SvgHandshake$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#handshake_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.95 4.222l-1.415-1.414a2 2 0 00-2.828 0l-2.815 2.814L8.877 3.53l-.706-.735-.721.72-5.657 5.658-.697.697.687.707 3.652 3.755a3.4 3.4 0 00.777 3.609l2.262 2.263a3.4 3.4 0 003.674.75 4.001 4.001 0 005.095-.468l.707-.707.707-.707a4.002 4.002 0 00.618-4.86l3.624-3.625.707-.707-.707-.707-4.95-4.95zm-4.19 15.326a2 2 0 002.068-.477l.707-.707.708-.707a2 2 0 000-2.828l-3.536-3.536-1.414 1.414-.707.707-.708-.707-2.12-2.121a2 2 0 010-2.829l.72-.72L8.143 5.65 3.904 9.889l2.786 2.864a2.6 2.6 0 013.199.379l3.394 3.394c.818.817.977 2.044.477 3.022zm4.19-6.84l-2.829-2.83.707-.706-1.414-1.415-2.829 2.829-1.414-1.414 1.415-1.415 3.535-3.535 1.414 1.414 4.243 4.243-2.828 2.828zM7.626 14.545a.6.6 0 01.848 0l3.395 3.394a.6.6 0 010 .848 1.4 1.4 0 01-1.98 0l-2.263-2.262a1.4 1.4 0 010-1.98z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "handshake_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1X = /*#__PURE__*/React__namespace.forwardRef(SvgHandshake$1);

  function SvgHeartbeat$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#heartbeat_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.857 10.485a1 1 0 00-1.69-.04L6.466 13H1v2h6.535l1.42-2.13.688 1.145 1.5 2.5a1 1 0 001.751-.068l1.277-2.553L15 15h8v-2h-7l-1.2-1.6a1 1 0 00-1.694.153l-1.186 2.37-2.063-3.438zM2.855 5.907C3.688 4.337 5.184 3 7.14 3c1.806 0 3.249.924 4.185 1.75.256.226.482.45.675.659.193-.209.42-.433.675-.659C13.61 3.924 15.054 3 16.859 3c1.92 0 3.397 1.288 4.237 2.816.827 1.507 1.156 3.438.693 5.184h-2.117a2.768 2.768 0 00.165-.444c.343-1.206.128-2.643-.494-3.777C18.716 5.638 17.8 5 16.859 5c-1.11 0-2.097.576-2.861 1.25a7.652 7.652 0 00-1.096 1.204 3.75 3.75 0 00-.053.075l-.01.015a1 1 0 01-1.678 0l-.063-.09a7.646 7.646 0 00-1.096-1.204C9.237 5.576 8.251 5 7.14 5c-.958 0-1.892.663-2.518 1.843-.62 1.172-.809 2.642-.418 3.849.03.092.071.195.124.308H2.21c-.455-1.714-.145-3.604.644-5.093zM14.73 17h2.783a84.597 84.597 0 01-2.796 2.822 99.991 99.991 0 01-2.007 1.884l-.03.027-.01.01a1 1 0 01-1.34 0l-.01-.01-.03-.027a44.492 44.492 0 01-.541-.497 99.719 99.719 0 01-1.466-1.387A84.585 84.585 0 016.487 17H9.27A91.801 91.801 0 0012 19.642 98.345 98.345 0 0014.73 17z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "heartbeat_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1W = /*#__PURE__*/React__namespace.forwardRef(SvgHeartbeat$1);

  function SvgHome$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#home_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.293 1.293a1 1 0 011.414 0l10 10-1.414 1.414L20 11.414V20a2 2 0 01-2 2H6a2 2 0 01-2-2v-8.586l-1.293 1.293-1.414-1.414 10-10zM10 20h4v-4a2 2 0 10-4 0v4zm6 0h2V9.414l-6-6-6 6V20h2v-4a4 4 0 018 0v4z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "home_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1V = /*#__PURE__*/React__namespace.forwardRef(SvgHome$1);

  function SvgHomeCollection(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#home-collection_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 10h-1v2h1v5H6V8.414l5-5 5 5V10h-3zm7.414 0l-8.707-8.707a1 1 0 00-1.414 0l-9 9 1.414 1.414L4 10.414V17a2 2 0 002 2h7.126A4.002 4.002 0 0021 18v-6h1v-2H20.414zM19 12h-4v3h4v-3z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "home-collection_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1U = /*#__PURE__*/React__namespace.forwardRef(SvgHomeCollection);

  function SvgId$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#id_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 18v-6h5V7h11v11H4zM7 7H4v3h3V7zm2-2h12a1 1 0 011 1v13a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h6zm10 7h-8v-2h8v2zM5 16h14v-2H5v2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "id_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1T = /*#__PURE__*/React__namespace.forwardRef(SvgId$1);

  function SvgLab$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#lab_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3h-1v2.5h2.25v5.167L4.6 16.2C3.117 18.178 4.528 21 7 21h10c2.472 0 3.883-2.822 2.4-4.8l-4.15-5.533V5.5h2.25V3h-10zm3.25 3.75V5h2.5v6.333l.2.267L16 15H8l2.55-3.4.2-.267V6.75zM6.5 17l-.3.4A1 1 0 007 19h10a1 1 0 00.8-1.6l-.3-.4h-11z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "lab_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1S = /*#__PURE__*/React__namespace.forwardRef(SvgLab$1);

  function SvgLink$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#link_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.071 4.929a5 5 0 00-7.071 0L9.172 7.757l1.414 1.414 2.828-2.828a3 3 0 014.243 4.243l-2.829 2.828 1.415 1.414L19.07 12a5 5 0 000-7.071zM6.343 13.414l2.121-2.121L7.05 9.879l-2.121 2.12A5 5 0 0012 19.072l2.121-2.121-1.414-1.415-2.121 2.122a3 3 0 11-4.243-4.243zm10.607-4.95L15.536 7.05 7.05 15.536l1.414 1.414 8.486-8.486z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "link_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1R = /*#__PURE__*/React__namespace.forwardRef(SvgLink$1);

  function SvgLoading$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#loading_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.556 3.685A9 9 0 0121 12h-2a7 7 0 10-3.5 6.062l1 1.732A9 9 0 118.556 3.685z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "loading_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1Q = /*#__PURE__*/React__namespace.forwardRef(SvgLoading$1);

  function SvgLock$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#lock_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 20v-9h12v9H6zM4 9h2c0-2.04.392-4.003 1.346-5.49C8.334 1.97 9.894 1 12 1s3.666.97 4.654 2.51C17.608 4.997 18 6.96 18 9h2v12a1 1 0 01-1 1H5a1 1 0 01-1-1V9zm12 0c0-1.827-.358-3.363-1.03-4.41C14.335 3.597 13.395 3 12 3c-1.394 0-2.334.597-2.97 1.59C8.357 5.637 8 7.173 8 9h8zm-3 7.732A2 2 0 0012 13a2 2 0 00-1 3.732V18h2v-1.268z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "lock_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1P = /*#__PURE__*/React__namespace.forwardRef(SvgLock$1);

  function SvgMail$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#mail_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.568 7L12 11.809 19.432 7H4.568zM4 9.015V17h16V9.015l-7.457 4.825-.543.351-.543-.351L4 9.015zM2 6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "mail_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1O = /*#__PURE__*/React__namespace.forwardRef(SvgMail$1);

  function SvgMedicalCalendar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#medical-calendar_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 6h2v1a1 1 0 102 0V6h6v1a1 1 0 102 0V6h2v13H5V6zm12-2h4v15a2 2 0 01-2 2H5a2 2 0 01-2-2V4h4V2h2v2h6V2h2v2zm-6 5v3H8v2h3v3h2v-3h3v-2h-3V9h-2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "medical-calendar_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1N = /*#__PURE__*/React__namespace.forwardRef(SvgMedicalCalendar);

  function SvgMenu$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#menu_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 6a2 2 0 114 0 2 2 0 01-4 0zm0 6a2 2 0 114 0 2 2 0 01-4 0zm2 4a2 2 0 100 4 2 2 0 000-4z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "menu_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1M = /*#__PURE__*/React__namespace.forwardRef(SvgMenu$1);

  function SvgMessage$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#message_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 18v-2H4V6h16v10h-9.273l-.572.52L8 18.48V18zm12 0h-8.5l-3.827 3.48C7.03 22.062 6 21.607 6 20.74V18H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2zM6 10h12V8H6v2zm0 4h8v-2H6v2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "message_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1L = /*#__PURE__*/React__namespace.forwardRef(SvgMessage$1);

  function SvgMicOff$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#mic-off_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 6.586L4.707 3.293 3.293 4.707 8 9.414V12a4 4 0 006.032 3.446l.803.803c-.657.446-1.561.751-2.835.751-1.505 0-2.494-.45-3.172-1.062-.699-.63-1.152-1.508-1.433-2.484-.487-1.689-.401-3.396-.363-4.146.006-.136.012-.24.012-.308h-2v-.002V9l-.002.035-.006.114v.014a17.932 17.932 0 00-.031 1.526c.02.922.122 2.12.468 3.32.345 1.197.95 2.454 2.015 3.415.89.804 2.05 1.35 3.512 1.52V22h2v-3.054c1.33-.149 2.409-.597 3.266-1.266l3.027 3.027 1.414-1.414-3.095-3.096c.42-.65.71-1.352.913-2.04.59-2.001.481-4.138.442-4.906-.006-.118-.01-.203-.01-.25l-2-.001c0 .109.006.258.014.44.038.882.11 2.541-.364 4.152-.12.404-.27.79-.456 1.144l-.705-.704c.352-.596.554-1.29.554-2.032V6a4 4 0 00-8 0v.586zm2 4.828V12a2 2 0 002.518 1.932L10 11.414zm3.932 1.104L10 8.586V6a2 2 0 114 0v6c0 .18-.024.353-.068.518z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "mic-off_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1K = /*#__PURE__*/React__namespace.forwardRef(SvgMicOff$1);

  function SvgMicOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#mic-on_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.044 9v-.002V9l-.002.035a15.13 15.13 0 01-.006.114v.014a17.939 17.939 0 00-.031 1.526c.02.922.122 2.12.468 3.32.345 1.197.95 2.454 2.015 3.415.89.804 2.05 1.35 3.512 1.52V22h2v-3.054c1.452-.162 2.606-.682 3.498-1.457 1.07-.93 1.68-2.152 2.027-3.331.59-2.002.481-4.14.442-4.907a6.362 6.362 0 01-.01-.25l-2-.001c0 .109.006.258.014.44.038.882.11 2.541-.364 4.152-.279.946-.727 1.786-1.42 2.387C14.51 16.566 13.517 17 12 17c-1.505 0-2.493-.45-3.172-1.062-.699-.63-1.152-1.508-1.433-2.484-.487-1.689-.401-3.396-.363-4.146.006-.136.012-.24.012-.308h-2zM14 12V6a2 2 0 10-4 0v6a2 2 0 104 0zM12 2a4 4 0 00-4 4v6a4 4 0 008 0V6a4 4 0 00-4-4z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "mic-on_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1J = /*#__PURE__*/React__namespace.forwardRef(SvgMicOn$1);

  function SvgNotification$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#notification_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6c-2.171 0-5 2.038-5 6.647V17h10v-4.353C17 8.038 14.171 6 12 6zm2-1.651V4a2 2 0 10-4 0v.349c-2.71.958-5 3.862-5 8.298V19h4a3 3 0 106 0h4v-6.353c0-4.436-2.29-7.34-5-8.298zM12 20a1 1 0 01-1-1h2a1 1 0 01-1 1z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "notification_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1I = /*#__PURE__*/React__namespace.forwardRef(SvgNotification$1);

  function SvgPdf(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#pdf_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 4h20v2H2V4zm20 4h-5v8h2v-2.231h2v-2h-2V10h3V8zM9.5 8h5l1 1v6l-1 1h-5V8zm2 2v4h2v-4h-2zM2 8h5l1 1v4l-1 1H4v2H2V8zm2 4h2v-2H4v2zm18 6H2v2h20v-2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "pdf_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1H = /*#__PURE__*/React__namespace.forwardRef(SvgPdf);

  function SvgPin$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#pin_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c-1.124 0-3.087.274-4.803 1.41C5.418 4.59 4 6.643 4 9.955c0 3.347 1.95 6.342 3.745 8.411a25.515 25.515 0 003.335 3.19c.101.08.182.142.238.184l.066.05.019.013.006.005h.001l.001.001L12 21l-.588.809a1 1 0 001.176 0L12 21c.588.809.588.808.589.808l.002-.002.006-.004.018-.013.066-.05a22.629 22.629 0 001.068-.873 25.524 25.524 0 002.506-2.5C18.051 16.295 20 13.3 20 9.953c0-3.312-1.418-5.364-3.198-6.543C15.087 2.274 13.123 2 12 2zm.438 17.357c-.162.14-.309.264-.438.37a23.521 23.521 0 01-2.745-2.673C7.551 15.09 6 12.563 6 9.955c0-2.641 1.082-4.067 2.302-4.876C9.587 4.226 11.123 4 12 4c.877 0 2.413.226 3.697 1.078C16.919 5.887 18 7.313 18 9.954c0 2.608-1.55 5.136-3.255 7.1a23.516 23.516 0 01-2.307 2.303zM10 10a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "pin_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1G = /*#__PURE__*/React__namespace.forwardRef(SvgPin$1);

  function SvgPortraitFrame$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#portrait-frame_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 4a1 1 0 00-1-1h-5v2h4v4h2V4zM4 3a1 1 0 00-1 1v5h2V5h4V3H4zm17 18a1 1 0 01-1 1h-5v-2h4v-4h2v5zM3 21a1 1 0 001 1h5v-2H5v-4H3v5zm6.684-4.145C9.15 17.355 9 17.859 9 18H7c0-.859.517-1.855 1.316-2.605C9.158 14.605 10.4 14 12 14c1.6 0 2.842.606 3.684 1.395C16.483 16.145 17 17.141 17 18h-2c0-.141-.15-.645-.684-1.145-.491-.46-1.25-.855-2.316-.855-1.066 0-1.825.394-2.316.855zM13 10a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 11-6 0 3 3 0 016 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "portrait-frame_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1F = /*#__PURE__*/React__namespace.forwardRef(SvgPortraitFrame$1);

  function SvgPrint(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#print_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 7a1 1 0 00-1 1v8a1 1 0 001 1h3v4a1 1 0 001 1h10a1 1 0 001-1v-4h3a1 1 0 001-1V8a1 1 0 00-1-1h-3V5a1 1 0 00-.375-.78l-2.5-2A1 1 0 0014.5 2H7a1 1 0 00-1 1v4H3zm5 0h8V5.48L14.15 4H8v3zM7 9H4v6h2v-3h12v3h2V9H7zm9 11H8v-6h8v6zm-2-2h-4v-2h4v2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "print_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1E = /*#__PURE__*/React__namespace.forwardRef(SvgPrint);

  function SvgQuestion$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#question_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-.794-12.735C11.09 9.405 11 9.65 11 10H9c0-.649.16-1.404.67-2.015C10.204 7.342 11.01 7 12 7s1.795.342 2.33.985c.51.61.67 1.366.67 2.015 0 1.376-.726 2.368-1.34 2.966-.236.231-.47.416-.66.555V14h-2v-.919a1.003 1.003 0 01.303-.805l.001-.001a1.696 1.696 0 01.203-.157l.004-.002.043-.029c.045-.029.092-.059.152-.1.154-.105.357-.257.558-.453.412-.402.736-.91.736-1.534 0-.351-.09-.596-.206-.735C12.705 9.158 12.51 9 12 9c-.51 0-.705.158-.794.265zM13 17v-2h-2v2h2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "question_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1D = /*#__PURE__*/React__namespace.forwardRef(SvgQuestion$1);

  function SvgSearch$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#search_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.193 15.607l5.707 5.707 1.414-1.415-5.707-5.707A7.002 7.002 0 005.05 5.05a7 7 0 009.143 10.557zm-.635-2.094l-.045.045a5 5 0 11.045-.045z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "search_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1C = /*#__PURE__*/React__namespace.forwardRef(SvgSearch$1);

  function SvgSecurity(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#security_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.033 1.455a2 2 0 00-2.066 0l-6.483 3.91L4 5.658V11.5c0 3.564 1.973 6.187 3.83 7.866a16.748 16.748 0 003.41 2.374 10.075 10.075 0 00.317.157l.02.01.007.002.002.001h.001L12 21l-.412.911.412.186.412-.186L12 21c.412.911.412.91.413.91h.003l.007-.004.02-.01a10.075 10.075 0 00.317-.157 16.746 16.746 0 003.41-2.373C18.028 17.687 20 15.064 20 11.5V5.657l-.483-.291-6.484-3.91zm-.456 18.095c-.224.135-.42.245-.577.33a14.768 14.768 0 01-2.83-1.996C7.528 16.395 6 14.27 6 11.5V6.787l6-3.62 6 3.62V11.5c0 2.77-1.527 4.896-3.17 6.383a14.77 14.77 0 01-2.253 1.667zm3.13-8.843l.707-.707L15 8.586l-.707.707-2.793 2.793-1.293-1.293-.707-.707L8.086 11.5l.707.707 2 2 .707.707.707-.707 3.5-3.5z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "security_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1B = /*#__PURE__*/React__namespace.forwardRef(SvgSecurity);

  function SvgSettings(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#settings_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2 4a2 2 0 00-2-2h-2a2 2 0 00-2 2v.504a8.028 8.028 0 00-.123.047l-.471-.47a2 2 0 00-2.829 0L4.363 5.494a2 2 0 000 2.828l.357.357-.054.12H4a2 2 0 00-2 2v2a2 2 0 002 2h.504l.047.123-.47.471a2 2 0 000 2.829l1.414 1.414a2 2 0 002.828 0l.357-.357c.17.078.344.15.52.216V20a2 2 0 002 2h2a2 2 0 002-2v-.666l.12-.054.357.357a2 2 0 002.828 0l1.415-1.415a2 2 0 000-2.828l-.471-.47.047-.124H20a2 2 0 002-2v-2a2 2 0 00-2-2h-.666a8.323 8.323 0 00-.054-.12l.357-.357a2 2 0 000-2.828L18.222 4.08a2 2 0 00-2.828 0l-.194.195V4zM8.644 6.947l.047.047a5.964 5.964 0 012.509-.941V4h2v2.12c.766.156 1.48.457 2.109.874l1.5-1.5 1.413 1.415-1.451 1.452c.54.706.926 1.536 1.109 2.439H20v2h-2.053a5.964 5.964 0 01-.941 2.509l1.5 1.5-1.415 1.413-1.452-1.451A5.973 5.973 0 0113.2 17.88V20h-2v-2.053a5.97 5.97 0 01-2.84-1.176L6.91 18.223l-1.414-1.415 1.5-1.5a5.965 5.965 0 01-.942-2.508H4v-2h2.12a5.973 5.973 0 011.11-2.44L5.776 6.91l1.415-1.414 1.452 1.452zM11 12a1 1 0 112 0 1 1 0 01-2 0zm1-3a3 3 0 100 6 3 3 0 000-6z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "settings_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1A = /*#__PURE__*/React__namespace.forwardRef(SvgSettings);

  function SvgShare$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#share_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 8a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 10-3.892-3.07L9.27 9.694a4 4 0 10-.252 4.932l5.07 2.535a4 4 0 10.895-1.788l-5.07-2.536a4.016 4.016 0 00.067-1.246l5.067-2.895A3.99 3.99 0 0018 10zm0 10a2 2 0 100-4 2 2 0 000 4zM8 12a2 2 0 11-4 0 2 2 0 014 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "share_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1z = /*#__PURE__*/React__namespace.forwardRef(SvgShare$1);

  function SvgStethoscope(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#stethoscope_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.8 15.933a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm3.2-1.2a3.201 3.201 0 01-2.035 2.981 7.468 7.468 0 01-.933 2.67C16.252 21.703 14.839 23 12.5 23c-1.104 0-2.043-.253-2.819-.722-.774-.467-1.331-1.116-1.726-1.827C7.18 19.058 7 17.372 7 16.068V12.929c-.933-.137-1.73-.47-2.396-.967-.884-.657-1.469-1.55-1.853-2.488-.758-1.846-.805-4.028-.72-5.53a19.891 19.891 0 01.208-1.959l.02-.122.007-.034.002-.01v-.005L3.252 2l.983.186-.001.004-.004.022-.017.097a17.895 17.895 0 00-.185 1.747C3.96 5.279 4 6.8 4.39 8.112 5.18 7.522 6.356 7 8 7s2.82.522 3.61 1.112c.39-1.31.431-2.833.363-4.056a17.89 17.89 0 00-.186-1.747 7.17 7.17 0 00-.016-.097l-.004-.022v-.004L12.748 2l.982-.187v.002l.001.004.002.01.006.034a10.802 10.802 0 01.086.563c.05.374.11.9.144 1.518.084 1.502.037 3.684-.72 5.53-.385.938-.97 1.83-1.854 2.488-.666.497-1.463.83-2.396.967V16.068c0 1.178.174 2.459.703 3.411.257.462.587.83 1.012 1.087.423.256.995.434 1.785.434 1.45 0 2.287-.75 2.81-1.634a5.413 5.413 0 00.607-1.556 3.202 3.202 0 01.883-6.277 3.2 3.2 0 013.2 3.2zm-9.33-4.806a3.047 3.047 0 00-.17-.146C10.04 9.412 9.257 9 8 9s-2.04.412-2.5.78c-.062.05-.118.099-.17.147.143.161.299.305.468.431.509.38 1.207.642 2.202.642.995 0 1.693-.263 2.202-.642.169-.126.325-.27.467-.431z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "stethoscope_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1y = /*#__PURE__*/React__namespace.forwardRef(SvgStethoscope);

  function SvgSun$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#sun_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 11a1 1 0 110 2h-4v-2h4zm-2.293-6.707a1 1 0 010 1.414l-1.414 1.414-1.414 1.415-1.415-1.415 1.415-1.414 1.414-1.414a1 1 0 011.414 0zM12 14a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zm0-15a1 1 0 011 1v4h-2V2a1 1 0 011-1zm1 21v-4h-2v4a1 1 0 102 0zm6.707-2.293a1 1 0 000-1.414l-2.829-2.829-1.414 1.415 2.829 2.828a1 1 0 001.414 0zm-15.243-14a1 1 0 011.414-1.414L8.707 7.12 7.293 8.536 4.464 5.707zM1.171 12a1 1 0 011-1h4v2h-4a1 1 0 01-1-1zm3.293 6.293a1 1 0 101.414 1.414l2.829-2.828-1.414-1.415-2.829 2.829z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "sun_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1x = /*#__PURE__*/React__namespace.forwardRef(SvgSun$1);

  function SvgSwap(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#swap_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 18a5 5 0 005-5v-1h-2v1a3 3 0 01-3 3H7.414l1.293-1.293.707-.707L8 12.586l-.707.707-3 3a1 1 0 000 1.414l3 3 .707.707L9.414 20l-.707-.707L7.414 18H15zm4.707-10.293a1 1 0 000-1.414l-3-3L16 2.586 14.586 4l.707.707L16.586 6H9a5 5 0 00-5 5v1h2v-1a3 3 0 013-3h7.586l-1.293 1.293-.707.707L16 11.414l.707-.707 3-3z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "swap_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1w = /*#__PURE__*/React__namespace.forwardRef(SvgSwap);

  function SvgTerms$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#terms_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 5h14v14H5V5zM3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm4 4h10V7H7v2zm6 4H7v-2h6v2zm-6 4h8v-2H7v2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "terms_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1v = /*#__PURE__*/React__namespace.forwardRef(SvgTerms$1);

  function SvgTrashBin$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#trash-bin_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 8h1V6h-4V4a2 2 0 00-2-2H9a2 2 0 00-2 2v2H3v2h1v12a2 2 0 002 2h12a2 2 0 002-2V8zm-2 0H6v12h12V8zM9 6h6V4H9v2zm2 4v8H9v-8h2zm4 8v-8h-2v8h2z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "trash-bin_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1u = /*#__PURE__*/React__namespace.forwardRef(SvgTrashBin$1);

  function SvgUser$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#user_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 21a6 6 0 0112 0h2a8 8 0 10-16 0h2zm9-14a3 3 0 11-6 0 3 3 0 016 0zm2 0A5 5 0 117 7a5 5 0 0110 0z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "user_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1t = /*#__PURE__*/React__namespace.forwardRef(SvgUser$1);

  function SvgVaccines$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#vaccines_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.657 1.686l5.657 5.657-1.415 1.414-2.12-2.121-1.415 1.414 3.535 3.536L19.485 13l-1.414-1.414-2.822 2.822-.006.006-.006.006-2.109 2.109-.007.006-.007.008-2.821 2.82a1 1 0 01-1.414 0L7.464 17.95 3.93 21.485a1 1 0 01-1.414-1.414l3.535-3.536-1.414-1.414a1 1 0 010-1.414l7.778-7.778L11 4.515 12.414 3.1l3.536 3.536 1.414-1.414L15.243 3.1l1.414-1.414zm-8.48 14.147l-.005-.005-.005-.004-1.41-1.41 7.072-7.07.707.706 1.414 1.414.707.707-2.121 2.122-.707-.707A1 1 0 1012.413 13l.707.707-.707.707-.707-.707a1 1 0 00-1.414 1.414l.707.707-1.414 1.415-1.41-1.41z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "vaccines_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1s = /*#__PURE__*/React__namespace.forwardRef(SvgVaccines$1);

  function SvgViewOff$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#view-off_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.201 12a15.803 15.803 0 001.964 2.276C7.662 15.702 9.675 17 12 17c1.04 0 2.016-.26 2.912-.674l-.88-.88a4 4 0 01-5.478-5.478l-1.23-1.23c-.414.311-.801.645-1.16.986A15.812 15.812 0 004.202 12zM7.6 6.185L4.707 3.293 3.293 4.707l2.605 2.606c-.404.316-.776.642-1.113.963a17.81 17.81 0 00-2.453 2.913 10.454 10.454 0 00-.173.27l-.011.018-.003.005-.002.002c0 .001 0 .002.857.516l-.857-.514-.31.514.31.514L3 12l-.857.515.002.003.003.005.01.018a7.09 7.09 0 00.174.27 17.81 17.81 0 002.453 2.913C6.438 17.298 8.925 19 12 19c1.649 0 3.128-.49 4.4-1.185l2.893 2.892 1.414-1.414-2.605-2.606c.404-.316.776-.642 1.113-.963a17.805 17.805 0 002.453-2.913 10.668 10.668 0 00.174-.27l.01-.018.003-.005.002-.002c0-.001 0-.002-.857-.516l.858.514.308-.514-.308-.514L21 12c.858-.514.857-.515.857-.515l-.002-.003-.003-.005-.01-.018a7.346 7.346 0 00-.174-.27 17.807 17.807 0 00-2.453-2.913C17.562 6.702 15.075 5 12 5c-1.648 0-3.128.49-4.4 1.185zm1.488 1.488C9.984 7.26 10.96 7 12 7c2.325 0 4.338 1.298 5.835 2.724A15.817 15.817 0 0119.8 12a15.809 15.809 0 01-1.964 2.276 12.94 12.94 0 01-1.16.985l-1.229-1.23a4 4 0 00-5.478-5.478l-.88-.88zm2.394 2.395a2 2 0 012.45 2.45l-2.45-2.45zm-1.414 1.414l2.45 2.45a2.003 2.003 0 01-2.45-2.45z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "view-off_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1r = /*#__PURE__*/React__namespace.forwardRef(SvgViewOff$1);

  function SvgViewOn$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#view-on_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.447 12.338A14.627 14.627 0 014.2 12a15.81 15.81 0 011.964-2.276C7.662 8.298 9.675 7 12 7s4.338 1.298 5.835 2.724A15.816 15.816 0 0119.8 12a15.816 15.816 0 01-1.964 2.276C16.338 15.702 14.325 17 12 17s-4.338-1.298-5.835-2.724a15.81 15.81 0 01-1.718-1.938zM21 12l.857-.515L21 12zm.855-.518l.002.003.31.515-.31.514L21 12c.858.514.857.515.857.516l-.002.002-.003.005-.01.018a7.595 7.595 0 01-.174.27 17.797 17.797 0 01-2.453 2.913C17.562 17.298 15.075 19 12 19s-5.562-1.702-7.215-3.276a17.801 17.801 0 01-2.453-2.913 10.463 10.463 0 01-.17-.264l-.003-.006-.011-.018-.003-.005-.002-.004L3 12l-.857-.516.002-.002.003-.005.01-.018.038-.06a15.69 15.69 0 01.651-.937 17.813 17.813 0 011.938-2.186C6.438 6.702 8.925 5 12 5s5.562 1.702 7.215 3.276a17.81 17.81 0 012.453 2.913 10.185 10.185 0 01.174.27l.01.018.003.005zM3 12l-.857-.515-.31.515.31.514L3 12zm7 0a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "view-on_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1q = /*#__PURE__*/React__namespace.forwardRef(SvgViewOn$1);

  function SvgWarning$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#warning_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1-16v7.6h-2V6h2zm-1 9a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "warning_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1p = /*#__PURE__*/React__namespace.forwardRef(SvgWarning$1);

  function SvgWhatsapp$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#whatsapp_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12a8 8 0 114.4 7.147l-.212-.108H4.96v-3.227l-.107-.213A7.966 7.966 0 014 12zm8-10C6.477 2 2 6.477 2 12a9.967 9.967 0 00.96 4.281v4.758H7.72A9.965 9.965 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm-1.979 5.526l.909.908a1 1 0 010 1.415l-.611.61s-.086.794.797 1.678c.884.883 2.03 1.151 2.03 1.151l.612-.611a1 1 0 011.414 0l.909.908c.213.214.43.48.246.72-.096.123-.24.287-.457.503-.925.925-1.325.988-1.325.988s-2.316.969-5.01-1.725c-2.693-2.694-1.725-5.01-1.725-5.01s.063-.399.989-1.324a5.5 5.5 0 01.504-.457c.239-.185.505.033.718.246z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "whatsapp_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1o = /*#__PURE__*/React__namespace.forwardRef(SvgWhatsapp$1);

  function SvgXRay$1(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#x-ray_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 5H5v14h14V5zM5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2H5zm6 4.107V6h2v1.107c.977.195 1.961.624 2.71 1a19.295 19.295 0 011.806 1.035l.03.02.008.006.003.002h.001L17 10l-.558.83-.005-.004-.02-.013-.089-.058a17.318 17.318 0 00-1.515-.862c-.604-.302-1.237-.57-1.813-.73v1.944c.977.195 1.961.623 2.71 1a19.274 19.274 0 011.806 1.035l.03.02.008.006.003.002h.001L17 14l-.558.83-.005-.004-.02-.013-.089-.058a17.333 17.333 0 00-1.515-.862c-.604-.302-1.237-.57-1.813-.73v1.928c.617.112 1.15.31 1.562.503a6.642 6.642 0 01.956.546l.062.045.02.015.007.005.002.002h.001v.001L15 17l-.611.792h.001l-.026-.018a4.639 4.639 0 00-.647-.367C13.265 17.196 12.662 17 12 17c-.662 0-1.265.196-1.717.407a4.635 4.635 0 00-.647.367l-.026.018h.001L9 17a151.87 151.87 0 01-.61-.792v-.001l.003-.002.007-.005.02-.015.062-.045A6.64 6.64 0 0111 15.091v-1.929c-.576.162-1.21.429-1.813.732a17.354 17.354 0 00-1.603.919l-.021.013-.004.003a431.448 431.448 0 00-1.117-1.659l.004-.002.008-.006.03-.02a11.524 11.524 0 01.494-.31c.327-.198.785-.461 1.312-.726.748-.376 1.733-.804 2.71-.999V9.162c-.576.162-1.21.429-1.813.732a17.338 17.338 0 00-1.603.919l-.021.013-.004.003L7 10l-.558-.83.004-.002.008-.006.03-.02.107-.07a19.332 19.332 0 011.699-.966c.748-.375 1.733-.804 2.71-.999zM9.61 17.792l-.002.002.002-.002zm4.78 0l.003.003-.001-.001-.002-.001z",
      fill: "currentcolor"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "x-ray_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1n = /*#__PURE__*/React__namespace.forwardRef(SvgXRay$1);

  function SvgAdd(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17 13h-4v4a1 1 0 11-2 0v-4H7a1 1 0 110-2h4V7a1 1 0 112 0v4h4a1 1 0 110 2z"
    }));
  }

  var ForwardRef$1m = /*#__PURE__*/React__namespace.forwardRef(SvgAdd);

  function SvgAgConsulta(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M8.745 3.574a.574.574 0 10-1.15 0v.958H5.107A2.106 2.106 0 003 6.638v12.256C3 20.057 3.943 21 5.106 21h3.83a.574.574 0 000-1.149h-3.83a.957.957 0 01-.957-.957v-8.617H19.85v3.106a.574.574 0 001.149 0V6.638a2.106 2.106 0 00-2.106-2.106h-2.49v-.958a.574.574 0 00-1.149 0v.958h-6.51v-.958zm6.51 3.064v-.957h-6.51v.957a.574.574 0 11-1.15 0v-.957H5.107a.957.957 0 00-.957.957v2.49H19.85v-2.49a.957.957 0 00-.957-.957h-2.49v.957a.574.574 0 01-1.149 0zM12.087 21c-.881 0-1.087-.087-1.087-.964v-4.339c0-.877.049-1.06.93-1.06h5.018c.881 0 1.087.183 1.087 1.06v4.339c0 .877-.206.964-1.087.964h-4.86zm.302-5.4c-.459 0-.459.016-.459.394v3.463c0 .482 0 .579.418.579H16.581c.465 0 .465-.039.465-.416v-3.626c0-.378 0-.393-.465-.393H12.39zm7.971 4.698a.632.632 0 01-.285-.067l-1.457-.725a.318.318 0 01-.142-.426c.078-.157.164-.205.286-.205.05 0 .098.012.142.034l1.292.598v-3.115l-.603.285-.689.305a.322.322 0 01-.142.033c-.122 0-.221-.066-.287-.196a.318.318 0 01.143-.427l1.456-.724a.644.644 0 01.739.12c.12.12.187.279.187.449v3.425a.637.637 0 01-.64.636z"
    }));
  }

  var ForwardRef$1l = /*#__PURE__*/React__namespace.forwardRef(SvgAgConsulta);

  function SvgAgExams(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M15.419 13.364c0-.201.125-.364.279-.364h2.604c.154 0 .279.163.279.364 0 .2-.125.363-.279.363h-.093v1.953l.678 1.358.005.013.943 1.889c.1.201.157.434.164.674.008.24-.035.478-.123.689-.088.21-.218.387-.376.51a.85.85 0 01-.523.187h-3.955a.853.853 0 01-.523-.188 1.247 1.247 0 01-.376-.51 1.673 1.673 0 01-.122-.689 1.63 1.63 0 01.164-.673l.943-1.89a.456.456 0 01.006-.012l.677-1.358v-1.953h-.093c-.154 0-.279-.162-.279-.363zm.93.363v2.06c0 .071-.016.14-.045.2l-.445.892h2.282l-.445-.893a.448.448 0 01-.045-.198v-.121h-.465c-.154 0-.279-.163-.279-.364 0-.2.125-.364.279-.364h.465v-.242h-.465c-.154 0-.279-.163-.279-.364 0-.2.125-.363.279-.363h.465v-.243h-1.302zm2.155 3.88h-3.008l-.863 1.73a.76.76 0 00-.019.619c.04.095.099.175.17.231a.387.387 0 00.238.086h3.955c.084 0 .166-.03.238-.085a.567.567 0 00.17-.232.76.76 0 00-.018-.62l-.863-1.73z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M8.17 3c.317 0 .575.257.575.574v.958h6.51v-.958a.574.574 0 011.15 0v.958h2.489c1.163 0 2.106.943 2.106 2.106V12.383a.574.574 0 01-1.149 0v-2.106H4.15v8.617c0 .528.429.957.957.957h5.83a.574.574 0 010 1.149h-5.83A2.106 2.106 0 013 18.894V6.638c0-1.163.943-2.106 2.106-2.106h2.49v-.958c0-.317.257-.574.574-.574zm7.085 2.68v.958a.574.574 0 001.15 0v-.957h2.489c.528 0 .957.428.957.957v2.49H4.15v-2.49c0-.529.429-.957.957-.957h2.49v.957a.574.574 0 001.149 0v-.957h6.51z"
    }));
  }

  var ForwardRef$1k = /*#__PURE__*/React__namespace.forwardRef(SvgAgExams);

  function SvgApp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5 3.25A1.75 1.75 0 003.25 5v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0010.75 9V5A1.75 1.75 0 009 3.25H5zM4.75 5A.25.25 0 015 4.75h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25H5A.25.25 0 014.75 9V5zM15 3.25A1.75 1.75 0 0013.25 5v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0020.75 9V5A1.75 1.75 0 0019 3.25h-4zM14.75 5a.25.25 0 01.25-.25h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25h-4a.25.25 0 01-.25-.25V5zM3.25 15c0-.966.784-1.75 1.75-1.75h4c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 019 20.75H5A1.75 1.75 0 013.25 19v-4zM5 14.75a.25.25 0 00-.25.25v4c0 .138.112.25.25.25h4a.25.25 0 00.25-.25v-4a.25.25 0 00-.25-.25H5zM15 13.25A1.75 1.75 0 0013.25 15v4c0 .966.784 1.75 1.75 1.75h4A1.75 1.75 0 0020.75 19v-4A1.75 1.75 0 0019 13.25h-4zM14.75 15a.25.25 0 01.25-.25h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25h-4a.25.25 0 01-.25-.25v-4z"
    }));
  }

  var ForwardRef$1j = /*#__PURE__*/React__namespace.forwardRef(SvgApp);

  function SvgArrowCornerRight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-corner-right_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.145 18.382l9.1-9.1a.189.189 0 01.32.146l-.55 8.637a1.084 1.084 0 002.162.14l.71-11.181a1.806 1.806 0 00-1.915-1.916L5.793 5.82a1.082 1.082 0 00.14 2.16l8.636-.549a.189.189 0 01.146.32l-9.1 9.101a1.083 1.083 0 001.531 1.532v-.001z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-corner-right_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1i = /*#__PURE__*/React__namespace.forwardRef(SvgArrowCornerRight);

  function SvgArrowDown(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-down_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.92 4.054v12.869a.189.189 0 01-.33.124L4.873 10.55a1.084 1.084 0 00-1.627 1.43l7.404 8.408a1.806 1.806 0 002.708 0l7.402-8.407a1.083 1.083 0 00-1.626-1.43l-5.718 6.496a.189.189 0 01-.33-.124V4.054a1.083 1.083 0 00-2.166 0h.001z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-down_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1h = /*#__PURE__*/React__namespace.forwardRef(SvgArrowDown);

  function SvgArrowLeft(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.946 10.92H7.077a.188.188 0 01-.124-.33l6.496-5.718a1.084 1.084 0 00-1.43-1.627L3.612 10.65a1.805 1.805 0 000 2.708l8.407 7.402a1.083 1.083 0 001.43-1.626l-6.496-5.718a.189.189 0 01.124-.33h12.87a1.082 1.082 0 000-2.166v.001z"
    }));
  }

  var ForwardRef$1g = /*#__PURE__*/React__namespace.forwardRef(SvgArrowLeft);

  function SvgArrowRight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.054 10.92h12.869a.189.189 0 00.124-.33L10.55 4.873a1.084 1.084 0 011.43-1.627l8.408 7.404a1.806 1.806 0 010 2.708l-8.407 7.402a1.083 1.083 0 01-1.43-1.626l6.496-5.718a.189.189 0 00-.124-.33H4.054a1.083 1.083 0 010-2.166v.001z"
    }));
  }

  var ForwardRef$1f = /*#__PURE__*/React__namespace.forwardRef(SvgArrowRight);

  function SvgArrowUp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#arrow-up_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.08 19.946V7.077a.188.188 0 01.33-.124l5.718 6.496a1.084 1.084 0 001.627-1.43L13.35 3.612a1.805 1.805 0 00-2.708 0L3.24 12.018a1.083 1.083 0 001.626 1.43l5.718-6.496a.189.189 0 01.33.124v12.87a1.082 1.082 0 002.166 0h-.001z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "arrow-up_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$1e = /*#__PURE__*/React__namespace.forwardRef(SvgArrowUp);

  function SvgAvatar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10a9.983 9.983 0 01-3.863 7.896l.075-.065a.755.755 0 01-.088.075A9.953 9.953 0 0112 22a9.957 9.957 0 01-6.124-2.094l-.013-.01A9.983 9.983 0 012 12C2 6.477 6.477 2 12 2zm0 15.679a7.28 7.28 0 00-4.498 1.556A8.47 8.47 0 0012 20.518c1.651 0 3.192-.47 4.498-1.283A7.273 7.273 0 0012 17.679zM12 3.48a8.519 8.519 0 00-5.715 14.836 8.763 8.763 0 0111.43 0A8.519 8.519 0 0012 3.481zm0 1.605a5.062 5.062 0 110 10.124 5.062 5.062 0 010-10.124zm0 1.482a3.58 3.58 0 100 7.16 3.58 3.58 0 000-7.16z"
    }));
  }

  var ForwardRef$1d = /*#__PURE__*/React__namespace.forwardRef(SvgAvatar);

  function SvgBrowser(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.689 18.762A1.69 1.69 0 013 17.073V4.69A1.69 1.69 0 014.689 3h13.51a1.69 1.69 0 011.689 1.689v4.503a.563.563 0 01-1.126 0V7.503H4.126v9.57c0 .311.252.563.563.563h4.503a.563.563 0 010 1.126H4.69zM18.762 6.378v-1.69a.563.563 0 00-.563-.562H4.69a.563.563 0 00-.563.563v1.689h14.636z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.18 21.003a2.36 2.36 0 01-1.653-.756 2.385 2.385 0 01-.001-3.237l.984-.985a2.258 2.258 0 011.876-.644.563.563 0 01-.133 1.118 1.136 1.136 0 00-.949.324l-.968.968a1.248 1.248 0 00.884 2.087h.049c.314 0 .616-.118.848-.334l.954-.956c.25-.252.37-.613.321-.966a.559.559 0 01.48-.635.565.565 0 01.635.48 2.29 2.29 0 01-.637 1.915l-.971.971a2.386 2.386 0 01-1.718.65zM17.777 16.53c-.103 0-.208-.007-.31-.021a.561.561 0 01-.48-.635.565.565 0 01.636-.48 1.166 1.166 0 00.968-.322l.967-.968c.214-.232.33-.548.316-.882a1.247 1.247 0 00-1.25-1.197c-.318 0-.619.117-.848.329l-.948.953c-.249.25-.366.594-.324.944a.565.565 0 01-.557.631.566.566 0 01-.56-.493 2.258 2.258 0 01.642-1.876l.965-.97a2.393 2.393 0 013.241-.016c.466.43.738 1.017.763 1.65a2.36 2.36 0 01-.628 1.708l-.985.985c-.425.42-1.01.66-1.608.66z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.259 18.2a.564.564 0 01-.398-.961l3.377-3.379a.558.558 0 01.796 0c.22.22.22.577 0 .796l-3.378 3.378a.557.557 0 01-.397.165z"
    }));
  }

  var ForwardRef$1c = /*#__PURE__*/React__namespace.forwardRef(SvgBrowser);

  function SvgCake(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.846 21C4.828 21 4 20.135 4 19.07v-6.428c0-1.064.828-1.929 1.846-1.929h.616V9.428a.63.63 0 01.615-.642.63.63 0 01.615.643v1.285h3.693V9.428A.63.63 0 0112 8.787a.63.63 0 01.615.643v1.285h3.693V9.428a.63.63 0 01.615-.642.63.63 0 01.616.643v1.285h.615c1.018 0 1.846.865 1.846 1.929v6.428C20 20.135 19.172 21 18.154 21H5.846zm-.615-1.929a.63.63 0 00.615.643h12.308a.63.63 0 00.615-.643v-2.414a2.665 2.665 0 01-3.384-.256c-.14.132-.293.25-.458.35-.42.256-.899.392-1.384.392-.689 0-1.347-.268-1.85-.742a2.668 2.668 0 01-1.843.742h-.047a2.646 2.646 0 01-1.497-.489c-.455.317-.993.49-1.538.49-.557-.001-1.087-.17-1.536-.485v2.412H5.23zm3.077-3.893c.165 0 .326.071.441.196a1.49 1.49 0 001.073.483h.046c.383 0 .753-.16 1.04-.45.098-.101.184-.215.254-.34a.613.613 0 01.531-.317c.218 0 .422.122.532.319.271.486.777.788 1.318.788.267 0 .531-.074.764-.217.226-.138.415-.336.547-.572a.614.614 0 01.53-.318c.219 0 .422.121.532.317.274.487.781.79 1.325.79.271 0 .539-.077.773-.221.468-.287.758-.818.756-1.384v-1.61a.63.63 0 00-.615-.642H5.847a.63.63 0 00-.615.643v1.607c-.001.428.158.832.448 1.136a1.488 1.488 0 002.187-.014.609.609 0 01.44-.194zM12 7.5c-1.018 0-1.846-.865-1.846-1.929 0-.914 1.089-2.064 1.423-2.394a.598.598 0 01.846 0c.334.33 1.423 1.479 1.423 2.394 0 1.064-.828 1.929-1.846 1.929zm0-2.926c-.418.501-.615.88-.615.997a.63.63 0 00.615.643.63.63 0 00.615-.643c0-.116-.197-.497-.615-.997zM16.923 7.5c-1.018 0-1.846-.865-1.846-1.929 0-.915 1.089-2.064 1.423-2.394a.598.598 0 01.846-.001c.334.33 1.423 1.48 1.423 2.395 0 1.064-.828 1.929-1.846 1.929zm0-2.927c-.418.501-.615.881-.615.998a.63.63 0 00.615.643.63.63 0 00.616-.643c0-.117-.198-.497-.616-.998zM7.077 7.5c-1.018 0-1.846-.865-1.846-1.929 0-.914 1.089-2.064 1.423-2.394a.598.598 0 01.846 0c.334.33 1.423 1.48 1.423 2.394 0 1.064-.828 1.929-1.846 1.929zm0-2.927c-.419.501-.615.882-.615.998a.63.63 0 00.615.643.63.63 0 00.615-.643c0-.117-.197-.497-.615-.998z"
    }));
  }

  var ForwardRef$1b = /*#__PURE__*/React__namespace.forwardRef(SvgCake);

  function SvgCalendar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M8.05 3c.295 0 .534.24.534.535v1.722h6.832V3.535a.535.535 0 111.07 0v1.722h2.643c1.033 0 1.871.838 1.871 1.872v12A1.871 1.871 0 0119.129 21H4.87A1.871 1.871 0 013 19.129v-12c0-1.034.838-1.872 1.871-1.872h2.644V3.535c0-.296.24-.535.534-.535zm7.366 3.327v1.158a.535.535 0 101.07 0V6.327h2.643c.443 0 .802.359.802.802V9.86H4.069V7.13c0-.443.36-.802.802-.802h2.644v1.158a.535.535 0 101.07 0V6.327h6.83zM4.069 10.752v8.377c0 .443.36.802.802.802H19.13c.443 0 .802-.36.802-.802v-8.377H4.069z"
    }));
  }

  var ForwardRef$1a = /*#__PURE__*/React__namespace.forwardRef(SvgCalendar);

  function SvgCall(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.621 20.589l.01.007a4.5 4.5 0 005.6-.615l.63-.63a1.5 1.5 0 000-2.122l-2.654-2.651a1.5 1.5 0 00-2.122 0 1.5 1.5 0 01-2.121 0l-4.242-4.244a1.5 1.5 0 010-2.121 1.5 1.5 0 000-2.122L7.07 3.439a1.5 1.5 0 00-2.121 0l-.63.63a4.5 4.5 0 00-.614 5.6l.006.01a40.61 40.61 0 0010.91 10.91z",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  }

  var ForwardRef$19 = /*#__PURE__*/React__namespace.forwardRef(SvgCall);

  function SvgCamera(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.875 17.75c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-8.75a3.755 3.755 0 00-3.75 3.75 3.755 3.755 0 003.75 3.75 3.755 3.755 0 003.75-3.75A3.755 3.755 0 0013.875 9z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2 8.575v9.8c0 1.034.84 1.875 1.875 1.875h16.25c1.034 0 1.875-.84 1.875-1.875v-10c0-1.034-.84-1.875-1.875-1.875h-1.488l-.732-1.463A1.865 1.865 0 0016.227 4h-4.704c-.716 0-1.358.397-1.678 1.037L9.113 6.5c.16.244.187.536.187.85 0 .138-.018.272-.052.4H9.5a.622.622 0 00.56-.346l.903-1.808a.622.622 0 01.56-.346h4.704c.239 0 .453.133.56.345l.904 1.81c.107.212.32.345.559.345h1.875c.345 0 .625.28.625.625v10c0 .345-.28.625-.625.625H3.875a.625.625 0 01-.625-.625V8.9h-.3c-.358 0-.688-.121-.95-.325z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M4.6 4.95a.75.75 0 011.5 0V6.6h1.65a.75.75 0 110 1.5H6.1v1.65a.75.75 0 11-1.5 0V8.1H2.95a.75.75 0 110-1.5H4.6V4.95z"
    }));
  }

  var ForwardRef$18 = /*#__PURE__*/React__namespace.forwardRef(SvgCamera);

  function SvgCameraOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M3.338 2.277a.75.75 0 10-1.06 1.061l18.384 18.385a.75.75 0 101.06-1.06l-5.972-5.974V8c0-1.654-.402-2-2.125-2H7.061L3.338 2.277zM8.261 7.2l6.239 6.24V8c0-.136.003-.25.005-.345.007-.244.01-.364-.049-.422-.057-.056-.174-.052-.407-.043-.112.005-.251.01-.424.01H8.261zM3.028 6.088C2.219 6.27 2 6.778 2 8v8c0 1.654.402 2 2.125 2h9.5c.507 0 .899-.03 1.2-.114l-1.085-1.085-.115-.001h-9.5c-.173 0-.312.005-.424.01-.233.009-.35.013-.407-.043-.06-.058-.056-.178-.05-.422.003-.095.006-.209.006-.345V8c0-.136-.003-.25-.005-.345-.007-.244-.01-.364.049-.422.057-.056.174-.052.407-.043.112.005.251.01.424.01h.014L3.028 6.088zM20.749 16.43c-.194 0-.381-.043-.557-.128l-2.847-1.365a.59.59 0 01-.28-.805.625.625 0 01.56-.332c.096 0 .192.022.278.063l2.847 1.366V8.77l-2.846 1.367a.649.649 0 01-.279.063.626.626 0 01-.56-.331.59.59 0 01.28-.805l2.846-1.366a1.294 1.294 0 011.443.225c.237.227.366.527.366.848v6.459c0 .184-.045.37-.13.535-.15.287-.408.502-.723.602-.129.041-.263.063-.398.063z"
    }));
  }

  var ForwardRef$17 = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOff);

  function SvgCameraOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M2 16c0 1.654.402 2 2.125 2h9.5c1.723 0 2.125-.346 2.125-2V8c0-1.654-.402-2-2.125-2h-9.5C2.402 6 2 6.346 2 8v8zm1.294-8.767c.085-.083.302-.033.831-.033h9.5c.53 0 .746-.05.831.033.082.08.044.282.044.767v8c0 .485.038.687-.044.767-.085.084-.302.033-.831.033h-9.5c-.53 0-.746.05-.831-.033-.082-.08-.044-.282-.044-.767V8c0-.485-.038-.687.044-.767zm16.898 9.07a1.272 1.272 0 00.955.064c.316-.1.573-.315.722-.602.086-.166.131-.35.131-.535V8.77c0-.32-.13-.621-.366-.848a1.265 1.265 0 00-.884-.352c-.193 0-.387.044-.56.127l-2.845 1.366a.59.59 0 00-.28.805c.107.204.322.331.56.331a.65.65 0 00.28-.063L20.75 8.77v6.459l-2.847-1.366a.656.656 0 00-.278-.063.625.625 0 00-.56.332.59.59 0 00.28.805l2.847 1.365z"
    }));
  }

  var ForwardRef$16 = /*#__PURE__*/React__namespace.forwardRef(SvgCameraOn);

  function SvgCameraSwitch(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M15.081 1.95a.5.5 0 01.64-.301A11 11 0 0111.999 23a.5.5 0 010-1 10 10 0 003.383-19.41.5.5 0 01-.301-.64z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M20.014 1.334a.5.5 0 01-.405.58l-3.261.573 1.612 2.747a.5.5 0 11-.862.506L15.12 2.372a.5.5 0 01.344-.745l3.97-.698a.5.5 0 01.58.405zM12 2a10 10 0 00-3.383 19.41.5.5 0 01-.338.942A11 11 0 0112 1a.5.5 0 110 1z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M6.218 18.082a.5.5 0 01.684.178l1.977 3.368a.5.5 0 01-.345.745l-3.97.698a.5.5 0 11-.173-.985l3.261-.573-1.613-2.747a.5.5 0 01.179-.684zM11.117 7h2.764a1.5 1.5 0 011.341.83l.086.17H17.5A1.5 1.5 0 0119 9.5v6a1.5 1.5 0 01-1.5 1.5h-10A1.5 1.5 0 016 15.5v-6A1.5 1.5 0 017.5 8h2.19l.086-.17a1.5 1.5 0 011.34-.83zm2.764 1h-2.764a.5.5 0 00-.447.276l-.223.447A.5.5 0 0110 9H7.5a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5H15a.5.5 0 01-.447-.275l-.225-.447v-.002A.5.5 0 0013.88 8z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M10.732 10.732a2.5 2.5 0 113.536 3.537 2.5 2.5 0 01-3.536-3.537zM12.5 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
    }));
  }

  var ForwardRef$15 = /*#__PURE__*/React__namespace.forwardRef(SvgCameraSwitch);

  function SvgCar(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.375 18.25c-.8 0-1.507-.512-1.768-1.25H8.143a1.883 1.883 0 01-1.768 1.25c-.8 0-1.507-.512-1.768-1.25h-.732A1.877 1.877 0 012 15.125v-1.25a3.134 3.134 0 012.726-3.1l1.369-2.738C6.415 7.397 7.058 7 7.773 7h6.583c.715 0 1.357.397 1.677 1.037l1.354 2.713h1.488A3.128 3.128 0 0122 13.875v1.25C22 16.159 21.16 17 20.125 17h-1.983a1.881 1.881 0 01-1.767 1.25zm0-2.5a.625.625 0 100 1.25.625.625 0 000-1.25zm-10 0a.625.625 0 100 1.25.625.625 0 000-1.25zm13.75 0c.345 0 .625-.28.625-.625v-1.25c0-1.034-.84-1.875-1.875-1.875H5.125c-1.034 0-1.875.84-1.875 1.875v1.25c0 .345.28.625.625.625h.732a1.883 1.883 0 011.768-1.25c.8 0 1.507.512 1.768 1.25h6.464a1.883 1.883 0 011.767-1.25c.8 0 1.507.512 1.768 1.25h1.983zm-4.135-5l-1.075-2.155a.62.62 0 00-.558-.345H7.773a.622.622 0 00-.559.346L6.136 10.75h9.854z"
    }));
  }

  var ForwardRef$14 = /*#__PURE__*/React__namespace.forwardRef(SvgCar);

  function SvgCheck(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M18.774 7.726l-6.964 9.847a1 1 0 01-1.455.2L5.382 13.63a1.09 1.09 0 01-.159-1.49.99.99 0 011.43-.166l4.147 3.457 6.336-8.959c.208-.325.57-.504.943-.467.373.037.696.284.841.644.146.36.09.774-.146 1.077z"
    }));
  }

  var ForwardRef$13 = /*#__PURE__*/React__namespace.forwardRef(SvgCheck);

  function SvgCheckRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M6.444 3.685A10 10 0 0112 2a10.01 10.01 0 0110 10A10 10 0 116.444 3.685zM7.37 18.93A8.333 8.333 0 0012 20.333 8.342 8.342 0 0020.333 12 8.333 8.333 0 107.37 18.929zm9.662-11.727a1.04 1.04 0 01.643.472 1.042 1.042 0 01-.05 1.157l-5.584 7.572a1.054 1.054 0 01-1.49.196l-3.985-3.188a1.042 1.042 0 011.302-1.628l3.14 2.512 4.936-6.7a1.04 1.04 0 011.088-.393z"
    }));
  }

  var ForwardRef$12 = /*#__PURE__*/React__namespace.forwardRef(SvgCheckRound);

  function SvgCheckboxEmpty(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M18 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2zM6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6z"
    }));
  }

  var ForwardRef$11 = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxEmpty);

  function SvgCheckboxIndeterminate(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2zM2 6a4 4 0 014-4h12a4 4 0 014 4v12a4 4 0 01-4 4H6a4 4 0 01-4-4V6zm5 5a1 1 0 100 2h10a1 1 0 000-2H7z"
    }));
  }

  var ForwardRef$10 = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxIndeterminate);

  function SvgCheckboxSelected(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M6 2a4 4 0 00-4 4v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4H6zm5.81 15.573l6.964-9.847c.235-.303.292-.717.146-1.077a1.022 1.022 0 00-.841-.644 1.003 1.003 0 00-.943.467l-6.335 8.959-4.147-3.457a.99.99 0 00-1.43.165 1.09 1.09 0 00.158 1.49l4.973 4.144a1 1 0 001.455-.2z"
    }));
  }

  var ForwardRef$$ = /*#__PURE__*/React__namespace.forwardRef(SvgCheckboxSelected);

  function SvgChevronDown(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-down_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.979 17.636a1.724 1.724 0 01-1.297-.585L3.324 8.688a1.385 1.385 0 012.08-1.83l6.434 7.314a.188.188 0 00.282 0l6.434-7.314a1.385 1.385 0 112.08 1.83l-7.356 8.36a1.731 1.731 0 01-1.3.588z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-down_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$_ = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDown);

  function SvgChevronDownSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-down-sm_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.986 15.76a1.151 1.151 0 01-.865-.39L6.216 9.794a.923.923 0 011.386-1.22l4.29 4.877a.125.125 0 00.188 0l4.29-4.876a.923.923 0 111.386 1.22l-4.904 5.573a1.155 1.155 0 01-.866.392z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-down-sm_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$Z = /*#__PURE__*/React__namespace.forwardRef(SvgChevronDownSm);

  function SvgChevronLeft(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5 11.979a1.725 1.725 0 01.585-1.297l8.364-7.358a1.385 1.385 0 011.829 2.08l-7.314 6.434a.188.188 0 000 .282l7.314 6.434a1.386 1.386 0 11-1.83 2.08l-8.36-7.356a1.733 1.733 0 01-.588-1.3z"
    }));
  }

  var ForwardRef$Y = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeft);

  function SvgChevronLeftSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.24 11.986a1.15 1.15 0 01.39-.865l5.576-4.905a.924.924 0 011.22 1.386l-4.877 4.29a.125.125 0 000 .188l4.876 4.29a.923.923 0 11-1.22 1.386l-5.573-4.904a1.155 1.155 0 01-.392-.866z"
    }));
  }

  var ForwardRef$X = /*#__PURE__*/React__namespace.forwardRef(SvgChevronLeftSm);

  function SvgChevronRight(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.273 11.979a1.724 1.724 0 00-.585-1.297L9.324 3.324a1.385 1.385 0 00-1.83 2.08l7.315 6.434a.188.188 0 010 .282l-7.314 6.434a1.385 1.385 0 101.829 2.08l8.36-7.356a1.733 1.733 0 00.589-1.3z"
    }));
  }

  var ForwardRef$W = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRight);

  function SvgChevronRightSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15.76 11.986a1.148 1.148 0 00-.39-.865L9.794 6.216a.923.923 0 00-1.22 1.386l4.877 4.29a.124.124 0 01.031.145.124.124 0 01-.031.043l-4.876 4.29a.924.924 0 101.22 1.386l5.573-4.904a1.156 1.156 0 00.392-.866z"
    }));
  }

  var ForwardRef$V = /*#__PURE__*/React__namespace.forwardRef(SvgChevronRightSm);

  function SvgChevronUp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-up_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.021 6.364a1.725 1.725 0 011.297.585l7.358 8.363a1.385 1.385 0 01-2.08 1.83l-6.434-7.314a.188.188 0 00-.282 0l-6.434 7.314a1.386 1.386 0 11-2.08-1.83l7.356-8.36a1.733 1.733 0 011.3-.588z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-up_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$U = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUp);

  function SvgChevronUpSm(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#chevron-up-sm_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.014 8.24a1.15 1.15 0 01.865.39l4.905 5.576a.924.924 0 01-1.386 1.22l-4.29-4.877a.125.125 0 00-.188 0l-4.29 4.876a.923.923 0 11-1.386-1.22l4.904-5.573a1.156 1.156 0 01.866-.392z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "chevron-up-sm_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$T = /*#__PURE__*/React__namespace.forwardRef(SvgChevronUpSm);

  function SvgClock(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12 21a9 9 0 100-18 9 9 0 000 18z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 12V8.786M12 12l4.017 4.018",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  }

  var ForwardRef$S = /*#__PURE__*/React__namespace.forwardRef(SvgClock);

  function SvgClose(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M7.05 8.11a.75.75 0 111.06-1.06L12 10.939l3.889-3.89a.75.75 0 011.06 1.061L13.06 12l3.89 3.889a.75.75 0 01-1.061 1.06l-3.89-3.889-3.889 3.89a.75.75 0 01-1.06-1.061l3.889-3.89-3.89-3.889z"
    }));
  }

  var ForwardRef$R = /*#__PURE__*/React__namespace.forwardRef(SvgClose);

  function SvgCloseRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM7.05 8.11a.75.75 0 011.06-1.06L12 10.939l3.889-3.89a.75.75 0 111.06 1.061L13.06 12l3.89 3.889a.75.75 0 01-1.061 1.06l-3.89-3.889-3.889 3.89a.75.75 0 11-1.06-1.061l3.889-3.89-3.89-3.889z"
    }));
  }

  var ForwardRef$Q = /*#__PURE__*/React__namespace.forwardRef(SvgCloseRound);

  function SvgDash(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7 11a1 1 0 100 2h10a1 1 0 100-2H7z"
    }));
  }

  var ForwardRef$P = /*#__PURE__*/React__namespace.forwardRef(SvgDash);

  function SvgDoctor(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#doctor_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M4.969 6.656a3.66 3.66 0 003.625 3.659A5.638 5.638 0 003 15.938a.563.563 0 001.125 0 4.47 4.47 0 011.32-3.183 4.494 4.494 0 012.617-1.28v4.463a.563.563 0 001.126 0v-4.464c.413.051.818.16 1.204.325a.56.56 0 00.738-.297.563.563 0 00-.297-.738 5.577 5.577 0 00-2.177-.45l-.031-.002a3.66 3.66 0 003.656-3.656c0-.135-.009-.275-.029-.438a.517.517 0 00-.017-.114A3.676 3.676 0 008.626 3c-1.281 0-2.486.69-3.143 1.795v.001c-.008.012-.021.031-.034.057a3.652 3.652 0 00-.48 1.803zm1.125 0c0-.213.026-.423.079-.628a5.691 5.691 0 003.482 1.19h.005c.497 0 .99-.064 1.47-.193a2.535 2.535 0 01-2.505 2.162 2.534 2.534 0 01-2.531-2.53zm4.94-.774a4.514 4.514 0 01-1.357.213l-.02-.001H9.65a4.629 4.629 0 01-2.945-1.081 2.53 2.53 0 011.921-.888c1.1 0 2.076.726 2.409 1.757zm-.159 13.806c0 .723.589 1.312 1.313 1.312h7.5C20.41 21 21 20.411 21 19.687v-5.25c0-.723-.589-1.312-1.313-1.312h-1.5v-.938c0-.723-.588-1.312-1.312-1.312H15c-.724 0-1.313.589-1.313 1.313v.937h-1.5c-.723 0-1.312.589-1.312 1.313v5.25zM12 14.438c0-.104.084-.188.188-.188h7.5c.103 0 .187.084.187.188v5.25a.188.188 0 01-.188.187h-7.5a.188.188 0 01-.187-.188v-5.25zm5.063-2.25v.937h-2.25v-.938c0-.103.083-.187.187-.187h1.875c.104 0 .188.084.188.188zm-1.688 6a.563.563 0 001.125 0v-.563h.563a.563.563 0 000-1.125H16.5v-.563a.563.563 0 00-1.125 0v.563h-.563a.563.563 0 000 1.125h.563v.563z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "doctor_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$O = /*#__PURE__*/React__namespace.forwardRef(SvgDoctor);

  function SvgEdit(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.929 13.9l-3.3.471.471-3.3 8.486-8.485a2 2 0 112.828 2.828L12.93 13.9zM17.643 3.529l2.828 2.828",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5.725 2.952c-.17 0-.36.085-.52.287-.16.204-.264.5-.264.824v15.873c0 .325.103.621.265.825.159.202.35.287.52.287h12.548c.17 0 .361-.085.52-.287.162-.204.265-.5.265-.825V12c0-.263.21-.476.47-.476S20 11.737 20 12v7.936c0 .518-.162 1.03-.47 1.42-.312.394-.76.644-1.256.644H5.726c-.495 0-.943-.25-1.254-.644A2.301 2.301 0 014 19.936V4.063c0-.517.162-1.028.47-1.42C4.783 2.25 5.23 2 5.726 2H12c.26 0 .47.213.47.476s-.21.476-.47.476H5.725z"
    }));
  }

  var ForwardRef$N = /*#__PURE__*/React__namespace.forwardRef(SvgEdit);

  function SvgEvolution(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#evolution_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M19.376 2.5a1.624 1.624 0 00-1.589 1.964L15.51 6.245a1.625 1.625 0 00-2.2.533l-2.872-.768a1.624 1.624 0 10-3.203.237l-2.75 2.747a1.624 1.624 0 10.815.461l2.397-2.394a1.624 1.624 0 002.422-.202l2.941.786a1.624 1.624 0 103.07-.74l2.094-1.636.004.005A1.624 1.624 0 1019.376 2.5zM4.41 9.915a.723.723 0 11-.57 1.328.723.723 0 01.57-1.328zm14.455-6.3a.722.722 0 111.021 1.022.722.722 0 01-1.02-1.021zm-8.423 16.483V10.44h2.03v9.656h-2.03zm-.06-10.558a.842.842 0 00-.843.842v9.716H7.51V17.42a.842.842 0 00-.841-.842H4.516a.842.842 0 00-.842.842v2.677h-.722a.451.451 0 000 .902H19.962a.451.451 0 100-.902h-.722V13.9a.842.842 0 00-.842-.843h-2.993v7.039h-2.03V10.38a.842.842 0 00-.842-.842h-2.151zm7.956 4.422v6.136h-2.03V13.96h2.03zM4.576 17.48v2.617h2.031V17.48h-2.03zM8.817 5.163a.722.722 0 100 1.444.722.722 0 000-1.444zm5.867 1.76a.722.722 0 100 1.443.722.722 0 000-1.444z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "evolution_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      transform: "translate(0 .024)",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$M = /*#__PURE__*/React__namespace.forwardRef(SvgEvolution);

  function SvgExams(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5 15.588C5 19.123 8.14 22 12 22s7-2.876 7-6.412c0-4.287-4.074-10.52-5.824-12.998a1.33 1.33 0 00-.426-.39c-.224-.13-.483-.2-.749-.2-.48 0-.919.22-1.175.587C9.074 5.067 5 11.301 5 15.588zm1.4.001c0-4.052 4.28-10.432 5.6-12.302 1.317 1.863 5.6 8.246 5.6 12.302 0 2.828-2.512 5.13-5.6 5.13-3.087 0-5.6-2.302-5.6-5.13zm1.4.002c0 2.12 1.885 3.847 4.2 3.847.387 0 .7-.287.7-.64 0-.354-.313-.642-.7-.642-1.543 0-2.8-1.151-2.8-2.567 0-.353-.313-.64-.7-.64-.386 0-.7.288-.7.642z"
    }));
  }

  var ForwardRef$L = /*#__PURE__*/React__namespace.forwardRef(SvgExams);

  function SvgExit(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.688 19.876a.563.563 0 010-1.125h3.375c.31 0 .563-.252.563-.563v-1.125a.563.563 0 011.125 0v1.125a1.69 1.69 0 01-1.688 1.688h-3.375zM19.188 8.625a.563.563 0 01-.562-.562V6.938a.563.563 0 00-.563-.563h-3.375a.563.563 0 010-1.125h3.375c.93 0 1.688.757 1.688 1.688v1.125c0 .31-.253.562-.563.562zM11.875 21c-.054 0-.108-.004-.16-.012l-6.749-.964A1.131 1.131 0 014 18.911V5.791c0-.528.374-.99.89-1.101l6.733-1.662A1.132 1.132 0 0113 4.125v15.75c0 .3-.118.584-.33.796-.213.212-.496.329-.796.329zM5.142 5.786l-.018.006.001 13.118 6.752.964-.002-15.75-6.733 1.662zM19.189 15.375a.561.561 0 01-.398-.96l1.29-1.29h-4.83a.563.563 0 010-1.125h4.829l-1.29-1.29a.557.557 0 010-.795.561.561 0 01.795 0l2.25 2.25a.568.568 0 01.163.424.613.613 0 01-.05.209.534.534 0 01-.08.125.334.334 0 01-.03.038l-2.25 2.25a.568.568 0 01-.4.164z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.906 12.844a.845.845 0 11.003-1.69.845.845 0 01-.003 1.69z"
    }));
  }

  var ForwardRef$K = /*#__PURE__*/React__namespace.forwardRef(SvgExit);

  function SvgFamily(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.625 9.625a2.815 2.815 0 01-2.813-2.813A2.815 2.815 0 0117.625 4a2.815 2.815 0 012.813 2.813 2.815 2.815 0 01-2.813 2.812zm0-4.5c-.93 0-1.688.757-1.688 1.688 0 .93.757 1.687 1.688 1.687.93 0 1.688-.757 1.688-1.688 0-.93-.757-1.687-1.688-1.687z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.5 19.75a.563.563 0 01-.558-.493l-.141-1.125a.56.56 0 01.557-.633c.284 0 .524.212.559.493l.08.633h1.256l.502-4.007a.563.563 0 01.558-.493h.562V13a2.253 2.253 0 00-3.6-1.8.56.56 0 01-.787-.112.563.563 0 01.112-.788c.58-.435 1.3-.675 2.025-.675A3.38 3.38 0 0121 13v1.688c0 .31-.252.562-.563.562h-.628l-.501 4.007a.563.563 0 01-.558.493H16.5zM6.375 9.625a2.815 2.815 0 01-2.813-2.813A2.815 2.815 0 016.376 4a2.815 2.815 0 012.813 2.813 2.815 2.815 0 01-2.813 2.812zm0-4.5a1.69 1.69 0 00-1.688 1.688c0 .93.757 1.687 1.688 1.687a1.69 1.69 0 001.688-1.688 1.69 1.69 0 00-1.688-1.687zM5.25 19.75a.563.563 0 01-.558-.493l-.501-4.007h-.628A.563.563 0 013 14.687V13a3.38 3.38 0 013.375-3.375c.725 0 1.444.24 2.025.675a.563.563 0 01-.675.9 2.253 2.253 0 00-3.6 1.8v1.125h.563c.282 0 .522.211.558.493l.5 4.007h1.257l.08-.632a.563.563 0 011.116.14l-.141 1.124a.563.563 0 01-.558.493H5.25zM12 11.875c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25 2.25 1.01 2.25 2.25-1.01 2.25-2.25 2.25zM12 8.5c-.62 0-1.125.505-1.125 1.125S11.38 10.75 12 10.75s1.125-.505 1.125-1.125S12.62 8.5 12 8.5zM10.875 19.75a.56.56 0 01-.555-.47l-.484-2.905h-.649a.563.563 0 01-.562-.563v-.562A3.38 3.38 0 0112 11.875a3.38 3.38 0 013.375 3.375v.563c0 .31-.252.562-.563.562h-.648l-.485 2.905a.56.56 0 01-.555.47h-2.249zm1.774-1.125l.484-2.905a.56.56 0 01.555-.47h.562c0-1.24-1.01-2.25-2.25-2.25s-2.25 1.01-2.25 2.25h.563a.56.56 0 01.554.47l.484 2.905h1.298z"
    }));
  }

  var ForwardRef$J = /*#__PURE__*/React__namespace.forwardRef(SvgFamily);

  function SvgFold(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.461 22c-.166 0-.332-.024-.493-.07l-8.615-2.48c-.795-.227-1.351-.983-1.353-1.838v-13.7C4 2.859 4.828 2 5.846 2h12.308C19.172 2 20 2.858 20 3.913v13.389c0 1.055-.828 1.912-1.846 1.912h-1.846v.873c0 .51-.192.99-.541 1.352-.348.361-.811.56-1.306.561zM5.841 3.275a.628.628 0 00-.61.638V17.61c0 .284.186.536.451.611l8.616 2.48a.61.61 0 00.598-.163c.117-.12.18-.28.18-.451V6.794a.635.635 0 00-.45-.613l-8.64-2.89a.657.657 0 00-.137-.016H5.84zM18.153 17.94c.34 0 .615-.285.615-.637V3.912a.627.627 0 00-.615-.637h-8.21l5.034 1.684c.777.222 1.329.979 1.33 1.835v11.144h1.846v.001z"
    }));
  }

  var ForwardRef$I = /*#__PURE__*/React__namespace.forwardRef(SvgFold);

  function SvgGenderFemale(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22.364a.637.637 0 01-.636-.637v-1.909h-1.91a.637.637 0 010-1.273h1.91v-2.574A6.989 6.989 0 015 9c0-3.86 3.14-7 7-7s7 3.14 7 7a6.989 6.989 0 01-6.364 6.971v2.575h1.91a.637.637 0 010 1.272h-1.91v1.91a.637.637 0 01-.636.636zm0-19.091A5.734 5.734 0 006.273 9 5.734 5.734 0 0012 14.727 5.734 5.734 0 0017.727 9 5.734 5.734 0 0012 3.273z"
    }));
  }

  var ForwardRef$H = /*#__PURE__*/React__namespace.forwardRef(SvgGenderFemale);

  function SvgGenderMale(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.19 21a6.152 6.152 0 01-4.379-1.81 6.19 6.19 0 010-8.751l.005-.005A6.151 6.151 0 019.19 8.626c1.455 0 2.852.507 3.963 1.432l5.925-5.933h-3.71a.563.563 0 110-1.125h5.066a.556.556 0 01.221.045.56.56 0 01.301.303.541.541 0 01.043.215v5.063a.563.563 0 01-1.126 0V4.923l-5.923 5.93a6.174 6.174 0 01-.379 8.337A6.161 6.161 0 019.191 21zm-3.587-9.762a5.066 5.066 0 00.005 7.157 5.038 5.038 0 003.583 1.48 5.038 5.038 0 003.584-1.48 5.066 5.066 0 000-7.16A5.037 5.037 0 009.192 9.75a5.036 5.036 0 00-3.589 1.487z"
    }));
  }

  var ForwardRef$G = /*#__PURE__*/React__namespace.forwardRef(SvgGenderMale);

  function SvgGlasses(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.457 4a.75.75 0 000 1.5A1.045 1.045 0 0119.5 6.543v5.574a.188.188 0 01-.294.155 4.153 4.153 0 00-5.827 1.12.375.375 0 01-.468.133 2.175 2.175 0 00-1.822 0 .375.375 0 01-.468-.133 4.152 4.152 0 00-5.827-1.12.187.187 0 01-.294-.155V6.543A1.045 1.045 0 015.543 5.5a.75.75 0 000-1.5A2.55 2.55 0 003 6.543v9.15a4.158 4.158 0 008.315 0v-.18a.685.685 0 111.37 0v.18a4.158 4.158 0 008.315 0v-9.15A2.55 2.55 0 0018.457 4zm-11.3 14.348a2.658 2.658 0 110-5.316 2.658 2.658 0 010 5.316zm9.686 0a2.658 2.658 0 11-.002-5.317 2.658 2.658 0 01.002 5.316z"
    }));
  }

  var ForwardRef$F = /*#__PURE__*/React__namespace.forwardRef(SvgGlasses);

  function SvgHandshake(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.883 18.255c-.509 0-.99-.22-1.321-.604l-2.734-3.063H5.436c-.27.343-.673.544-1.112.544l-.058-.001H2.624a.625.625 0 01.001-1.25h1.668c.079 0 .139-.029.174-.076a.684.684 0 01.033-.096V8.394c-.003-.066-.088-.139-.182-.139H2.625a.625.625 0 010-1.25h1.71c.668 0 1.247.49 1.385 1.133l2.882-1.152a2.363 2.363 0 012.29.292l.01.008 2.01-1.011a2.59 2.59 0 012.046-.118l3.647 1.334a1.42 1.42 0 011.13-.485h1.64a.625.625 0 010 1.25l-1.69-.001c-.1 0-.182.074-.186.168l.001 5.319c.003.067.082.14.166.14l.029-.001h1.68a.625.625 0 010 1.25h-1.712c-.405 0-.785-.177-1.053-.482l-3.886.743a.636.636 0 01-.16.008 1.997 1.997 0 01-1.908 1.382h-.053a1.742 1.742 0 01-1.72 1.473zm-3.775-4.917c.178 0 .348.075.466.208l2.927 3.28a.493.493 0 00.874-.314v-.254l-.632-.631a.627.627 0 01.442-1.068c.167 0 .324.065.442.184l.724.724.026.01a.753.753 0 001-.477l-1.004-1.004a.62.62 0 010-.883.624.624 0 01.884 0l1.04 1.04h.148a.599.599 0 00.478-.957L12.586 10.2l-1.267.418a1.59 1.59 0 01-1.934-.84 1.59 1.59 0 01.232-1.706 1.141 1.141 0 00-.548.072L5.75 9.474v3.864h1.358zm8.809-.901a1.869 1.869 0 01.356 1.386l1.977-.377V8.693l-3.722-1.362a1.323 1.323 0 00-1.054.06l-2.8 1.409a.342.342 0 00-.155.452.336.336 0 00.409.18l2.889-.955a.624.624 0 11.392 1.188l-.362.12 2.07 2.652z"
    }));
  }

  var ForwardRef$E = /*#__PURE__*/React__namespace.forwardRef(SvgHandshake);

  function SvgHealthInsurance(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3.875 20C2.841 20 2 19.172 2 18.154V5.846C2 4.828 2.84 4 3.875 4h16.25C21.159 4 22 4.828 22 5.846v12.308C22 19.172 21.16 20 20.125 20H3.875zm-.625-1.846c0 .34.28.615.625.615h16.25a.62.62 0 00.625-.615v-9.23H3.25v9.23zm17.5-10.462V5.846a.62.62 0 00-.625-.615H3.875a.62.62 0 00-.625.615v1.846h17.5z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.875 12.615A.62.62 0 0113.25 12c0-.34.28-.615.625-.615h5A.62.62 0 0119.5 12a.62.62 0 01-.625.615h-5zM13.875 16.308a.62.62 0 01-.625-.616c0-.34.28-.615.625-.615h2.5a.62.62 0 01.625.615.62.62 0 01-.625.616h-2.5zM8.25 16.923a.62.62 0 01-.625-.615v-1.846H5.75a.62.62 0 01-.625-.616c0-.34.28-.615.625-.615h1.875v-1.846c0-.34.28-.616.625-.616a.62.62 0 01.625.616v1.846h1.875a.62.62 0 01.625.615.62.62 0 01-.625.616H8.875v1.846a.62.62 0 01-.625.615z"
    }));
  }

  var ForwardRef$D = /*#__PURE__*/React__namespace.forwardRef(SvgHealthInsurance);

  function SvgHeartbeat(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M2.68 11.018a.623.623 0 00.85.244c.3-.17.41-.554.242-.857a4.156 4.156 0 01-.089-3.859 4.086 4.086 0 012.372-2.072 4.041 4.041 0 013.132.224c.396.2.754.46 1.067.775l1.306 1.31a.617.617 0 00.883-.001l1.305-1.314a4.06 4.06 0 012.9-1.208 4.06 4.06 0 012.9 1.208c.313.314.572.675.769 1.072a4.16 4.16 0 01-.086 3.86.63.63 0 00.545.936.625.625 0 00.547-.323c.86-1.558.902-3.44.111-5.035a5.394 5.394 0 00-1.002-1.4A5.298 5.298 0 0016.647 3c-1.43 0-2.774.56-3.784 1.578l-.864.87-.863-.865a5.332 5.332 0 00-1.39-1.01A5.274 5.274 0 005.66 3.28a5.33 5.33 0 00-3.095 2.703 5.42 5.42 0 00.115 5.035zm9.375 4.74a.935.935 0 01-.893-.655l-1.18-3.953-1.087 2.184a.932.932 0 01-.839.521H2.625a.627.627 0 01-.625-.63c0-.347.28-.628.625-.628h5.238l1.35-2.72a.93.93 0 01.841-.525.942.942 0 01.902.685l1.15 3.86.967-2.276a.94.94 0 011.234-.495c.166.072.307.19.407.34l.746 1.126h5.915c.345 0 .625.282.625.63 0 .347-.28.629-.625.629h-6.25a.624.624 0 01-.52-.28l-.61-.922-1.08 2.541a.955.955 0 01-.572.521.942.942 0 01-.288.046zm-.057 4.74c-.323 0-.63-.123-.863-.35l-.032-.03-3.75-3.94a.623.623 0 01-.173-.449.627.627 0 011.076-.423l3.737 3.926 3.75-3.925a.625.625 0 011.075.422.631.631 0 01-.173.449l-3.743 3.932a1.24 1.24 0 01-.875.388h-.029z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.68 11.018l.044-.024-.044.024zm.85.244l.024.044-.024-.044zm.242-.857l.043-.024-.043.024zm-.089-3.859l-.044-.022.044.022zm2.372-2.072l-.016-.047.016.047zm3.132.224l-.022.045.022-.045zm1.067.775l-.036.035.036-.035zm1.306 1.31l.036-.035-.036.035zm.883-.001l-.036-.035.036.035zm1.305-1.314l-.036-.035.036.035zm5.8 0l-.035.035.036-.035zm.769 1.072l.045-.022-.045.022zm-.086 3.86l-.044-.024.044.024zm-.055.479l.048-.014-.048.014zm.297.377l.024-.043-.024.043zm.85-.243l.043.024-.043-.024zm.111-5.035l.045-.022-.045.022zm-1.002-1.4l.035-.035-.035.035zm-7.57 0l.036.036-.035-.036zm-.864.87l-.035.035.036.036.035-.036-.036-.035zm-.862-.865l-.035.035.035-.035zm-1.39-1.01l.023-.045-.023.045zM5.66 3.28l.016.048-.016-.048zM2.565 5.983l-.045-.022.045.022zm8.597 9.12l-.048.014v.001l.048-.015zm-1.18-3.953l.049-.014-.037-.122-.056.114.045.022zm-1.087 2.184l.045.022-.045-.022zm-1.032-.737v.05h.03l.015-.028-.045-.022zm1.35-2.72l.045.023-.045-.022zm.532-.473l.017.048-.017-.048zm.718.042l-.022.045.022-.045zm.493.59l-.048.014.048-.014zm1.15 3.86l-.047.015.04.133.054-.128-.046-.02zm.967-2.275l-.046-.02.046.02zm1.234-.495l-.02.045.02-.045zm.407.34l-.042.028.042-.028zm.746 1.126l-.042.028.015.022h.027v-.05zm-.854.979l-.042.027.042-.027zm-.61-.922l.041-.027-.051-.078-.036.086.046.02zm-1.081 2.541l.046.02-.046-.02zm-.572.521l.016.048-.016-.048zm-1.208 4.438l-.035.035.035-.035zm.863.35v.05H12l-.002-.05zm-.895-.381l-.036.034.001.001.035-.035zm-3.75-3.94l-.036.034.036-.034zm-.173-.449l.05.001-.05-.001zm.192-.441l-.035-.036.035.036zm.884.018l.036-.034-.036.034zm3.737 3.926l-.036.035.036.038.037-.038-.037-.035zm3.75-3.925l.035.034-.036-.034zm.882-.02l.035-.035-.035.036zm.02.891l.036.034-.036-.034zm-3.743 3.932l-.037-.034.037.034zm-.875.388l-.002-.05.002.05zM3.226 11.29a.573.573 0 01-.502-.297l-.088.048a.673.673 0 00.59.349v-.1zm.28-.073a.58.58 0 01-.28.073v.1a.68.68 0 00.328-.085l-.048-.088zm.222-.788a.584.584 0 01-.223.789l.05.087a.684.684 0 00.26-.925l-.087.049zm-.09-3.906a4.206 4.206 0 00.09 3.906l.087-.049a4.106 4.106 0 01-.087-3.813l-.09-.044zm2.4-2.097a4.136 4.136 0 00-2.4 2.097l.09.044a4.036 4.036 0 012.343-2.046l-.032-.095zm1.318-.217c-.445 0-.888.073-1.317.217l.032.095c.419-.14.85-.212 1.285-.212v-.1zm1.853.444a4.091 4.091 0 00-1.853-.444v.1c.63 0 1.238.146 1.809.433l.044-.09zm1.08.784a4.136 4.136 0 00-1.08-.784l-.044.09c.39.196.744.453 1.053.764l.071-.07zm1.307 1.31l-1.307-1.31-.07.07 1.306 1.31.07-.07zm.405.169a.568.568 0 01-.405-.17l-.071.071a.667.667 0 00.476.199v-.1zm.406-.17a.568.568 0 01-.406.17v.1c.18 0 .35-.071.477-.2l-.07-.07zm1.305-1.314l-1.305 1.314.071.07 1.305-1.314-.071-.07zm2.936-1.223a4.11 4.11 0 00-2.936 1.223l.071.07a4.01 4.01 0 012.865-1.193v-.1zm2.936 1.223a4.11 4.11 0 00-2.936-1.223v.1a4.01 4.01 0 012.865 1.193l.071-.07zm.778 1.085a4.15 4.15 0 00-.778-1.085l-.07.07c.308.31.563.667.758 1.06l.09-.045zm-.087 3.907a4.21 4.21 0 00.087-3.907l-.09.045a4.11 4.11 0 01-.085 3.813l.088.049zm-.05.44a.58.58 0 01.05-.44l-.088-.049a.68.68 0 00-.059.516l.096-.027zm.272.348a.57.57 0 01-.273-.348l-.096.027a.67.67 0 00.32.408l.05-.087zm.28.073a.57.57 0 01-.28-.073l-.049.087c.1.056.214.086.328.086v-.1zm.502-.297a.576.576 0 01-.503.297v.1c.245 0 .47-.133.59-.349l-.087-.048zM21.389 6a5.377 5.377 0 01-.11 4.989l.087.048a5.477 5.477 0 00.113-5.081L21.39 6zm-.992-1.386c.403.406.737.873.993 1.386l.09-.044c-.262-.524-.601-.999-1.013-1.413l-.07.07zm-3.75-1.564c1.417 0 2.748.555 3.75 1.564l.07-.07a5.348 5.348 0 00-3.82-1.594v.1zm-3.749 1.564a5.248 5.248 0 013.75-1.564v-.1c-1.444 0-2.8.566-3.82 1.593l.07.07zm-.864.869l.864-.87-.07-.07-.865.87.07.07zm-.933-.865l.862.865.07-.07-.862-.866-.07.07zm-1.377-1c.51.258.974.593 1.377 1l.07-.07a5.384 5.384 0 00-1.402-1.02l-.045.09zm-2.368-.566c.824 0 1.62.19 2.368.566l.045-.09a5.324 5.324 0 00-2.413-.576v.1zm-1.68.276a5.264 5.264 0 011.68-.276v-.1c-.58 0-1.155.094-1.712.28l.032.096zM2.61 6.005a5.28 5.28 0 013.066-2.677l-.032-.095A5.38 5.38 0 002.52 5.96l.09.044zm.114 4.989a5.37 5.37 0 01-.114-4.989l-.09-.044a5.47 5.47 0 00.116 5.081l.088-.048zm8.39 4.124c.132.413.51.69.941.69v-.1a.885.885 0 01-.846-.62l-.095.03zm-1.18-3.954l1.18 3.953.096-.028-1.18-3.954-.095.03zm-.994 2.192l1.087-2.184-.09-.045-1.086 2.185.089.044zm-.884.55c.377 0 .715-.21.884-.55l-.09-.044a.882.882 0 01-.794.493v.1zm-5.431 0h5.431v-.1H2.625v.1zm-.675-.68c0 .374.302.68.675.68v-.1a.577.577 0 01-.575-.58h-.1zm.675-.68a.677.677 0 00-.675.68h.1c0-.32.258-.58.575-.58v-.1zm5.238 0H2.625v.1h5.238v-.1zm1.305-2.69l-1.35 2.718.09.045 1.35-2.72-.09-.044zm.56-.499a.98.98 0 00-.56.499l.09.043a.88.88 0 01.504-.447l-.033-.095zm.326-.055c-.11 0-.22.018-.325.055l.033.095a.878.878 0 01.292-.05v-.1zm.43.1a.975.975 0 00-.43-.1v.1c.134 0 .264.03.387.09l.043-.09zm.52.62a.992.992 0 00-.52-.62l-.043.09c.227.11.397.313.467.558l.096-.027zm1.15 3.86l-1.15-3.86-.096.029 1.15 3.86.097-.029zm.873-2.281l-.966 2.276.092.039.966-2.276-.092-.039zm.91-.603a.99.99 0 00-.91.603l.092.04a.89.89 0 01.818-.543v-.1zm.39.082a.974.974 0 00-.39-.082v.1c.121 0 .24.025.35.073l.04-.091zm.429.359a.982.982 0 00-.429-.36l-.04.092c.157.069.29.18.385.323l.084-.055zm.745 1.126l-.745-1.126-.084.055.746 1.126.083-.055zm5.874-.023H15.46v.1h5.915v-.1zm.675.68a.677.677 0 00-.675-.68v.1c.317 0 .575.26.575.58h.1zm-.675.679a.677.677 0 00.675-.68h-.1c0 .32-.258.58-.575.58v.1zm-6.25 0h6.25v-.1h-6.25v.1zm-.561-.303c.126.19.335.303.562.303v-.1a.574.574 0 01-.479-.258l-.083.055zm-.61-.921l.61.921.083-.055-.61-.921-.083.055zm-.993 2.533l1.08-2.541-.091-.04-1.081 2.542.092.039zm-.602.549c.264-.086.482-.283.601-.548l-.09-.041a.906.906 0 01-.542.494l.03.095zm-.304.048a.992.992 0 00.304-.048l-.031-.095a.892.892 0 01-.273.043v.1zm-.955 4.378c.243.234.562.364.898.364v-.1c-.31 0-.604-.12-.828-.336l-.07.072zm-.032-.032l.032.032.07-.072-.032-.031-.07.071zm-3.751-3.94l3.75 3.94.073-.07-3.75-3.94-.073.07zm-.187-.485a.673.673 0 00.187.484l.072-.069a.573.573 0 01-.16-.413l-.1-.002zm.207-.476a.677.677 0 00-.207.476l.1.002a.577.577 0 01.177-.406l-.07-.072zm.468-.19a.67.67 0 00-.468.19l.07.072a.57.57 0 01.398-.162v-.1zm.487.21a.677.677 0 00-.487-.21v.1c.155 0 .307.065.415.179l.072-.07zm3.738 3.926l-3.738-3.926-.072.069 3.737 3.926.073-.069zm3.676-3.926l-3.749 3.926.072.069 3.75-3.925-.073-.07zm.487-.209a.675.675 0 00-.487.21l.072.068a.575.575 0 01.415-.178v-.1zm.467.188a.673.673 0 00-.467-.188v.1c.149 0 .29.057.398.16l.069-.072zm.208.477a.677.677 0 00-.208-.476l-.07.072a.577.577 0 01.178.406l.1-.002zm-.187.484a.681.681 0 00.187-.484l-.1.002a.582.582 0 01-.16.414l.073.068zm-3.743 3.933l3.743-3.933-.073-.069-3.743 3.933.073.069zm-.91.403c.346-.008.67-.151.91-.403l-.073-.07a1.19 1.19 0 01-.84.373l.003.1zm-.028 0h.028l-.003-.1h-.028l.003.1z"
    }));
  }

  var ForwardRef$C = /*#__PURE__*/React__namespace.forwardRef(SvgHeartbeat);

  function SvgHome(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5.384 21a.736.736 0 01-.73-.633l-.008-.1v-8.744l-1.387 1.38a.741.741 0 01-1.043 0 .728.728 0 01-.072-.953l.072-.082 8.325-8.273a2.068 2.068 0 012.78-.114l.133.121 8.33 8.265a.728.728 0 010 1.035.741.741 0 01-.96.072l-.083-.071-1.388-1.378v8.743c0 .37-.277.677-.637.725l-.1.007H5.384zm6.611-16.536a.59.59 0 00-.343.11l-.07.058-5.461 5.425v9.478l2.495-.001v-3.207c0-1.856 1.515-3.36 3.384-3.36 1.806 0 3.282 1.405 3.379 3.175l.005.184-.001 3.208 2.496.001-.001-9.473-5.469-5.426a.588.588 0 00-.414-.172zM12 14.431c-1.004 0-1.827.77-1.903 1.747l-.006.148-.001 3.208h3.819v-3.207A1.902 1.902 0 0012 14.43z"
    }));
  }

  var ForwardRef$B = /*#__PURE__*/React__namespace.forwardRef(SvgHome);

  function SvgHospital(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#hospital_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5.54 6.442a3.08 3.08 0 116.158 0 3.08 3.08 0 01-6.159 0zm3.078-4.376a4.376 4.376 0 100 8.752 4.376 4.376 0 000-8.752zM4.296 10.17a.648.648 0 10-1.296 0v11.182a.648.648 0 001.296 0V10.169zm6.387 4.55a.594.594 0 01.42-.175H19.8a.594.594 0 01.595.594v5.564h-9.886V15.14c0-.157.062-.308.174-.42zm.42-1.471h1.837v-2.443a.648.648 0 011.296 0v2.443H19.8a1.89 1.89 0 011.891 1.89v6.213c0 .358-.29.648-.648.648H7.376a.648.648 0 110-1.297h1.836V15.14a1.89 1.89 0 011.891-1.89zM8.618 4.55c.358 0 .648.29.648.648v.595h.594a.648.648 0 010 1.296h-.594v.594a.648.648 0 11-1.296 0V7.09h-.594a.648.648 0 110-1.296h.594v-.595c0-.358.29-.648.648-.648zm-3.133 9.346c0-.358.29-.648.648-.648h1.243a.648.648 0 010 1.296H6.133a.648.648 0 01-.648-.648zm.648 3.079a.648.648 0 100 1.296h1.243a.648.648 0 100-1.296H6.133zm6.186 1.906c0-.358.29-.648.648-.648h1.242a.648.648 0 110 1.297h-1.242a.648.648 0 01-.648-.649zm4.375-.648a.648.648 0 100 1.297h1.243a.648.648 0 000-1.297h-1.243zm-4.375-1.837c0-.357.29-.648.648-.648h1.242a.648.648 0 110 1.297h-1.242a.648.648 0 01-.648-.648zm4.375-.648a.648.648 0 100 1.297h1.243a.648.648 0 100-1.297h-1.243z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "hospital_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      transform: "translate(0 .154)",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$A = /*#__PURE__*/React__namespace.forwardRef(SvgHospital);

  function SvgId(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.875 12.125a2.816 2.816 0 01-2.813-2.813A2.816 2.816 0 018.876 6.5a2.816 2.816 0 012.813 2.813 2.816 2.816 0 01-2.813 2.812zm0-4.375c-.862 0-1.563.7-1.563 1.563 0 .861.701 1.562 1.563 1.562s1.563-.7 1.563-1.563c0-.861-.701-1.562-1.563-1.562z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.125 16.5a.625.625 0 01-.625-.625A4.38 4.38 0 018.875 11.5a4.38 4.38 0 014.375 4.375c0 .345-.28.625-.625.625h-7.5zm6.812-1.25a3.15 3.15 0 00-3.062-2.5 3.15 3.15 0 00-3.062 2.5h6.124zM13.875 10.25a.625.625 0 010-1.25h3.75a.625.625 0 010 1.25h-3.75zM13.875 12.75a.625.625 0 010-1.25h5a.625.625 0 010 1.25h-5z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.625 20.25a.625.625 0 01-.625-.625.625.625 0 00-1.25 0c0 .345-.28.625-.625.625h-6.25a.625.625 0 01-.625-.625.625.625 0 00-1.25 0c0 .345-.28.625-.625.625h-2.5A1.877 1.877 0 012 18.375v-12.5C2 4.841 2.84 4 3.875 4h16.25C21.159 4 22 4.84 22 5.875v12.5c0 1.034-.84 1.875-1.875 1.875h-2.5zm2.5-1.25c.345 0 .625-.28.625-.625v-12.5a.625.625 0 00-.625-.625H3.875a.625.625 0 00-.625.625v12.5c0 .345.28.625.625.625h1.982a1.883 1.883 0 011.768-1.25c.8 0 1.507.512 1.768 1.25h5.214a1.883 1.883 0 011.768-1.25c.8 0 1.507.512 1.768 1.25h1.982z"
    }));
  }

  var ForwardRef$z = /*#__PURE__*/React__namespace.forwardRef(SvgId);

  function SvgInfoRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2 12.176a10.04 10.04 0 002.965 7.012 9.709 9.709 0 007.05 2.814 10.173 10.173 0 007.092-3.044 9.836 9.836 0 002.892-7.13A9.817 9.817 0 0012.164 2h-.18A10.092 10.092 0 002 12.176zm11.21 4.672a1.211 1.211 0 11-2.421 0v-5.45a1.211 1.211 0 112.421 0v5.45zM11.973 5.921h.026a1.514 1.514 0 11.026 3.028h-.026a1.514 1.514 0 11-.024-3.028h-.002z"
    }));
  }

  var ForwardRef$y = /*#__PURE__*/React__namespace.forwardRef(SvgInfoRound);

  function SvgLab(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5.164 21.495c.415.33.896.504 1.392.505H17.44c.683 0 1.326-.325 1.81-.915.483-.59.749-1.376.749-2.21 0-.606-.143-1.194-.414-1.703L15.071 8.69V3.25h.512c.282 0 .512-.28.512-.625S15.865 2 15.583 2H8.416c-.282 0-.512.28-.512.625s.23.625.512.625h.512v5.44l-4.516 8.482c-.768 1.445-.432 3.384.752 4.323zm.558-1.047c-.71-.564-.912-1.728-.45-2.595l2.45-4.602h8.555l2.45 4.603c.163.305.25.659.25 1.022 0 .5-.16.971-.45 1.326-.29.354-.676.549-1.087.549H6.556c-.297-.001-.585-.106-.834-.303zM14.13 9.216L15.612 12H8.387l1.482-2.784a.728.728 0 00.083-.341V3.25h4.095V4.5h-1.536c-.282 0-.512.28-.512.625s.23.625.512.625h1.536V7h-1.536c-.282 0-.512.28-.512.625s.23.625.512.625h1.536v.625c0 .122.029.24.083.34zm-.083 8.847c0 .31.23.562.512.562.282 0 .512-.252.512-.563V17.5h.512c.282 0 .512-.252.512-.563 0-.31-.23-.562-.512-.562h-.512v-.563c0-.31-.23-.562-.512-.562-.283 0-.512.252-.512.563v.562h-.512c-.283 0-.512.252-.512.563 0 .31.23.562.512.562h.512v.563zm-5.632 1.406a.474.474 0 01-.09-.01c-.35-.046-.628-.352-.67-.736a.59.59 0 010-.196c.041-.385.32-.692.671-.738a.49.49 0 01.176 0c.351.045.63.352.672.738a.59.59 0 010 .196c-.04.384-.319.691-.668.737a.446.446 0 01-.09.009zm1.957-2.26a.465.465 0 00.181 0c.347-.045.625-.35.668-.73a.666.666 0 00.01-.104c0-.429-.292-.786-.68-.835a.491.491 0 00-.177 0c-.35.045-.63.352-.671.737a.673.673 0 000 .196c.041.384.32.69.67.737z"
    }));
  }

  var ForwardRef$x = /*#__PURE__*/React__namespace.forwardRef(SvgLab);

  function SvgLink(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M19.272 4.054l.673.673h-.004a3.612 3.612 0 010 5.11l-4.377 4.377a3.585 3.585 0 01-2.555 1.057 3.587 3.587 0 01-2.554-1.057.756.756 0 111.068-1.066 2.085 2.085 0 001.486.616 2.088 2.088 0 001.488-.616l4.377-4.378a2.102 2.102 0 000-2.975l-.674-.674a2.106 2.106 0 00-2.974 0L13.037 7.31a.755.755 0 01-1.067-1.067l2.192-2.189a3.623 3.623 0 015.11 0zm-10.5 14.822l2.065-2.065.002-.002a.755.755 0 111.067 1.068L9.842 19.94a3.612 3.612 0 01-5.11 0l-.674-.673a3.613 3.613 0 010-5.109l4.378-4.377a3.616 3.616 0 015.11 0l.674.673a.756.756 0 11-1.07 1.07l-.675-.673a2.105 2.105 0 00-2.975 0l-4.377 4.377a2.103 2.103 0 000 2.974l.673.673a2.153 2.153 0 002.975 0z"
    }));
  }

  var ForwardRef$w = /*#__PURE__*/React__namespace.forwardRef(SvgLink);

  function SvgLoading(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M8.91 2.49A10 10 0 0122 12a1 1 0 11-2 0 8 8 0 10-5.528 7.608 1 1 0 11.618 1.903A10.001 10.001 0 018.91 2.489z"
    }));
  }

  var ForwardRef$v = /*#__PURE__*/React__namespace.forwardRef(SvgLoading);

  function SvgLock(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6.75 22C5.785 22 5 21.185 5 20.182V11.09c0-1.003.785-1.818 1.75-1.818h.583V6.848C7.333 4.175 9.427 2 12 2s4.667 2.175 4.667 4.848v2.425h.583c.965 0 1.75.815 1.75 1.818v9.09C19 21.186 18.215 22 17.25 22H6.75zm0-11.515a.595.595 0 00-.583.606v9.09c0 .335.261.607.583.607h10.5a.595.595 0 00.583-.606V11.09a.595.595 0 00-.583-.606H6.75zm8.75-1.212V6.848c0-2.004-1.57-3.636-3.5-3.636S8.5 4.844 8.5 6.848v2.425h7z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 17.152a.595.595 0 01-.583-.606V14.12c0-.334.261-.606.583-.606.322 0 .583.272.583.606v2.425a.595.595 0 01-.583.606z"
    }));
  }

  var ForwardRef$u = /*#__PURE__*/React__namespace.forwardRef(SvgLock);

  function SvgMail(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4 19c-1.103 0-2-.856-2-1.91V6.91a1.83 1.83 0 01.443-1.198l.02-.023A2.028 2.028 0 014 5h16a2.035 2.035 0 011.562.717l.016.022c.276.339.422.742.422 1.17v10.182C22 18.144 21.103 19 20 19H4zm-.667-1.91c0 .352.299.637.667.637h16c.368 0 .667-.285.667-.636V7.174l-6.468 5.748a3.737 3.737 0 01-2.199.713 3.737 3.737 0 01-2.2-.713L3.334 7.174v9.917zm7.28-5.177c.395.29.887.45 1.387.45s.991-.16 1.386-.45l6.32-5.641H4.293l6.321 5.641z"
    }));
  }

  var ForwardRef$t = /*#__PURE__*/React__namespace.forwardRef(SvgMail);

  function SvgMenu(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12 3.6a1.4 1.4 0 100 2.8 1.4 1.4 0 000-2.8zM9.4 5a2.6 2.6 0 115.2 0 2.6 2.6 0 01-5.2 0zm2.6 5.6a1.4 1.4 0 100 2.8 1.4 1.4 0 000-2.8zM9.4 12a2.6 2.6 0 115.2 0 2.6 2.6 0 01-5.2 0zm1.2 7a1.4 1.4 0 112.8 0 1.4 1.4 0 01-2.8 0zm1.4-2.6a2.6 2.6 0 100 5.2 2.6 2.6 0 000-5.2z"
    }));
  }

  var ForwardRef$s = /*#__PURE__*/React__namespace.forwardRef(SvgMenu);

  function SvgMessage(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M19.5 4h-15A1.5 1.5 0 003 5.5v10.164a1.465 1.465 0 001.5 1.461h1.875v2.625a.75.75 0 001.177.617l4.682-3.242H19.5a1.5 1.5 0 001.5-1.5V5.5A1.5 1.5 0 0019.5 4zm0 11.438a.188.188 0 01-.188.187H12a.75.75 0 00-.427.133l-3.698 2.56v-1.943a.75.75 0 00-.75-.75H4.687a.188.188 0 01-.187-.188v-9.75a.187.187 0 01.188-.187h14.625a.188.188 0 01.187.188v9.75zm-12-5.813h9a.75.75 0 100-1.5h-9a.75.75 0 000 1.5zm9 3.375h-9a.75.75 0 110-1.5h9a.75.75 0 110 1.5z"
    }));
  }

  var ForwardRef$r = /*#__PURE__*/React__namespace.forwardRef(SvgMessage);

  function SvgMicOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 18.667V22M12.5 15.969c-.166.02-.333.031-.5.031v0a4 4 0 01-4-4v-.667M8.501 4.06A4 4 0 0112 2v0a4 4 0 014 4v6",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.78 18.08a6.845 6.845 0 01-2.78.587v0a6.55 6.55 0 01-6.667-6.386V10M18.667 10v2.28c0 .831-.17 1.653-.498 2.415M4 3.333L20 20",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  }

  var ForwardRef$q = /*#__PURE__*/React__namespace.forwardRef(SvgMicOff);

  function SvgMicOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 18.25v3.125M14.617 17.738c-.82.364-1.72.513-2.617.512a6.14 6.14 0 01-6.25-5.987v-2.138m3.67 7.608c.82.363 1.732.518 2.63.517a6.14 6.14 0 006.25-5.987v-2.138",
      stroke: "currentcolor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React__namespace.createElement("rect", {
      x: 8.5,
      y: 2.5,
      width: 7,
      height: 13,
      rx: 3.5,
      stroke: "currentcolor"
    }));
  }

  var ForwardRef$p = /*#__PURE__*/React__namespace.forwardRef(SvgMicOn);

  function SvgNotification(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M14.057 19.266c.41.114.645.52.525.908-.336 1.083-1.387 1.826-2.58 1.826s-2.243-.743-2.58-1.826c-.12-.387.115-.794.525-.908a.789.789 0 01.925.403l.036.093c.142.46.588.774 1.094.774.464 0 .877-.265 1.053-.662l.042-.112c.12-.388.55-.61.96-.496zM12 2c.392 0 .716.275.767.632l.007.1v1.263c3.396.383 6.02 3.257 6.02 6.728 0 2.416.217 4.125.57 5.24.137.435.255.678.318.784l.02.033.024.03c.52.419.249 1.204-.397 1.282l-.105.006H4.775c-.597 0-.956-.605-.681-1.079l.059-.087.027-.039c.1-.15.269-.51.452-1.132.356-1.212.573-2.87.573-5.038 0-3.471 2.625-6.345 6.02-6.728V2.732c0-.404.347-.732.775-.732zm0 3.415c-2.887 0-5.246 2.367-5.246 5.308 0 2.295-.235 4.084-.63 5.43l-.07.225-.068.208-.019.049h12l-.086-.253c-.4-1.265-.635-3.11-.635-5.66 0-2.94-2.36-5.307-5.246-5.307z"
    }));
  }

  var ForwardRef$o = /*#__PURE__*/React__namespace.forwardRef(SvgNotification);

  function SvgPhone(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M16.5 10.771a1.69 1.69 0 01-1.688-1.688.563.563 0 00-.562-.562h-4.5a.563.563 0 00-.563.563A1.69 1.69 0 017.5 10.77H4.687A1.69 1.69 0 013 9.083v-.667A3.913 3.913 0 016.14 4.56 31.06 31.06 0 0111.994 4a31.113 31.113 0 015.923.572A3.915 3.915 0 0121 8.415v.668a1.69 1.69 0 01-1.688 1.687H16.5zm-2.25-3.375c.93 0 1.688.757 1.688 1.688 0 .31.251.562.562.562h2.813c.31 0 .562-.252.562-.563v-.667a2.798 2.798 0 00-2.17-2.738l-.027-.005a29.94 29.94 0 00-5.684-.547 29.965 29.965 0 00-5.7.55 2.8 2.8 0 00-2.169 2.74v.667c0 .31.252.562.563.562H7.5c.31 0 .563-.252.563-.562 0-.931.756-1.688 1.687-1.688h4.5v.001zM7.781 14.146a.844.844 0 100-1.688.844.844 0 000 1.688zM12 14.146a.844.844 0 100-1.687.844.844 0 000 1.687zM16.219 14.146a.845.845 0 11.037-1.685h.009a.841.841 0 01.797.841.845.845 0 01-.843.844zM7.781 17.521a.844.844 0 100-1.688.844.844 0 000 1.688zM12 17.521a.844.844 0 100-1.687.844.844 0 000 1.687zM16.219 17.521a.845.845 0 11.037-1.685h.009a.841.841 0 01.797.841.845.845 0 01-.843.844zM7.781 20.896a.844.844 0 100-1.688.844.844 0 000 1.688zM12 20.896a.844.844 0 100-1.687.844.844 0 000 1.687zM16.219 20.896a.842.842 0 110-1.688.845.845 0 010 1.688z"
    }));
  }

  var ForwardRef$n = /*#__PURE__*/React__namespace.forwardRef(SvgPhone);

  function SvgPin(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 13.086c-2.105 0-3.818-1.755-3.818-3.912C8.182 7.016 9.895 5.26 12 5.26s3.818 1.755 3.818 3.913c0 2.157-1.713 3.912-3.818 3.912zm0-6.521c-1.403 0-2.546 1.17-2.546 2.609 0 1.438 1.143 2.608 2.546 2.608 1.403 0 2.545-1.17 2.545-2.608 0-1.439-1.142-2.609-2.545-2.609z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.998 22a1.25 1.25 0 01-.701-.217 1.283 1.283 0 01-.358-.367c-.595-.919-1.909-2.46-3.427-5.151C5.845 12.978 5 10.593 5 9.174 5 5.218 8.14 2 12 2s7 3.218 7 7.174c0 1.418-.845 3.804-2.512 7.09-1.942 3.127-2.832 4.233-3.427 5.152a1.261 1.261 0 01-1.063.584zM12 3.304c-3.158 0-5.727 2.633-5.727 5.87 0 2.504 3.182 8.477 5.727 11.52 2.546-3.043 5.727-9.017 5.727-11.52 0-3.236-2.569-5.87-5.727-5.87z"
    }));
  }

  var ForwardRef$m = /*#__PURE__*/React__namespace.forwardRef(SvgPin);

  function SvgPortraitFrame(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3.563 8.626A.563.563 0 013 8.063V4.687C3 3.757 3.757 3 4.688 3h3.375a.563.563 0 010 1.125H4.687a.563.563 0 00-.562.563v3.375c0 .31-.252.563-.563.563zM20.438 8.626a.563.563 0 01-.563-.563V4.687a.563.563 0 00-.563-.562h-3.375a.563.563 0 010-1.125h3.376C20.242 3 21 3.757 21 4.688v3.375c0 .31-.252.563-.563.563zM4.688 21C3.756 21 3 20.243 3 19.312v-3.375a.563.563 0 011.125 0v3.376c0 .31.252.562.563.562h3.375a.563.563 0 010 1.125H4.687zM15.938 21a.563.563 0 010-1.125h3.374c.311 0 .563-.252.563-.563v-3.375a.563.563 0 011.125 0v3.376c0 .93-.757 1.687-1.688 1.687h-3.375zM12 13.125a3.66 3.66 0 01-3.656-3.656A3.66 3.66 0 0112 5.813a3.66 3.66 0 013.656 3.656A3.66 3.66 0 0112 13.125zm0-6.188A2.534 2.534 0 009.469 9.47 2.534 2.534 0 0012 12a2.534 2.534 0 002.531-2.531A2.534 2.534 0 0012 6.938zM16.752 17.625a.563.563 0 01-.531-.377 4.477 4.477 0 00-5.695-2.748 4.45 4.45 0 00-2.748 2.748.562.562 0 11-1.062-.37 5.568 5.568 0 013.44-3.44 5.569 5.569 0 011.84-.313 5.605 5.605 0 015.288 3.752.559.559 0 01-.346.716.553.553 0 01-.186.032z"
    }));
  }

  var ForwardRef$l = /*#__PURE__*/React__namespace.forwardRef(SvgPortraitFrame);

  function SvgQuestion(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 14.5a.625.625 0 01-.625-.625v-.838c0-.794.502-1.505 1.25-1.769a1.878 1.878 0 001.25-1.767c0-.501-.195-.972-.55-1.326A1.86 1.86 0 0012 7.625c-.5 0-.972.196-1.326.55a1.86 1.86 0 00-.549 1.325.626.626 0 01-1.25 0c0-.835.326-1.62.916-2.21A3.104 3.104 0 0112 6.377 3.129 3.129 0 0115.125 9.5a3.13 3.13 0 01-2.083 2.946.626.626 0 00-.417.589v.839c0 .345-.28.625-.625.625zM12 17.625a.937.937 0 100-1.875.937.937 0 000 1.875z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10zm0-18.75c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S16.825 3.25 12 3.25z"
    }));
  }

  var ForwardRef$k = /*#__PURE__*/React__namespace.forwardRef(SvgQuestion);

  function SvgRadioOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
    }));
  }

  var ForwardRef$j = /*#__PURE__*/React__namespace.forwardRef(SvgRadioOff);

  function SvgRadioOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM12 6a6 6 0 106 6 6.007 6.007 0 00-6-6z"
    }));
  }

  var ForwardRef$i = /*#__PURE__*/React__namespace.forwardRef(SvgRadioOn);

  function SvgRefresh(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M10.376 5.293c-1.238.3-2.37.938-3.27 1.84a6.95 6.95 0 00-1.698 7.008.21.21 0 00.316.111l1.126-.74a.84.84 0 011.285.871l-.768 3.703a.84.84 0 01-.991.655l-3.704-.763a.84.84 0 01-.292-1.526l1.176-.775a.208.208 0 00.08-.252A9.035 9.035 0 0114.763 3.43a1.05 1.05 0 11-.639 2 6.92 6.92 0 00-3.749-.137zm11.393 1.123a.84.84 0 01.218.436.84.84 0 01-.38.859l-1.131.71a.208.208 0 00-.084.253A9.034 9.034 0 019.337 20.667a1.051 1.051 0 11.62-2.007A6.932 6.932 0 0018.6 9.9a.211.211 0 00-.128-.134.208.208 0 00-.184.023l-1.212.761a.84.84 0 01-1.267-.898l.84-3.687a.841.841 0 011.01-.632l3.687.84a.84.84 0 01.423.243z"
    }));
  }

  var ForwardRef$h = /*#__PURE__*/React__namespace.forwardRef(SvgRefresh);

  function SvgRemove(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7 11a1 1 0 100 2h10a1 1 0 100-2H7z"
    }));
  }

  var ForwardRef$g = /*#__PURE__*/React__namespace.forwardRef(SvgRemove);

  function SvgRemoveRound(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM6 12a1 1 0 011-1h10a1 1 0 110 2H7a1 1 0 01-1-1z"
    }));
  }

  var ForwardRef$f = /*#__PURE__*/React__namespace.forwardRef(SvgRemoveRound);

  function SvgSearch(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M20.725 19.375l-4.988-4.988a7.093 7.093 0 10-1.35 1.35l4.988 4.988a.967.967 0 001.35 0 .956.956 0 000-1.35zM4.962 10.116a5.157 5.157 0 115.156 5.157 5.163 5.163 0 01-5.156-5.157z"
    }));
  }

  var ForwardRef$e = /*#__PURE__*/React__namespace.forwardRef(SvgSearch);

  function SvgShare(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M15.13 4.082a4.087 4.087 0 012.843-1.142c1.065 0 2.088.41 2.844 1.142A3.859 3.859 0 0122 6.854a3.859 3.859 0 01-1.183 2.77 4.086 4.086 0 01-2.844 1.143 4.086 4.086 0 01-2.843-1.142 3.934 3.934 0 01-.592-.73L9.98 10.613a3.806 3.806 0 01-.088 1.84l4.854 2.353a3.94 3.94 0 01.384-.43 4.087 4.087 0 012.843-1.143c1.065 0 2.088.41 2.844 1.142A3.859 3.859 0 0122 17.146a3.859 3.859 0 01-1.183 2.772 4.086 4.086 0 01-2.844 1.142 4.087 4.087 0 01-2.843-1.142 3.859 3.859 0 01-1.183-2.771c0-.375.055-.744.161-1.097l-4.855-2.352a3.947 3.947 0 01-.383.43 4.086 4.086 0 01-2.844 1.142 4.086 4.086 0 01-2.843-1.142A3.859 3.859 0 012 11.357c0-1.042.427-2.038 1.183-2.771a4.086 4.086 0 012.843-1.143c1.065 0 2.088.41 2.844 1.143.228.221.427.467.592.73l4.558-1.718a3.808 3.808 0 01-.073-.744c0-1.042.427-2.039 1.183-2.772zm2.843.252a2.66 2.66 0 00-1.85.742 2.476 2.476 0 00-.76 1.778c0 .664.272 1.304.76 1.777a2.66 2.66 0 001.85.742 2.66 2.66 0 001.85-.742c.489-.473.761-1.113.761-1.777 0-.665-.272-1.305-.76-1.778a2.66 2.66 0 00-1.85-.742zM6.026 8.837a2.66 2.66 0 00-1.85.742 2.476 2.476 0 00-.76 1.778c0 .665.272 1.304.76 1.778a2.66 2.66 0 001.85.741 2.66 2.66 0 001.85-.741c.489-.474.761-1.114.761-1.778 0-.665-.272-1.305-.76-1.778a2.66 2.66 0 00-1.85-.742zm10.097 6.532a2.66 2.66 0 011.85-.742 2.66 2.66 0 011.85.742c.489.473.761 1.113.761 1.777 0 .665-.272 1.305-.76 1.778a2.66 2.66 0 01-1.85.742 2.66 2.66 0 01-1.85-.742 2.476 2.476 0 01-.761-1.777c0-.665.272-1.305.76-1.778z"
    }));
  }

  var ForwardRef$d = /*#__PURE__*/React__namespace.forwardRef(SvgShare);

  function SvgSun(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#sun_svg__clip0)",
      clipRule: "evenodd"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.8 12a4.2 4.2 0 118.4 0 4.2 4.2 0 01-8.4 0zM12 9a3 3 0 100 6 3 3 0 000-6zM12 3a.6.6 0 01.6.6V6a.6.6 0 11-1.2 0V3.6A.6.6 0 0112 3zM12 17.4a.6.6 0 01.6.6v2.4a.6.6 0 11-1.2 0V18a.6.6 0 01.6-.6zM17.4 12a.6.6 0 01.6-.6h2.4a.6.6 0 010 1.2H18a.6.6 0 01-.6-.6zM3 12a.6.6 0 01.6-.6H6a.6.6 0 010 1.2H3.6A.6.6 0 013 12zM18.363 5.637a.6.6 0 010 .848l-1.696 1.697a.6.6 0 11-.849-.849l1.697-1.696a.6.6 0 01.848 0zM8.181 15.819a.6.6 0 010 .848l-1.697 1.697a.6.6 0 01-.848-.848l1.696-1.697a.6.6 0 01.849 0zM15.818 15.819a.6.6 0 01.849 0l1.696 1.697a.6.6 0 01-.848.848l-1.697-1.697a.6.6 0 010-.848zM5.636 5.637a.6.6 0 01.848 0l1.697 1.696a.6.6 0 01-.848.849L5.635 6.485a.6.6 0 010-.848z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "sun_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      transform: "translate(0 .024)",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$c = /*#__PURE__*/React__namespace.forwardRef(SvgSun);

  function SvgTelemedicine(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#telemedicine_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M5.25 21C4.01 21 3 19.99 3 18.75V5.25C3 4.01 4.01 3 5.25 3H12c1.24 0 2.25 1.01 2.25 2.25v5.063a.563.563 0 01-1.125 0V5.25c0-.62-.505-1.125-1.125-1.125H5.25c-.62 0-1.125.505-1.125 1.125V16.5h6.188a.563.563 0 010 1.125H4.125v1.125c0 .62.505 1.125 1.125 1.125h6.188a.563.563 0 010 1.125H5.25zm15.188 0a.563.563 0 01-.563-.563v-2.594c0-.828-.593-1.528-1.41-1.664l-1.495-.249a.562.562 0 01-.47-.555v-2.25a.563.563 0 00-1.125 0v3.938a.567.567 0 01-.563.562.564.564 0 01-.25-.06l-.882-.44a.666.666 0 00-.944.434.668.668 0 00.23.681l2.198 1.758a.563.563 0 01-.703.879l-2.196-1.758a1.794 1.794 0 01-.619-1.832 1.787 1.787 0 012.539-1.166l.065.032v-3.028c0-.93.757-1.688 1.688-1.688.93 0 1.687.757 1.687 1.688v1.774l1.024.17A2.803 2.803 0 0121 17.844v2.595c0 .31-.252.562-.563.562zm-13.5-8.438c0 .62.504 1.126 1.125 1.126h1.124c.62 0 1.126-.505 1.126-1.126V12h.562c.62 0 1.125-.505 1.125-1.125V9.75c0-.62-.505-1.125-1.125-1.125h-.563v-.563c0-.62-.504-1.124-1.124-1.124H8.062c-.62 0-1.124.504-1.124 1.125v.562h-.563c-.62 0-1.125.505-1.125 1.125v1.125c0 .62.505 1.125 1.125 1.125h.563v.563zm1.125-1.124a.563.563 0 00-.563-.563H6.375V9.75H7.5c.31 0 .563-.252.563-.563V8.063h1.124v1.124c0 .311.253.563.563.563h1.125v1.125H9.75a.563.563 0 00-.563.563v1.124H8.063v-1.124z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "telemedicine_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$b = /*#__PURE__*/React__namespace.forwardRef(SvgTelemedicine);

  function SvgTerms(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.688 21C3.756 21 3 20.243 3 19.312V4.688C3 3.757 3.757 3 4.688 3h14.625C20.242 3 21 3.757 21 4.688v14.625c0 .93-.757 1.687-1.688 1.687H4.688zm0-16.875a.563.563 0 00-.563.563v14.625c0 .31.252.562.563.562h14.625c.31 0 .562-.252.562-.563V4.688a.563.563 0 00-.563-.562H4.688z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8.625 11.438a.557.557 0 01-.398-.165l-2.25-2.25a.557.557 0 01-.165-.398c0-.15.059-.292.165-.398a.557.557 0 01.398-.165c.15 0 .292.059.397.165l1.792 1.791 2.986-3.98a.566.566 0 01.787-.113.56.56 0 01.112.788l-3.374 4.5a.562.562 0 01-.41.223l-.04.002zM13.688 9.75a.563.563 0 010-1.125h3.374a.563.563 0 010 1.125h-3.375zM8.625 18.188a.557.557 0 01-.398-.165l-2.25-2.25a.564.564 0 01.398-.961c.15 0 .292.058.397.165l1.792 1.791 2.986-3.981a.566.566 0 01.787-.113c.249.186.299.54.113.788l-3.375 4.5a.562.562 0 01-.45.226zM13.688 16.5a.563.563 0 010-1.125h3.374a.563.563 0 010 1.125h-3.375z"
    }));
  }

  var ForwardRef$a = /*#__PURE__*/React__namespace.forwardRef(SvgTerms);

  function SvgTrashBin(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.228 22a2.011 2.011 0 01-1.993-1.835L4.053 6H2.667a.667.667 0 010-1.333H8V4c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v.667h5.333a.667.667 0 010 1.333h-1.386l-1.18 14.166A2.011 2.011 0 0116.772 22H7.228zm-.665-1.945a.67.67 0 00.665.612h9.545a.67.67 0 00.664-.612L18.61 6H5.39l1.172 14.055zm8.104-15.388V4A.667.667 0 0014 3.333h-4A.667.667 0 009.333 4v.667h5.334z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10 17.333a.667.667 0 01-.667-.666V10a.667.667 0 011.334 0v6.667a.667.667 0 01-.667.666zM14 17.333a.667.667 0 01-.667-.666V10a.667.667 0 011.334 0v6.667a.667.667 0 01-.667.666z"
    }));
  }

  var ForwardRef$9 = /*#__PURE__*/React__namespace.forwardRef(SvgTrashBin);

  function SvgTweezer(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("g", {
      clipPath: "url(#tweezer_svg__clip0)"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.15 21c-1.617 0-2.932-1.337-2.932-2.98 0-.774.293-1.507.823-2.068l3.075-3.694-1.425-1.449-3.735 3.039a2.888 2.888 0 01-2.025.829C4.315 14.677 3 13.34 3 11.697c0-1.644 1.315-2.981 2.931-2.981 1.58 0 2.872 1.277 2.93 2.87L19.095 3.26a1.148 1.148 0 01.862-.254c.312.036.59.192.786.441.349.443.34 1.08-.02 1.513l-8.392 10.084c1.531.096 2.748 1.394 2.748 2.975 0 1.643-1.315 2.98-2.93 2.98zm0-4.769c-.97 0-1.76.802-1.76 1.789 0 .986.79 1.788 1.76 1.788s1.758-.802 1.758-1.788c0-.987-.79-1.789-1.758-1.789zM5.93 9.91c-.97 0-1.758.802-1.758 1.788 0 .987.788 1.788 1.758 1.788s1.76-.802 1.76-1.788c0-.985-.79-1.788-1.76-1.788zm7.945 1.436l5.951-7.152-7.215 5.868 1.264 1.284z"
    })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
      id: "tweezer_svg__clip0"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  var ForwardRef$8 = /*#__PURE__*/React__namespace.forwardRef(SvgTweezer);

  function SvgUser(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 12c-2.52 0-4.571-2.019-4.571-4.5S9.479 3 12 3c2.52 0 4.571 2.019 4.571 4.5S14.521 12 12 12zm0-7.875c-1.89 0-3.429 1.514-3.429 3.375 0 1.86 1.539 3.375 3.429 3.375s3.429-1.514 3.429-3.375c0-1.86-1.539-3.375-3.429-3.375zM19.429 21a.567.567 0 01-.572-.563c0-3.722-3.076-6.75-6.857-6.75s-6.857 3.028-6.857 6.75c0 .31-.256.563-.572.563A.567.567 0 014 20.437c0-4.342 3.589-7.875 8-7.875s8 3.533 8 7.875c0 .31-.256.563-.571.563z"
    }));
  }

  var ForwardRef$7 = /*#__PURE__*/React__namespace.forwardRef(SvgUser);

  function SvgVaccines(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M16.774 2.646a.5.5 0 10-.707.708l.945.945-2.323 2.323-.945-.945-.003-.002-1.296-1.296a.5.5 0 10-.707.707l.945.945-7.006 7.005a1.724 1.724 0 000 2.44l.08.08-1.812 1.81a.5.5 0 000 .708l.512.512-1.81 1.81a.5.5 0 10.707.707l1.81-1.81.513.512a.5.5 0 00.707 0l1.811-1.81.08.078v.001c.674.671 1.764.67 2.436-.003l2.125-2.126a.477.477 0 00.079-.078l2.517-2.518a.477.477 0 00.081-.08l2.204-2.204.947.947a.5.5 0 10.707-.707l-1.298-1.298-.003-.003-.942-.943 2.323-2.323.945.945a.5.5 0 10.708-.707l-4.33-4.33zm-4.252 12.2l1.89-1.89-1.376-1.376a.5.5 0 01.708-.707l1.375 1.375 1.89-1.89-3.619-3.62-7.006 7.006a.725.725 0 000 1.025l.426.426.007.007 1.732 1.732.007.007.424.424c.284.282.742.281 1.024-.001l1.81-1.811-1.375-1.376a.5.5 0 11.707-.707l1.376 1.376zm2.874-7.517l1.024 1.025 2.324-2.323-1.025-1.025-2.323 2.323zM5.518 18.232a.458.458 0 01.018.018l.495.495 1.457-1.458-1.024-1.024-1.458 1.457.494.494a.423.423 0 01.018.018z"
    }));
  }

  var ForwardRef$6 = /*#__PURE__*/React__namespace.forwardRef(SvgVaccines);

  function SvgViewOff(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M4.319 19.448a.62.62 0 01-.432-1.076L19.508 3.374a.62.62 0 01.883.018.623.623 0 01-.017.884L4.752 19.276a.627.627 0 01-.433.173zm7.67-1.25l-.092.001a8.838 8.838 0 01-2.614-.402.626.626 0 01.37-1.194c.74.23 1.5.347 2.258.347h.207c3.21 0 6.463-2.32 8.437-4.493a.758.758 0 00-.002-1.016 16.487 16.487 0 00-2.465-2.21.62.62 0 01-.25-.41.627.627 0 01.986-.602c.961.702 1.854 1.504 2.656 2.383.693.769.693 1.926.002 2.693-2.154 2.372-5.745 4.905-9.363 4.905l-.13-.002zm-7.225-2.83a.626.626 0 001.004-.569.622.622 0 00-.236-.415 16.786 16.786 0 01-2.086-1.925.758.758 0 01-.001-1.017c1.974-2.171 5.23-4.492 8.448-4.492h.191c.6 0 1.196.073 1.774.217a.624.624 0 10.303-1.213 8.604 8.604 0 00-2.083-.254l-.198-.001c-3.616 0-7.207 2.532-9.362 4.903a2.007 2.007 0 00.003 2.694 18.011 18.011 0 002.243 2.072zm4.11-2.794a.626.626 0 01-.625-.625c0-1 .39-1.94 1.098-2.65a3.72 3.72 0 012.649-1.1c.172 0 .312.14.312.312l.002.625a.315.315 0 01-.09.222.309.309 0 01-.222.091c-.667 0-1.294.261-1.767.733A2.482 2.482 0 009.5 11.95a.623.623 0 01-.625.625zm2.813 2.812c0 .173.14.312.312.312 1.002 0 1.943-.39 2.652-1.099a3.724 3.724 0 001.097-2.65.625.625 0 00-1.25 0c0 .667-.26 1.295-.731 1.767-.473.473-1.1.733-1.768.733a.31.31 0 00-.221.091.31.31 0 00-.092.221v.625z"
    }));
  }

  var ForwardRef$5 = /*#__PURE__*/React__namespace.forwardRef(SvgViewOff);

  function SvgViewOn(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M2.52 13.595c2.152 2.37 5.737 4.903 9.348 4.903h.244c3.623 0 7.215-2.532 9.37-4.904a2.007 2.007 0 00-.002-2.694C19.326 8.531 15.738 6 12.132 6h-.253C8.26 6 4.67 8.531 2.518 10.902c-.69.767-.69 1.924.002 2.693zm.924-1.855C5.417 9.57 8.668 7.25 11.877 7.25l.11.002.13-.001c3.21 0 6.463 2.319 8.436 4.489.261.29.261.728.001 1.016-1.974 2.172-5.23 4.493-8.453 4.493h-.223c-3.21 0-6.46-2.32-8.432-4.491a.758.758 0 01-.002-1.017zm5.902 3.158c.709.709 1.65 1.1 2.652 1.1 1.002 0 1.943-.39 2.651-1.098a3.726 3.726 0 001.1-2.654c0-1.002-.39-1.942-1.099-2.65a3.728 3.728 0 00-2.651-1.098 3.753 3.753 0 00-3.75 3.749 3.72 3.72 0 001.097 2.651zm.154-2.651a2.502 2.502 0 014.266-1.768 2.48 2.48 0 01.732 1.769c0 .667-.26 1.296-.732 1.767a2.482 2.482 0 01-1.767.732c-.668 0-1.295-.26-1.768-.733a2.484 2.484 0 01-.731-1.767z"
    }));
  }

  var ForwardRef$4 = /*#__PURE__*/React__namespace.forwardRef(SvgViewOn);

  function SvgWarning(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M2 12c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2 2 6.486 2 12zm1.667 0c0-4.594 3.739-8.333 8.333-8.333 4.596 0 8.333 3.739 8.333 8.333S16.594 20.333 12 20.333 3.667 16.594 3.667 12zM12 14c-.552 0-1-.403-1-.9V5.9c0-.497.448-.9 1-.9s1 .403 1 .9v7.2c0 .497-.448.9-1 .9zm0 4a.712.712 0 01-.116-.01 1.001 1.001 0 01-.874-.873.638.638 0 010-.233c.053-.456.418-.82.874-.874a.712.712 0 01.232 0c.456.054.82.418.874.874a.626.626 0 010 .233A1.001 1.001 0 0112 18z"
    }));
  }

  var ForwardRef$3 = /*#__PURE__*/React__namespace.forwardRef(SvgWarning);

  function SvgWhatsapp(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.883 17.58h.359a3.51 3.51 0 001.868-.45 3.534 3.534 0 001.357-1.368 1.773 1.773 0 00.125-1.742 1.276 1.276 0 00-.609-.46l-.116-.06s-1.442-.711-1.742-.837a.996.996 0 00-1.283.36c-.142.21-.292.427-.4.57a6.9 6.9 0 01-2.975-2.513l.191-.176c.147-.123.264-.278.342-.453a1.06 1.06 0 000-.996c-.05-.1-.25-.603-.45-1.072l-.292-.704a1.382 1.382 0 00-1.075-.838 1.808 1.808 0 00-1.666.486 4.326 4.326 0 00-.833 4.75 9.365 9.365 0 002.891 3.687 9.3 9.3 0 004.308 1.816zM8.45 8.24a.565.565 0 01.375-.117.531.531 0 01.267.059l.291.703c.175.427.359.838.45 1.072l-.333.327a.956.956 0 00-.208 1.265A8.147 8.147 0 0013 14.799a.98.98 0 001.275-.21c.15-.175.375-.486.508-.687.275.118 1.05.495 1.534.738l.133.067h.075a1 1 0 01-.142.418 2.332 2.332 0 01-2.408 1.19 8.038 8.038 0 01-3.63-1.552 8.093 8.093 0 01-2.462-3.097A3.055 3.055 0 018.45 8.24z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.642 20.805a.631.631 0 00.427.855.622.622 0 00.356-.018l3.325-1.139a9.962 9.962 0 0010.079.248 10.023 10.023 0 003.756-3.647A10.09 10.09 0 0022 12.051c0-2.665-1.053-5.222-2.929-7.107A9.974 9.974 0 0012 2a9.974 9.974 0 00-7.071 2.944A10.078 10.078 0 002 12.051a9.878 9.878 0 001.717 5.587l-1.075 3.167zm.6-8.754a8.828 8.828 0 011.437-4.905 8.76 8.76 0 013.91-3.273 8.708 8.708 0 015.06-.533 8.736 8.736 0 014.5 2.387 8.808 8.808 0 012.418 4.5 8.836 8.836 0 01-.482 5.091 8.786 8.786 0 01-3.218 3.961A8.718 8.718 0 0112 20.771a8.718 8.718 0 01-4.817-1.44.622.622 0 00-.533-.076l-2.425.77L5 17.74a.631.631 0 00-.092-.586 8.632 8.632 0 01-1.666-5.102z"
    }));
  }

  var ForwardRef$2 = /*#__PURE__*/React__namespace.forwardRef(SvgWhatsapp);

  function SvgWifi(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 21.482a3.129 3.129 0 01-3.125-3.125A3.129 3.129 0 0112 15.232a3.129 3.129 0 013.125 3.125A3.129 3.129 0 0112 21.482zm0-5c-1.034 0-1.875.84-1.875 1.875 0 1.034.84 1.875 1.875 1.875 1.034 0 1.875-.84 1.875-1.875 0-1.034-.84-1.875-1.875-1.875zM16.417 14.563a.62.62 0 01-.442-.184 5.588 5.588 0 00-3.978-1.644 5.59 5.59 0 00-3.977 1.644.62.62 0 01-.884 0 .62.62 0 010-.883 6.827 6.827 0 014.861-2.01c1.839 0 3.566.714 4.862 2.01a.62.62 0 010 .883.624.624 0 01-.442.184z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.071 11.91a.619.619 0 01-.441-.183A9.317 9.317 0 0012 8.987a9.315 9.315 0 00-6.63 2.741.62.62 0 01-.883 0 .62.62 0 010-.883A10.55 10.55 0 0112 7.737c2.841 0 5.51 1.103 7.513 3.107a.619.619 0 01.183.442.62.62 0 01-.183.441.619.619 0 01-.442.184z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M2.625 8.925a.626.626 0 01-.427-1.083A14.327 14.327 0 0112.001 4c3.663 0 7.143 1.365 9.801 3.843a.627.627 0 01-.425 1.082.625.625 0 01-.426-.167A13.074 13.074 0 0012 5.249a13.077 13.077 0 00-8.95 3.508.622.622 0 01-.426.168z"
    }));
  }

  var ForwardRef$1 = /*#__PURE__*/React__namespace.forwardRef(SvgWifi);

  function SvgXRay(props, svgRef) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef
    }, props), /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      d: "M3 19.688C3 20.41 3.589 21 4.313 21h15.375C20.41 21 21 20.411 21 19.687V4.313C21 3.59 20.411 3 19.687 3H4.313C3.59 3 3 3.589 3 4.313v15.375zM4.125 4.313c0-.104.084-.188.188-.188h15.375c.103 0 .187.084.187.188v15.375a.188.188 0 01-.188.187H4.313a.188.188 0 01-.187-.188V4.313zm7.313 12.75a.563.563 0 001.124 0v-1.675c1.73.072 2.64.458 2.818.62a.563.563 0 001.12-.07c0-1.127-1.985-1.601-3.938-1.676v-2.253c3.002.086 4.455.836 4.5 1.117a.563.563 0 001.125 0c0-1.265-2.248-2.156-5.625-2.243V8.636c2.708.098 3.938.879 3.938 1.114a.563.563 0 001.125 0c0-1.04-1.568-2.12-5.063-2.24v-.572a.563.563 0 00-1.124 0v.573C7.942 7.63 6.375 8.71 6.375 9.75a.563.563 0 001.125 0c0-.236 1.23-1.016 3.938-1.114v2.247c-3.377.087-5.626.977-5.626 2.242a.563.563 0 001.125.002c.046-.283 1.499-1.033 4.5-1.119v2.253c-1.952.076-3.937.55-3.937 1.677a.563.563 0 001.12.07c.178-.162 1.087-.549 2.818-.62v1.675z"
    }));
  }

  var ForwardRef = /*#__PURE__*/React__namespace.forwardRef(SvgXRay);

  exports.AddBold = ForwardRef$3M;
  exports.AddOutline = ForwardRef$1m;
  exports.AddOutlineDasa = ForwardRef$2p;
  exports.AgconsultaBold = ForwardRef$3L;
  exports.AgconsultaOutline = ForwardRef$1l;
  exports.AgexamsBold = ForwardRef$3K;
  exports.AgexamsOutline = ForwardRef$1k;
  exports.AgexamsOutlineDasa = ForwardRef$2o;
  exports.AppBold = ForwardRef$3J;
  exports.AppOutline = ForwardRef$1j;
  exports.ArrowcornerrightBold = ForwardRef$3I;
  exports.ArrowcornerrightOutline = ForwardRef$1i;
  exports.ArrowdownBold = ForwardRef$3H;
  exports.ArrowdownOutline = ForwardRef$1h;
  exports.ArrowleftBold = ForwardRef$3G;
  exports.ArrowleftOutline = ForwardRef$1g;
  exports.ArrowleftOutlineDasa = ForwardRef$2n;
  exports.ArrowrightBold = ForwardRef$3F;
  exports.ArrowrightOutline = ForwardRef$1f;
  exports.ArrowupBold = ForwardRef$3E;
  exports.ArrowupOutline = ForwardRef$1e;
  exports.AvatarBold = ForwardRef$3D;
  exports.AvatarOutline = ForwardRef$1d;
  exports.BrowserBold = ForwardRef$3C;
  exports.BrowserOutline = ForwardRef$1c;
  exports.CakeBold = ForwardRef$3B;
  exports.CakeOutline = ForwardRef$1b;
  exports.CakeOutlineDasa = ForwardRef$2m;
  exports.CalendarBold = ForwardRef$3A;
  exports.CalendarOutline = ForwardRef$1a;
  exports.CalendarOutlineDasa = ForwardRef$2l;
  exports.CallBold = ForwardRef$3z;
  exports.CallOutline = ForwardRef$19;
  exports.CallOutlineDasa = ForwardRef$2k;
  exports.CameraBold = ForwardRef$3y;
  exports.CameraOutline = ForwardRef$18;
  exports.CameraOutlineDasa = ForwardRef$2j;
  exports.CameraoffBold = ForwardRef$3x;
  exports.CameraoffOutline = ForwardRef$17;
  exports.CameraonBold = ForwardRef$3w;
  exports.CameraonOutline = ForwardRef$16;
  exports.CameraonOutlineDasa = ForwardRef$2i;
  exports.CameraswitchBold = ForwardRef$3v;
  exports.CameraswitchOutline = ForwardRef$15;
  exports.CarBold = ForwardRef$3u;
  exports.CarOutline = ForwardRef$14;
  exports.CarOutlineDasa = ForwardRef$2h;
  exports.CheckBold = ForwardRef$3t;
  exports.CheckOutline = ForwardRef$13;
  exports.CheckboxemptyBold = ForwardRef$3r;
  exports.CheckboxemptyOutline = ForwardRef$11;
  exports.CheckboxindeterminateBold = ForwardRef$3q;
  exports.CheckboxindeterminateOutline = ForwardRef$10;
  exports.CheckboxselectedBold = ForwardRef$3p;
  exports.CheckboxselectedOutline = ForwardRef$$;
  exports.CheckroundBold = ForwardRef$3s;
  exports.CheckroundOutline = ForwardRef$12;
  exports.CheckroundOutlineDasa = ForwardRef$2g;
  exports.ChevrondownBold = ForwardRef$3o;
  exports.ChevrondownOutline = ForwardRef$_;
  exports.ChevrondownOutlineDasa = ForwardRef$2f;
  exports.ChevrondownsmBold = ForwardRef$3n;
  exports.ChevrondownsmOutline = ForwardRef$Z;
  exports.ChevronleftBold = ForwardRef$3m;
  exports.ChevronleftOutline = ForwardRef$Y;
  exports.ChevronleftOutlineDasa = ForwardRef$2e;
  exports.ChevronleftsmBold = ForwardRef$3l;
  exports.ChevronleftsmOutline = ForwardRef$X;
  exports.ChevronrightBold = ForwardRef$3k;
  exports.ChevronrightOutline = ForwardRef$W;
  exports.ChevronrightOutlineDasa = ForwardRef$2d;
  exports.ChevronrightsmBold = ForwardRef$3j;
  exports.ChevronrightsmOutline = ForwardRef$V;
  exports.ChevronupBold = ForwardRef$3i;
  exports.ChevronupOutline = ForwardRef$U;
  exports.ChevronupOutlineDasa = ForwardRef$2c;
  exports.ChevronupsmBold = ForwardRef$3h;
  exports.ChevronupsmOutline = ForwardRef$T;
  exports.ClinicOutlineDasa = ForwardRef$2b;
  exports.ClockBold = ForwardRef$3g;
  exports.ClockOutline = ForwardRef$S;
  exports.ClockOutlineDasa = ForwardRef$2a;
  exports.CloseBold = ForwardRef$3f;
  exports.CloseOutline = ForwardRef$R;
  exports.CloseOutlineDasa = ForwardRef$29;
  exports.CloseroundBold = ForwardRef$3e;
  exports.CloseroundOutline = ForwardRef$Q;
  exports.CompanionOutlineDasa = ForwardRef$28;
  exports.CrossOutlineDasa = ForwardRef$27;
  exports.DashBold = ForwardRef$3d;
  exports.DashOutline = ForwardRef$P;
  exports.DoctorBold = ForwardRef$3c;
  exports.DoctorOutline = ForwardRef$O;
  exports.DoctorOutlineDasa = ForwardRef$26;
  exports.DownloadOutlineDasa = ForwardRef$25;
  exports.EditBold = ForwardRef$3b;
  exports.EditOutline = ForwardRef$N;
  exports.EditOutlineDasa = ForwardRef$24;
  exports.EvolutionBold = ForwardRef$3a;
  exports.EvolutionOutline = ForwardRef$M;
  exports.ExamsBold = ForwardRef$39;
  exports.ExamsOutline = ForwardRef$L;
  exports.ExamsOutlineDasa = ForwardRef$23;
  exports.ExitBold = ForwardRef$38;
  exports.ExitOutline = ForwardRef$K;
  exports.ExitOutlineDasa = ForwardRef$22;
  exports.FamilyBold = ForwardRef$37;
  exports.FamilyOutline = ForwardRef$J;
  exports.FilterOutlineDasa = ForwardRef$21;
  exports.FoldBold = ForwardRef$36;
  exports.FoldOutline = ForwardRef$I;
  exports.FoldOutlineDasa = ForwardRef$20;
  exports.GenderfemaleBold = ForwardRef$35;
  exports.GenderfemaleOutline = ForwardRef$H;
  exports.GenderfemaleOutlineDasa = ForwardRef$1$;
  exports.GendermaleBold = ForwardRef$34;
  exports.GendermaleOutline = ForwardRef$G;
  exports.GendermaleOutlineDasa = ForwardRef$1_;
  exports.GlassesBold = ForwardRef$33;
  exports.GlassesOutline = ForwardRef$F;
  exports.GlassesOutlineDasa = ForwardRef$1Z;
  exports.HamburguerOutlineDasa = ForwardRef$1Y;
  exports.HandshakeBold = ForwardRef$32;
  exports.HandshakeOutline = ForwardRef$E;
  exports.HandshakeOutlineDasa = ForwardRef$1X;
  exports.HealthinsuranceBold = ForwardRef$31;
  exports.HealthinsuranceOutline = ForwardRef$D;
  exports.HeartbeatBold = ForwardRef$30;
  exports.HeartbeatOutline = ForwardRef$C;
  exports.HeartbeatOutlineDasa = ForwardRef$1W;
  exports.HomeBold = ForwardRef$2$;
  exports.HomeOutline = ForwardRef$B;
  exports.HomeOutlineDasa = ForwardRef$1V;
  exports.HomecollectionOutlineDasa = ForwardRef$1U;
  exports.HospitalBold = ForwardRef$2_;
  exports.HospitalOutline = ForwardRef$A;
  exports.IdBold = ForwardRef$2Z;
  exports.IdOutline = ForwardRef$z;
  exports.IdOutlineDasa = ForwardRef$1T;
  exports.InforoundBold = ForwardRef$2Y;
  exports.InforoundOutline = ForwardRef$y;
  exports.LabBold = ForwardRef$2X;
  exports.LabOutline = ForwardRef$x;
  exports.LabOutlineDasa = ForwardRef$1S;
  exports.LinkBold = ForwardRef$2W;
  exports.LinkOutline = ForwardRef$w;
  exports.LinkOutlineDasa = ForwardRef$1R;
  exports.LoadingBold = ForwardRef$2V;
  exports.LoadingOutline = ForwardRef$v;
  exports.LoadingOutlineDasa = ForwardRef$1Q;
  exports.LockBold = ForwardRef$2U;
  exports.LockOutline = ForwardRef$u;
  exports.LockOutlineDasa = ForwardRef$1P;
  exports.MailBold = ForwardRef$2T;
  exports.MailOutline = ForwardRef$t;
  exports.MailOutlineDasa = ForwardRef$1O;
  exports.MedicalcalendarOutlineDasa = ForwardRef$1N;
  exports.MenuBold = ForwardRef$2S;
  exports.MenuOutline = ForwardRef$s;
  exports.MenuOutlineDasa = ForwardRef$1M;
  exports.MessageBold = ForwardRef$2R;
  exports.MessageOutline = ForwardRef$r;
  exports.MessageOutlineDasa = ForwardRef$1L;
  exports.MicoffBold = ForwardRef$2Q;
  exports.MicoffOutline = ForwardRef$q;
  exports.MicoffOutlineDasa = ForwardRef$1K;
  exports.MiconBold = ForwardRef$2P;
  exports.MiconOutline = ForwardRef$p;
  exports.MiconOutlineDasa = ForwardRef$1J;
  exports.NotificationBold = ForwardRef$2O;
  exports.NotificationOutline = ForwardRef$o;
  exports.NotificationOutlineDasa = ForwardRef$1I;
  exports.PdfOutlineDasa = ForwardRef$1H;
  exports.PhoneBold = ForwardRef$2N;
  exports.PhoneOutline = ForwardRef$n;
  exports.PinBold = ForwardRef$2M;
  exports.PinOutline = ForwardRef$m;
  exports.PinOutlineDasa = ForwardRef$1G;
  exports.PortraitframeBold = ForwardRef$2L;
  exports.PortraitframeOutline = ForwardRef$l;
  exports.PortraitframeOutlineDasa = ForwardRef$1F;
  exports.PrintOutlineDasa = ForwardRef$1E;
  exports.QuestionBold = ForwardRef$2K;
  exports.QuestionOutline = ForwardRef$k;
  exports.QuestionOutlineDasa = ForwardRef$1D;
  exports.RadiooffBold = ForwardRef$2J;
  exports.RadiooffOutline = ForwardRef$j;
  exports.RadioonBold = ForwardRef$2I;
  exports.RadioonOutline = ForwardRef$i;
  exports.RefreshBold = ForwardRef$2H;
  exports.RefreshOutline = ForwardRef$h;
  exports.RemoveBold = ForwardRef$2G;
  exports.RemoveOutline = ForwardRef$g;
  exports.RemoveroundBold = ForwardRef$2F;
  exports.RemoveroundOutline = ForwardRef$f;
  exports.SearchBold = ForwardRef$2E;
  exports.SearchOutline = ForwardRef$e;
  exports.SearchOutlineDasa = ForwardRef$1C;
  exports.SecurityOutlineDasa = ForwardRef$1B;
  exports.SettingsOutlineDasa = ForwardRef$1A;
  exports.ShareBold = ForwardRef$2D;
  exports.ShareOutline = ForwardRef$d;
  exports.ShareOutlineDasa = ForwardRef$1z;
  exports.StethoscopeOutlineDasa = ForwardRef$1y;
  exports.SunBold = ForwardRef$2C;
  exports.SunOutline = ForwardRef$c;
  exports.SunOutlineDasa = ForwardRef$1x;
  exports.SwapOutlineDasa = ForwardRef$1w;
  exports.TelemedicineBold = ForwardRef$2B;
  exports.TelemedicineOutline = ForwardRef$b;
  exports.TermsBold = ForwardRef$2A;
  exports.TermsOutline = ForwardRef$a;
  exports.TermsOutlineDasa = ForwardRef$1v;
  exports.TrashbinBold = ForwardRef$2z;
  exports.TrashbinOutline = ForwardRef$9;
  exports.TrashbinOutlineDasa = ForwardRef$1u;
  exports.TweezerBold = ForwardRef$2y;
  exports.TweezerOutline = ForwardRef$8;
  exports.UserBold = ForwardRef$2x;
  exports.UserOutline = ForwardRef$7;
  exports.UserOutlineDasa = ForwardRef$1t;
  exports.VaccinesBold = ForwardRef$2w;
  exports.VaccinesOutline = ForwardRef$6;
  exports.VaccinesOutlineDasa = ForwardRef$1s;
  exports.ViewoffBold = ForwardRef$2v;
  exports.ViewoffOutline = ForwardRef$5;
  exports.ViewoffOutlineDasa = ForwardRef$1r;
  exports.ViewonBold = ForwardRef$2u;
  exports.ViewonOutline = ForwardRef$4;
  exports.ViewonOutlineDasa = ForwardRef$1q;
  exports.WarningBold = ForwardRef$2t;
  exports.WarningOutline = ForwardRef$3;
  exports.WarningOutlineDasa = ForwardRef$1p;
  exports.WhatsappBold = ForwardRef$2s;
  exports.WhatsappOutline = ForwardRef$2;
  exports.WhatsappOutlineDasa = ForwardRef$1o;
  exports.WifiBold = ForwardRef$2r;
  exports.WifiOutline = ForwardRef$1;
  exports.XrayBold = ForwardRef$2q;
  exports.XrayOutline = ForwardRef;
  exports.XrayOutlineDasa = ForwardRef$1n;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
